// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import { client } from '../client.gen';
import { addCartItem, applyHomeDonationEvent, approvePayment, authGeolocation, authReverseGeocoding, bannerList, beforeCompleteDonation, bestContents, bestContentsFeedback, bestContentsList, bestContentsWishlist, blockWelloMemberByCommunity, cancelOrder, cancelOrder1, cancelOrderProduct, cancelOrderProducts, cancelProduct, cancelReturn, certificationCheck, changeMemberPassword, checkDlpGyeonggiAccount, checkDlpGyeonggiAccountId, checkDlpGyeonggiAccountIdentification, checkDonationAvailable, checkMember, checkout, checkPlusFail, checkPlusSendResult, checkVoted, checkWelloPolicyApply, completeDonation, confirmHouseholdInfoAgreement, confirmOrderProduct, confirmPurchase, createAccount, createBeforeOrder, createDeliveryAddress, createDonationReservation, createMember, createPollVote, decreaseOptionQuantity, decryptMemberVerification, deleteCartItem, deleteCartItems, deleteCartItems1, deleteDeliveryAddress, deleteDonationBusinessComment, deleteHomeInquiry, deleteInquiry, deleteMemberSocialAccounts, deleteMemberWelloBlock, deleteMyReview, deleteTourReview, deleteWelloComment, deleteWelloLike, deleteWelloMemberFamily, deleteWishlist, dislike, downloadAllCoupons, downloadCoupon, drawEventPreselection, dummyComplete, exchangeOrderProducts, exchangeProduct, existsDownloadableCoupon, feedbackCommunityWelloNews, feedbackPointMarketProduct, fileCopy, fileDecryptionDownload, fileDelete, fileRename, fileReUpload, fileUpload, fileUpload1, findAllByMemberOAuthId, findAllOrders, findAllTerms, findApplicableCoupons, findApplicableCouponsForProducts, findArticleFeedback, findAvailableCoupons, findCartItems, findCouponAvailable, findDownloadableCoupons, findMyCoupons, findMyReview, findMyReviews, findOrder, findOrderByNumber, findPaymentConfig, findSimplePayMethods, findTerms, findTourFeedback, findTourReview, findUnifiedOrders, getActionCount, getAvailablePointProductList, getBeforeOrder, getBenefitNotificationApplicationResultsUrl, getBenefitNotificationFitAnalysis, getBenefitNotificationFitAnalysisResult, getBenefitNotificationMainInfo, getBenefitNotificationPrivacyUsageUrl, getBenefitNotificationPrivatePolicyUrl, getBenefitNotificationPublicServiceDetailUrl, getBenefitNotificationServiceUsageAgreementManagementUrl, getBenefitNotificationServiceUsageAgreementUrl, getBenefitNotificationSituationManagementUrl, getBenefitNotificationTermServiceUrl, getCommunityWelloNews, getCommunityWelloNewsList, getCommunityWelloNewsWishlist, getDecemberRandomTicketCount, getDeliveryAddress, getDeliveryAddressList, getDeliveryTracking, getDeliveryTracking1, getDeliveryTracking2, getDetailPointBalance, getDetailTermsOfPrivacy, getDetailTermsOfService, getDlpSeoulAccountAndRequestLogin, getDlpSeoulAppliedPolicyList, getDlpSeoulCltrPassCheck, getDlpSeoulCulturePassApply, getDlpSeoulIsltYoungSprtApply, getDlpSeoulIsltYoungSprtCheck, getDlpSeoulLoanCrdtRcvrApply, getDlpSeoulLoanCrdtRcvrCheck, getDlpSeoulMemberInfo, getDonationBusinessCommentList, getEmergencyRoom, getEmergencyRoomList, getEmergencyRoomWishlist, getEventHistoryList, getEventLocalTour, getFeedList, getGiftOrderHistory, getGiftOrderHistoryList, getGiftOrderProductReview, getGiftOrderProductReviewList, getHomeDonationHistory, getHomeDonationHistoryList, getHomeInquiry, getHomeInquiryList, getHomeInquiryMyList, getHomeInstitutionCertificate, getHomeInstitutionEventList, getHomeInstitutionPolicyList, getHomeLoveMainInstitutionEventList, getHomeNoticeList, getInquiry, getInterestPolicyList, getInvitedMemberCount, getInviteeEventReceived, getInviteeGiftBoxReceived, getLatestCommunityList, getLatestCompleted, getLatestCompletedCi, getLatestHomeInstitutionCertificate, getListChildcareRelatedPolicy, getListLikeContents, getListLikeContentsType, getListPointAttendance, getListPointHistory, getLiveWelloCommentList, getLocalfestaParticipantInfo, getLocationServiceConsent, getMember, getMemberAccount, getMemberDetailInfo, getMemberTermAgreementByAgreementType, getMemberVerificationId, getMetaPolicyCommentList, getMyCommunityList, getMyCommunityTypeList, getMyDonationInfo, getMyGiftOrderProductReviewList, getMyInviteEventGiftBoxSummary, getMyInviteEventHistorySummary, getMyWelloCommentList, getNewBestContentsList, getOpenedEventGiftBoxList, getOrderedHomeInstitutionEventList, getOrderItemsForAction, getParticipantDonationEventList, getPointBudget, getPointMarketOrderList, getPointMarketOrderPreview, getPoll, getPollResult, getPopularBestContentsList, getPopularHometownNewsList, getPopularHometownNewsListForCommunity, getPrimaryDeliveryAddress, getPrivateDataConsent, getProductOptionsById, getProductRefundInfo, getReceipt, getRefundEstimate, getRefundInfo, getRelatedMetaPolicyList, getReviewForm, getSituationPolicyList, getTourFestivalWishlist, getTransactionStatement, getUnopenedEventGiftBoxCount, getUnopenedGiftBoxIndicators, getWebWelloAppPushList, getWelloApplyPolicyList, getWelloCommentList, getWelloMemberBlockList, getWelloMemberFamily, getWelloPolicyApplyCount, getWelloPolicyApplyList, hometownNews, hometownNewsFeedback, hometownNewsList, hometownNewsWishlist, increaseOptionQuantity, inquiryList, interestFilter, isEventInProgress, kbMemberCheck, latestCompleteDonation, loginDlpGyeonggiAccount, logoutMember, member, memberAccountList, memberCardList, memberContentCount, memberInterestPolicyList, memberNeighborPolicyList, memberPeerGroupPolicyList, memberPolicyList, memberRecentPolicyList, memberRecommendPolicyByRecentList, memberSocialAccounts, messageReceive, metaPolicy, metaPolicyFeedback, metaPolicyList, metaPolicyWishlist, noticeList, openAllEventGiftBox, openRandomTicket, type Options, paymentHisList, payPointMarketOrder, preselectionStatus, processDonation, processDonationCart, putFitFilter, recommendPolicyList, reissueCoupon, rejectMessage, removeGiftOrderProductReview, removeWishlist, reportCommunity, requestDlpSeoulIdCheck, requestDlpSeoulVerification, requestDlpSeoulVerificationCheck, requestDlpSeoulVerificationCheckForPassword, requestDlpSeoulVerificationForPassword, requestLogin, requestReturn, requiredFilter, resignMember, returnOrderProducts, returnProduct, saveBenefitNotificationApplicationInfo, saveCartItem, saveDlpGyeonggiAccount, saveDonationBusinessComment, saveFitFilter, saveGiftOrderProductReview, saveHomeInquiry, saveHomeInquiry1, saveInquiry, saveInquiry1, saveInterestFilter, saveKbFilter, saveLocalfestaParticipant, saveMemberAccount, saveMemberCard, saveMemberNickName, saveOrUpdateMemberTermAgreement, saveReport, saveReview, saveTodayAttendance, saveTourReview, saveWelloComment, saveWelloCommentReport, saveWelloDeviceInfo, saveWelloHelper, saveWelloLike, saveWelloMemberFamily, saveWelloParticipation, saveWelloTracking, saveWishlist, saveWishlist1, sendCertificationCellphone, sendNiceSafeKey, sendPinkey, situationList, totalPaymentHisList, updateAllDeliveryAddress, updateDeliveryAddress, updateDonationBusinessComment, updateFileTempSaveYn, updateGiftOrderAddress, updateGiftOrderProductReview, updateGiftOrderStatus, updateIssueAt, updateLocalfestaParticipantEntry, updateLocationServiceConsent, updateMemberNickName, updateMemberVerification, updateMyReview, updateOption, updateOptionItemList, updatePrivateDataConsent, updateQuantity, updateTourReview, updateVendorDeliveryAddress, updateWelloAppPushRead, updateWelloComment, updateWelloMemberFamily, uploadCardImage, userProperty, verifyDlpGyeonggiAccountIdentification, welloPickList, welloPickPolicyList } from '../sdk.gen';
import type { AddCartItemData, AddCartItemError, AddCartItemResponse, ApplyHomeDonationEventData, ApplyHomeDonationEventError, ApplyHomeDonationEventResponse2, ApprovePaymentData, ApprovePaymentError, ApprovePaymentResponse2, AuthGeolocationData, AuthGeolocationError, AuthGeolocationResponse, AuthReverseGeocodingData, AuthReverseGeocodingError, AuthReverseGeocodingResponse, BannerListData, BannerListError, BannerListResponse, BeforeCompleteDonationData, BeforeCompleteDonationError, BeforeCompleteDonationResponse, BestContentsData, BestContentsError, BestContentsFeedbackData, BestContentsFeedbackError, BestContentsFeedbackResponse, BestContentsListData, BestContentsListError, BestContentsListResponse, BestContentsResponse, BestContentsWishlistData, BestContentsWishlistError, BestContentsWishlistResponse2, BlockWelloMemberByCommunityData, BlockWelloMemberByCommunityError, BlockWelloMemberByCommunityResponse, CancelOrder1Data, CancelOrder1Error, CancelOrder1Response, CancelOrderData, CancelOrderError, CancelOrderProductData, CancelOrderProductError, CancelOrderProductResponse, CancelOrderProductsData, CancelOrderProductsError, CancelOrderProductsResponse, CancelOrderResponse, CancelProductData, CancelProductError, CancelProductResponse, CancelReturnData, CancelReturnError, CancelReturnResponse, CertificationCheckData, CertificationCheckError, CertificationCheckResponse, ChangeMemberPasswordData, ChangeMemberPasswordError, ChangeMemberPasswordResponse, CheckDlpGyeonggiAccountData, CheckDlpGyeonggiAccountError, CheckDlpGyeonggiAccountIdData, CheckDlpGyeonggiAccountIdentificationData, CheckDlpGyeonggiAccountIdentificationError, CheckDlpGyeonggiAccountIdentificationResponse, CheckDlpGyeonggiAccountIdError, CheckDlpGyeonggiAccountIdResponse2, CheckDlpGyeonggiAccountResponse2, CheckDonationAvailableData, CheckDonationAvailableError, CheckDonationAvailableResponse, CheckMemberData, CheckMemberError, CheckMemberResponse, CheckoutData, CheckoutError, CheckoutResponse, CheckPlusFailData, CheckPlusFailError, CheckPlusFailResponse, CheckPlusSendResultData, CheckPlusSendResultError, CheckPlusSendResultResponse, CheckVotedData, CheckVotedError, CheckVotedResponse, CheckWelloPolicyApplyData, CheckWelloPolicyApplyError, CheckWelloPolicyApplyResponse2, CompleteDonationData, CompleteDonationError, CompleteDonationResponse2, ConfirmHouseholdInfoAgreementData, ConfirmHouseholdInfoAgreementError, ConfirmHouseholdInfoAgreementResponse2, ConfirmOrderProductData, ConfirmOrderProductError, ConfirmOrderProductResponse, ConfirmPurchaseData, ConfirmPurchaseError, ConfirmPurchaseResponse, CreateAccountData, CreateAccountError, CreateAccountResponse, CreateBeforeOrderData, CreateBeforeOrderError, CreateBeforeOrderResponse2, CreateDeliveryAddressData, CreateDeliveryAddressError, CreateDeliveryAddressResponse2, CreateDonationReservationData, CreateDonationReservationError, CreateDonationReservationResponse, CreateMemberData, CreateMemberError, CreateMemberResponse, CreatePollVoteData, CreatePollVoteError, CreatePollVoteResponse, DecreaseOptionQuantityData, DecreaseOptionQuantityError, DecreaseOptionQuantityResponse, DecryptMemberVerificationData, DecryptMemberVerificationError, DecryptMemberVerificationResponse2, DeleteCartItemData, DeleteCartItemError, DeleteCartItemResponse, DeleteCartItems1Data, DeleteCartItems1Error, DeleteCartItems1Response, DeleteCartItemsData, DeleteCartItemsError, DeleteCartItemsResponse, DeleteDeliveryAddressData, DeleteDeliveryAddressError, DeleteDeliveryAddressResponse, DeleteDonationBusinessCommentData, DeleteDonationBusinessCommentError, DeleteDonationBusinessCommentResponse2, DeleteHomeInquiryData, DeleteHomeInquiryError, DeleteHomeInquiryResponse, DeleteInquiryData, DeleteInquiryError, DeleteInquiryResponse, DeleteMemberSocialAccountsData, DeleteMemberSocialAccountsError, DeleteMemberSocialAccountsResponse, DeleteMemberWelloBlockData, DeleteMemberWelloBlockError, DeleteMemberWelloBlockResponse, DeleteMyReviewData, DeleteMyReviewError, DeleteMyReviewResponse, DeleteTourReviewData, DeleteTourReviewError, DeleteTourReviewResponse, DeleteWelloCommentData, DeleteWelloCommentError, DeleteWelloCommentResponse, DeleteWelloLikeData, DeleteWelloLikeError, DeleteWelloLikeResponse, DeleteWelloMemberFamilyData, DeleteWelloMemberFamilyError, DeleteWelloMemberFamilyResponse, DeleteWishlistData, DeleteWishlistError, DeleteWishlistResponse, DislikeData, DislikeError, DislikeResponse, DownloadAllCouponsData, DownloadAllCouponsError, DownloadAllCouponsResponse2, DownloadCouponData, DownloadCouponError, DownloadCouponResponse2, DrawEventPreselectionData, DrawEventPreselectionError, DrawEventPreselectionResponse, DummyCompleteData, DummyCompleteError, DummyCompleteResponse, ExchangeOrderProductsData, ExchangeOrderProductsError, ExchangeOrderProductsResponse, ExchangeProductData, ExchangeProductError, ExchangeProductResponse, ExistsDownloadableCouponData, ExistsDownloadableCouponError, ExistsDownloadableCouponResponse, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, FeedbackPointMarketProductData, FeedbackPointMarketProductError, FeedbackPointMarketProductResponse, FileCopyData, FileCopyError, FileCopyResponse, FileDecryptionDownloadData, FileDecryptionDownloadError, FileDecryptionDownloadResponse, FileDeleteData, FileDeleteError, FileDeleteResponse, FileRenameData, FileRenameError, FileRenameResponse, FileReUploadData, FileReUploadError, FileReUploadResponse, FileUpload1Data, FileUpload1Error, FileUpload1Response, FileUploadData, FileUploadError, FileUploadResponse, FindAllByMemberOAuthIdData, FindAllByMemberOAuthIdError, FindAllByMemberOAuthIdResponse, FindAllOrdersData, FindAllOrdersError, FindAllOrdersResponse, FindAllTermsData, FindAllTermsError, FindAllTermsResponse, FindApplicableCouponsData, FindApplicableCouponsError, FindApplicableCouponsForProductsData, FindApplicableCouponsForProductsError, FindApplicableCouponsForProductsResponse2, FindApplicableCouponsResponse, FindArticleFeedbackData, FindArticleFeedbackError, FindArticleFeedbackResponse, FindAvailableCouponsData, FindAvailableCouponsError, FindAvailableCouponsResponse, FindCartItemsData, FindCartItemsError, FindCartItemsResponse, FindCouponAvailableData, FindCouponAvailableError, FindCouponAvailableResponse, FindDownloadableCouponsData, FindDownloadableCouponsError, FindDownloadableCouponsResponse, FindMyCouponsData, FindMyCouponsError, FindMyCouponsResponse, FindMyReviewData, FindMyReviewError, FindMyReviewResponse, FindMyReviewsData, FindMyReviewsError, FindMyReviewsResponse, FindOrderByNumberData, FindOrderByNumberError, FindOrderByNumberResponse, FindOrderData, FindOrderError, FindOrderResponse, FindPaymentConfigData, FindPaymentConfigError, FindPaymentConfigResponse, FindSimplePayMethodsData, FindSimplePayMethodsError, FindSimplePayMethodsResponse, FindTermsData, FindTermsError, FindTermsResponse, FindTourFeedbackData, FindTourFeedbackError, FindTourFeedbackResponse, FindTourReviewData, FindTourReviewError, FindTourReviewResponse, FindUnifiedOrdersData, FindUnifiedOrdersError, FindUnifiedOrdersResponse, GetActionCountData, GetActionCountError, GetActionCountResponse, GetAvailablePointProductListData, GetAvailablePointProductListError, GetAvailablePointProductListResponse, GetBeforeOrderData, GetBeforeOrderError, GetBeforeOrderResponse2, GetBenefitNotificationApplicationResultsUrlData, GetBenefitNotificationApplicationResultsUrlError, GetBenefitNotificationApplicationResultsUrlResponse, GetBenefitNotificationFitAnalysisData, GetBenefitNotificationFitAnalysisError, GetBenefitNotificationFitAnalysisResponse, GetBenefitNotificationFitAnalysisResultData, GetBenefitNotificationFitAnalysisResultError, GetBenefitNotificationFitAnalysisResultResponse, GetBenefitNotificationMainInfoData, GetBenefitNotificationMainInfoError, GetBenefitNotificationMainInfoResponse, GetBenefitNotificationPrivacyUsageUrlData, GetBenefitNotificationPrivacyUsageUrlError, GetBenefitNotificationPrivacyUsageUrlResponse, GetBenefitNotificationPrivatePolicyUrlData, GetBenefitNotificationPrivatePolicyUrlError, GetBenefitNotificationPrivatePolicyUrlResponse, GetBenefitNotificationPublicServiceDetailUrlData, GetBenefitNotificationPublicServiceDetailUrlError, GetBenefitNotificationPublicServiceDetailUrlResponse, GetBenefitNotificationServiceUsageAgreementManagementUrlData, GetBenefitNotificationServiceUsageAgreementManagementUrlError, GetBenefitNotificationServiceUsageAgreementManagementUrlResponse, GetBenefitNotificationServiceUsageAgreementUrlData, GetBenefitNotificationServiceUsageAgreementUrlError, GetBenefitNotificationServiceUsageAgreementUrlResponse, GetBenefitNotificationSituationManagementUrlData, GetBenefitNotificationSituationManagementUrlError, GetBenefitNotificationSituationManagementUrlResponse, GetBenefitNotificationTermServiceUrlData, GetBenefitNotificationTermServiceUrlError, GetBenefitNotificationTermServiceUrlResponse, GetCommunityWelloNewsData, GetCommunityWelloNewsError, GetCommunityWelloNewsListData, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, GetCommunityWelloNewsResponse, GetCommunityWelloNewsWishlistData, GetCommunityWelloNewsWishlistError, GetCommunityWelloNewsWishlistResponse, GetDecemberRandomTicketCountData, GetDecemberRandomTicketCountError, GetDecemberRandomTicketCountResponse, GetDeliveryAddressData, GetDeliveryAddressError, GetDeliveryAddressListData, GetDeliveryAddressListError, GetDeliveryAddressListResponse, GetDeliveryAddressResponse, GetDeliveryTracking1Data, GetDeliveryTracking1Error, GetDeliveryTracking1Response, GetDeliveryTracking2Data, GetDeliveryTracking2Error, GetDeliveryTracking2Response, GetDeliveryTrackingData, GetDeliveryTrackingError, GetDeliveryTrackingResponse, GetDetailPointBalanceData, GetDetailPointBalanceError, GetDetailPointBalanceResponse, GetDetailTermsOfPrivacyData, GetDetailTermsOfPrivacyError, GetDetailTermsOfPrivacyResponse, GetDetailTermsOfServiceData, GetDetailTermsOfServiceError, GetDetailTermsOfServiceResponse, GetDlpSeoulAccountAndRequestLoginData, GetDlpSeoulAccountAndRequestLoginError, GetDlpSeoulAccountAndRequestLoginResponse, GetDlpSeoulAppliedPolicyListData, GetDlpSeoulAppliedPolicyListError, GetDlpSeoulAppliedPolicyListResponse, GetDlpSeoulCltrPassCheckData, GetDlpSeoulCltrPassCheckError, GetDlpSeoulCltrPassCheckResponse, GetDlpSeoulCulturePassApplyData, GetDlpSeoulCulturePassApplyError, GetDlpSeoulCulturePassApplyResponse, GetDlpSeoulIsltYoungSprtApplyData, GetDlpSeoulIsltYoungSprtApplyError, GetDlpSeoulIsltYoungSprtApplyResponse, GetDlpSeoulIsltYoungSprtCheckData, GetDlpSeoulIsltYoungSprtCheckError, GetDlpSeoulIsltYoungSprtCheckResponse, GetDlpSeoulLoanCrdtRcvrApplyData, GetDlpSeoulLoanCrdtRcvrApplyError, GetDlpSeoulLoanCrdtRcvrApplyResponse, GetDlpSeoulLoanCrdtRcvrCheckData, GetDlpSeoulLoanCrdtRcvrCheckError, GetDlpSeoulLoanCrdtRcvrCheckResponse, GetDlpSeoulMemberInfoData, GetDlpSeoulMemberInfoError, GetDlpSeoulMemberInfoResponse, GetDonationBusinessCommentListData, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, GetEmergencyRoomData, GetEmergencyRoomError, GetEmergencyRoomListData, GetEmergencyRoomListError, GetEmergencyRoomListResponse, GetEmergencyRoomResponse, GetEmergencyRoomWishlistData, GetEmergencyRoomWishlistError, GetEmergencyRoomWishlistResponse, GetEventHistoryListData, GetEventHistoryListError, GetEventHistoryListResponse, GetEventLocalTourData, GetEventLocalTourError, GetEventLocalTourResponse, GetFeedListData, GetFeedListError, GetFeedListResponse, GetGiftOrderHistoryData, GetGiftOrderHistoryError, GetGiftOrderHistoryListData, GetGiftOrderHistoryListError, GetGiftOrderHistoryListResponse, GetGiftOrderHistoryResponse, GetGiftOrderProductReviewData, GetGiftOrderProductReviewError, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewResponse, GetHomeDonationHistoryData, GetHomeDonationHistoryError, GetHomeDonationHistoryListData, GetHomeDonationHistoryListError, GetHomeDonationHistoryListResponse, GetHomeDonationHistoryResponse, GetHomeInquiryData, GetHomeInquiryError, GetHomeInquiryListData, GetHomeInquiryListError, GetHomeInquiryListResponse, GetHomeInquiryMyListData, GetHomeInquiryMyListError, GetHomeInquiryMyListResponse, GetHomeInquiryResponse, GetHomeInstitutionCertificateData, GetHomeInstitutionCertificateError, GetHomeInstitutionCertificateResponse, GetHomeInstitutionEventListData, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, GetHomeLoveMainInstitutionEventListData, GetHomeLoveMainInstitutionEventListError, GetHomeLoveMainInstitutionEventListResponse, GetHomeNoticeListData, GetHomeNoticeListError, GetHomeNoticeListResponse, GetInquiryData, GetInquiryError, GetInquiryResponse, GetInterestPolicyListData, GetInterestPolicyListError, GetInterestPolicyListResponse, GetInvitedMemberCountData, GetInvitedMemberCountError, GetInvitedMemberCountResponse, GetInviteeEventReceivedData, GetInviteeEventReceivedError, GetInviteeEventReceivedResponse, GetInviteeGiftBoxReceivedData, GetInviteeGiftBoxReceivedError, GetInviteeGiftBoxReceivedResponse, GetLatestCommunityListData, GetLatestCommunityListError, GetLatestCommunityListResponse, GetLatestCompletedCiData, GetLatestCompletedCiError, GetLatestCompletedCiResponse, GetLatestCompletedData, GetLatestCompletedError, GetLatestCompletedResponse, GetLatestHomeInstitutionCertificateData, GetLatestHomeInstitutionCertificateError, GetLatestHomeInstitutionCertificateResponse, GetListChildcareRelatedPolicyData, GetListChildcareRelatedPolicyError, GetListChildcareRelatedPolicyResponse, GetListLikeContentsData, GetListLikeContentsError, GetListLikeContentsResponse, GetListLikeContentsTypeData, GetListLikeContentsTypeError, GetListLikeContentsTypeResponse, GetListPointAttendanceData, GetListPointAttendanceError, GetListPointAttendanceResponse, GetListPointHistoryData, GetListPointHistoryError, GetListPointHistoryResponse, GetLiveWelloCommentListData, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, GetLocalfestaParticipantInfoData, GetLocalfestaParticipantInfoError, GetLocalfestaParticipantInfoResponse, GetLocationServiceConsentData, GetLocationServiceConsentError, GetLocationServiceConsentResponse, GetMemberAccountData, GetMemberAccountError, GetMemberAccountResponse, GetMemberData, GetMemberDetailInfoData, GetMemberDetailInfoError, GetMemberDetailInfoResponse, GetMemberError, GetMemberResponse, GetMemberTermAgreementByAgreementTypeData, GetMemberTermAgreementByAgreementTypeError, GetMemberTermAgreementByAgreementTypeResponse, GetMemberVerificationIdData, GetMemberVerificationIdError, GetMemberVerificationIdResponse, GetMetaPolicyCommentListData, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, GetMyCommunityListData, GetMyCommunityListError, GetMyCommunityListResponse, GetMyCommunityTypeListData, GetMyCommunityTypeListError, GetMyCommunityTypeListResponse, GetMyDonationInfoData, GetMyDonationInfoError, GetMyDonationInfoResponse, GetMyGiftOrderProductReviewListData, GetMyGiftOrderProductReviewListError, GetMyGiftOrderProductReviewListResponse, GetMyInviteEventGiftBoxSummaryData, GetMyInviteEventGiftBoxSummaryError, GetMyInviteEventGiftBoxSummaryResponse, GetMyInviteEventHistorySummaryData, GetMyInviteEventHistorySummaryError, GetMyInviteEventHistorySummaryResponse, GetMyWelloCommentListData, GetMyWelloCommentListError, GetMyWelloCommentListResponse, GetNewBestContentsListData, GetNewBestContentsListError, GetNewBestContentsListResponse, GetOpenedEventGiftBoxListData, GetOpenedEventGiftBoxListError, GetOpenedEventGiftBoxListResponse, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, GetOrderItemsForActionData, GetOrderItemsForActionError, GetOrderItemsForActionResponse, GetParticipantDonationEventListData, GetParticipantDonationEventListError, GetParticipantDonationEventListResponse, GetPointBudgetData, GetPointBudgetError, GetPointBudgetResponse, GetPointMarketOrderListData, GetPointMarketOrderListError, GetPointMarketOrderListResponse, GetPointMarketOrderPreviewData, GetPointMarketOrderPreviewError, GetPointMarketOrderPreviewResponse, GetPollData, GetPollError, GetPollResponse, GetPollResultData, GetPollResultError, GetPollResultResponse, GetPopularBestContentsListData, GetPopularBestContentsListError, GetPopularBestContentsListResponse, GetPopularHometownNewsListData, GetPopularHometownNewsListError, GetPopularHometownNewsListForCommunityData, GetPopularHometownNewsListForCommunityError, GetPopularHometownNewsListForCommunityResponse, GetPopularHometownNewsListResponse, GetPrimaryDeliveryAddressData, GetPrimaryDeliveryAddressError, GetPrimaryDeliveryAddressResponse, GetPrivateDataConsentData, GetPrivateDataConsentError, GetPrivateDataConsentResponse, GetProductOptionsByIdData, GetProductOptionsByIdError, GetProductOptionsByIdResponse, GetProductRefundInfoData, GetProductRefundInfoError, GetProductRefundInfoResponse, GetReceiptData, GetReceiptError, GetReceiptResponse, GetRefundEstimateData, GetRefundEstimateError, GetRefundEstimateResponse, GetRefundInfoData, GetRefundInfoError, GetRefundInfoResponse, GetRelatedMetaPolicyListData, GetRelatedMetaPolicyListError, GetRelatedMetaPolicyListResponse, GetReviewFormData, GetReviewFormError, GetReviewFormResponse, GetSituationPolicyListData, GetSituationPolicyListError, GetSituationPolicyListResponse, GetTourFestivalWishlistData, GetTourFestivalWishlistError, GetTourFestivalWishlistResponse, GetTransactionStatementData, GetTransactionStatementError, GetTransactionStatementResponse, GetUnopenedEventGiftBoxCountData, GetUnopenedEventGiftBoxCountError, GetUnopenedEventGiftBoxCountResponse, GetUnopenedGiftBoxIndicatorsData, GetUnopenedGiftBoxIndicatorsError, GetUnopenedGiftBoxIndicatorsResponse, GetWebWelloAppPushListData, GetWebWelloAppPushListError, GetWebWelloAppPushListResponse, GetWelloApplyPolicyListData, GetWelloApplyPolicyListError, GetWelloApplyPolicyListResponse, GetWelloCommentListData, GetWelloCommentListError, GetWelloCommentListResponse, GetWelloMemberBlockListData, GetWelloMemberBlockListError, GetWelloMemberBlockListResponse, GetWelloMemberFamilyData, GetWelloMemberFamilyError, GetWelloMemberFamilyResponse, GetWelloPolicyApplyCountData, GetWelloPolicyApplyCountError, GetWelloPolicyApplyCountResponse, GetWelloPolicyApplyListData, GetWelloPolicyApplyListError, GetWelloPolicyApplyListResponse, HometownNewsData, HometownNewsError, HometownNewsFeedbackData, HometownNewsFeedbackError, HometownNewsFeedbackResponse, HometownNewsListData, HometownNewsListError, HometownNewsListResponse, HometownNewsResponse, HometownNewsWishlistData, HometownNewsWishlistError, HometownNewsWishlistResponse2, IncreaseOptionQuantityData, IncreaseOptionQuantityError, IncreaseOptionQuantityResponse, InquiryListData, InquiryListError, InquiryListResponse, InterestFilterData, InterestFilterError, InterestFilterResponse, IsEventInProgressData, IsEventInProgressError, IsEventInProgressResponse, KbMemberCheckData, KbMemberCheckError, KbMemberCheckResponse, LatestCompleteDonationData, LatestCompleteDonationError, LatestCompleteDonationResponse, LoginDlpGyeonggiAccountData, LoginDlpGyeonggiAccountError, LoginDlpGyeonggiAccountResponse2, LogoutMemberData, LogoutMemberError, LogoutMemberResponse, MemberAccountListData, MemberAccountListError, MemberAccountListResponse, MemberCardListData, MemberCardListError, MemberCardListResponse, MemberContentCountData, MemberContentCountError, MemberContentCountResponse2, MemberData, MemberError, MemberInterestPolicyListData, MemberInterestPolicyListError, MemberInterestPolicyListResponse, MemberNeighborPolicyListData, MemberNeighborPolicyListError, MemberNeighborPolicyListResponse, MemberPeerGroupPolicyListData, MemberPeerGroupPolicyListError, MemberPeerGroupPolicyListResponse, MemberPolicyListData, MemberPolicyListError, MemberPolicyListResponse, MemberRecentPolicyListData, MemberRecentPolicyListError, MemberRecentPolicyListResponse, MemberRecommendPolicyByRecentListData, MemberRecommendPolicyByRecentListError, MemberRecommendPolicyByRecentListResponse, MemberResponse, MemberSocialAccountsData, MemberSocialAccountsError, MemberSocialAccountsResponse, MessageReceiveData, MessageReceiveError, MessageReceiveResponse, MetaPolicyData, MetaPolicyError, MetaPolicyFeedbackData, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, MetaPolicyListData, MetaPolicyListError, MetaPolicyListResponse, MetaPolicyResponse, MetaPolicyWishlistData, MetaPolicyWishlistError, MetaPolicyWishlistResponse2, NoticeListData, NoticeListError, NoticeListResponse, OpenAllEventGiftBoxData, OpenAllEventGiftBoxError, OpenAllEventGiftBoxResponse2, OpenRandomTicketData, OpenRandomTicketError, OpenRandomTicketResponse, PaymentHisListData, PaymentHisListError, PaymentHisListResponse, PayPointMarketOrderData, PayPointMarketOrderError, PayPointMarketOrderResponse, PreselectionStatusData, PreselectionStatusError, PreselectionStatusResponse, ProcessDonationCartData, ProcessDonationCartError, ProcessDonationCartResponse, ProcessDonationData, ProcessDonationError, ProcessDonationResponse2, PutFitFilterData, PutFitFilterError, PutFitFilterResponse, RecommendPolicyListData, RecommendPolicyListError, RecommendPolicyListResponse, ReissueCouponData, ReissueCouponError, ReissueCouponResponse2, RejectMessageData, RejectMessageError, RejectMessageResponse, RemoveGiftOrderProductReviewData, RemoveGiftOrderProductReviewError, RemoveGiftOrderProductReviewResponse, RemoveWishlistData, RemoveWishlistError, RemoveWishlistResponse, ReportCommunityData, ReportCommunityError, ReportCommunityResponse, RequestDlpSeoulIdCheckData, RequestDlpSeoulIdCheckError, RequestDlpSeoulIdCheckResponse, RequestDlpSeoulVerificationCheckData, RequestDlpSeoulVerificationCheckError, RequestDlpSeoulVerificationCheckForPasswordData, RequestDlpSeoulVerificationCheckForPasswordError, RequestDlpSeoulVerificationCheckForPasswordResponse, RequestDlpSeoulVerificationCheckResponse, RequestDlpSeoulVerificationData, RequestDlpSeoulVerificationError, RequestDlpSeoulVerificationForPasswordData, RequestDlpSeoulVerificationForPasswordError, RequestDlpSeoulVerificationForPasswordResponse, RequestDlpSeoulVerificationResponse, RequestLoginData, RequestLoginError, RequestLoginResponse, RequestReturnData, RequestReturnError, RequestReturnResponse, RequiredFilterData, RequiredFilterError, RequiredFilterResponse, ResignMemberData, ResignMemberError, ResignMemberResponse, ReturnOrderProductsData, ReturnOrderProductsError, ReturnOrderProductsResponse, ReturnProductData, ReturnProductError, ReturnProductResponse, SaveBenefitNotificationApplicationInfoData, SaveBenefitNotificationApplicationInfoError, SaveBenefitNotificationApplicationInfoResponse, SaveCartItemData, SaveCartItemError, SaveCartItemResponse, SaveDlpGyeonggiAccountData, SaveDlpGyeonggiAccountError, SaveDlpGyeonggiAccountResponse, SaveDonationBusinessCommentData, SaveDonationBusinessCommentError, SaveDonationBusinessCommentResponse2, SaveFitFilterData, SaveFitFilterError, SaveFitFilterResponse, SaveGiftOrderProductReviewData, SaveGiftOrderProductReviewError, SaveGiftOrderProductReviewResponse, SaveHomeInquiry1Data, SaveHomeInquiry1Error, SaveHomeInquiry1Response, SaveHomeInquiryData, SaveHomeInquiryError, SaveHomeInquiryResponse, SaveInquiry1Data, SaveInquiry1Error, SaveInquiry1Response, SaveInquiryData, SaveInquiryError, SaveInquiryResponse, SaveInterestFilterData, SaveInterestFilterError, SaveInterestFilterResponse, SaveKbFilterData, SaveKbFilterError, SaveKbFilterResponse, SaveLocalfestaParticipantData, SaveLocalfestaParticipantError, SaveLocalfestaParticipantResponse, SaveMemberAccountData, SaveMemberAccountError, SaveMemberAccountResponse, SaveMemberCardData, SaveMemberCardError, SaveMemberCardResponse, SaveMemberNickNameData, SaveMemberNickNameError, SaveMemberNickNameResponse, SaveOrUpdateMemberTermAgreementData, SaveOrUpdateMemberTermAgreementError, SaveOrUpdateMemberTermAgreementResponse, SaveReportData, SaveReportError, SaveReportResponse, SaveReviewData, SaveReviewError, SaveReviewResponse, SaveTodayAttendanceData, SaveTodayAttendanceError, SaveTodayAttendanceResponse, SaveTourReviewData, SaveTourReviewError, SaveTourReviewResponse, SaveWelloCommentData, SaveWelloCommentError, SaveWelloCommentReportData, SaveWelloCommentReportError, SaveWelloCommentReportResponse, SaveWelloCommentResponse2, SaveWelloDeviceInfoData, SaveWelloDeviceInfoError, SaveWelloDeviceInfoResponse, SaveWelloHelperData, SaveWelloHelperError, SaveWelloHelperResponse, SaveWelloLikeData, SaveWelloLikeError, SaveWelloLikeResponse, SaveWelloMemberFamilyData, SaveWelloMemberFamilyError, SaveWelloMemberFamilyResponse, SaveWelloParticipationData, SaveWelloParticipationError, SaveWelloParticipationResponse, SaveWelloTrackingData, SaveWelloTrackingError, SaveWelloTrackingResponse, SaveWishlist1Data, SaveWishlist1Error, SaveWishlist1Response, SaveWishlistData, SaveWishlistError, SaveWishlistResponse, SendCertificationCellphoneData, SendCertificationCellphoneError, SendCertificationCellphoneResponse, SendNiceSafeKeyData, SendNiceSafeKeyError, SendNiceSafeKeyResponse, SendPinkeyData, SendPinkeyError, SendPinkeyResponse, SituationListData, SituationListError, SituationListResponse2, TotalPaymentHisListData, TotalPaymentHisListError, TotalPaymentHisListResponse, UpdateAllDeliveryAddressData, UpdateAllDeliveryAddressError, UpdateAllDeliveryAddressResponse, UpdateDeliveryAddressData, UpdateDeliveryAddressError, UpdateDeliveryAddressResponse, UpdateDonationBusinessCommentData, UpdateDonationBusinessCommentError, UpdateDonationBusinessCommentResponse2, UpdateFileTempSaveYnData, UpdateFileTempSaveYnError, UpdateFileTempSaveYnResponse, UpdateGiftOrderAddressData, UpdateGiftOrderAddressError, UpdateGiftOrderAddressResponse, UpdateGiftOrderProductReviewData, UpdateGiftOrderProductReviewError, UpdateGiftOrderProductReviewResponse, UpdateGiftOrderStatusData, UpdateGiftOrderStatusError, UpdateGiftOrderStatusResponse, UpdateIssueAtData, UpdateIssueAtError, UpdateIssueAtResponse, UpdateLocalfestaParticipantEntryData, UpdateLocalfestaParticipantEntryError, UpdateLocalfestaParticipantEntryResponse, UpdateLocationServiceConsentData, UpdateLocationServiceConsentError, UpdateLocationServiceConsentResponse, UpdateMemberNickNameData, UpdateMemberNickNameError, UpdateMemberNickNameResponse, UpdateMemberVerificationData, UpdateMemberVerificationError, UpdateMemberVerificationResponse, UpdateMyReviewData, UpdateMyReviewError, UpdateMyReviewResponse, UpdateOptionData, UpdateOptionError, UpdateOptionItemListData, UpdateOptionItemListError, UpdateOptionItemListResponse, UpdateOptionResponse, UpdatePrivateDataConsentData, UpdatePrivateDataConsentError, UpdatePrivateDataConsentResponse, UpdateQuantityData, UpdateQuantityError, UpdateQuantityResponse, UpdateTourReviewData, UpdateTourReviewError, UpdateTourReviewResponse, UpdateVendorDeliveryAddressData, UpdateVendorDeliveryAddressError, UpdateVendorDeliveryAddressResponse, UpdateWelloAppPushReadData, UpdateWelloAppPushReadError, UpdateWelloAppPushReadResponse, UpdateWelloCommentData, UpdateWelloCommentError, UpdateWelloCommentResponse, UpdateWelloMemberFamilyData, UpdateWelloMemberFamilyError, UpdateWelloMemberFamilyResponse, UploadCardImageData, UploadCardImageError, UploadCardImageResponse, UserPropertyData, UserPropertyError, UserPropertyResponse2, VerifyDlpGyeonggiAccountIdentificationData, VerifyDlpGyeonggiAccountIdentificationError, VerifyDlpGyeonggiAccountIdentificationResponse, WelloPickListData, WelloPickListError, WelloPickListResponse, WelloPickPolicyListData, WelloPickPolicyListError, WelloPickPolicyListResponse } from '../types.gen';
export type QueryKey<TOptions extends Options> = [Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
  _id: string;
  _infinite?: boolean;
  tags?: ReadonlyArray<string>;
}];
const createQueryKey = <TOptions extends Options,>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};
export const getMetaPolicyCommentListQueryKey = (options: Options<GetMetaPolicyCommentListData>) => createQueryKey('getMetaPolicyCommentList', options);

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentListOptions = (options: Options<GetMetaPolicyCommentListData>) => queryOptions<GetMetaPolicyCommentListResponse, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, ReturnType<typeof getMetaPolicyCommentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMetaPolicyCommentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMetaPolicyCommentListQueryKey(options)
});

/**
 * 웰로 댓글 수정
 */
export const updateWelloCommentMutation = (options?: Partial<Options<UpdateWelloCommentData>>): UseMutationOptions<UpdateWelloCommentResponse, UpdateWelloCommentError, Options<UpdateWelloCommentData>> => {
  const mutationOptions: UseMutationOptions<UpdateWelloCommentResponse, UpdateWelloCommentError, Options<UpdateWelloCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateWelloComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 댓글 삭제
 */
export const deleteWelloCommentMutation = (options?: Partial<Options<DeleteWelloCommentData>>): UseMutationOptions<DeleteWelloCommentResponse, DeleteWelloCommentError, Options<DeleteWelloCommentData>> => {
  const mutationOptions: UseMutationOptions<DeleteWelloCommentResponse, DeleteWelloCommentError, Options<DeleteWelloCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteWelloComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getWebWelloAppPushListQueryKey = (options: Options<GetWebWelloAppPushListData>) => createQueryKey('getWebWelloAppPushList', options);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const getWebWelloAppPushListOptions = (options: Options<GetWebWelloAppPushListData>) => queryOptions<GetWebWelloAppPushListResponse, GetWebWelloAppPushListError, GetWebWelloAppPushListResponse, ReturnType<typeof getWebWelloAppPushListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWebWelloAppPushList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWebWelloAppPushListQueryKey(options)
});
const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>,>(queryKey: QueryKey<Options>, page: K) => {
  const params = {
    ...queryKey[0]
  };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any)
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any)
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any)
    };
  }
  return params as unknown as typeof page;
};
export const getWebWelloAppPushListInfiniteQueryKey = (options: Options<GetWebWelloAppPushListData>): QueryKey<Options<GetWebWelloAppPushListData>> => createQueryKey('getWebWelloAppPushList', options, true);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const getWebWelloAppPushListInfiniteOptions = (options: Options<GetWebWelloAppPushListData>) => infiniteQueryOptions<GetWebWelloAppPushListResponse, GetWebWelloAppPushListError, InfiniteData<GetWebWelloAppPushListResponse>, QueryKey<Options<GetWebWelloAppPushListData>>, number | Pick<QueryKey<Options<GetWebWelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetWebWelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getWebWelloAppPushList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWebWelloAppPushListInfiniteQueryKey(options)
});

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushReadMutation = (options?: Partial<Options<UpdateWelloAppPushReadData>>): UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> => {
  const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateWelloAppPushRead({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 삭제
 */
export const fileDeleteMutation = (options?: Partial<Options<FileDeleteData>>): UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> => {
  const mutationOptions: UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileDelete({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 업로드
 */
export const fileUploadMutation = (options?: Partial<Options<FileUploadData>>): UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> => {
  const mutationOptions: UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYnMutation = (options?: Partial<Options<UpdateFileTempSaveYnData>>): UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> => {
  const mutationOptions: UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateFileTempSaveYn({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 이름 변경
 */
export const fileRenameMutation = (options?: Partial<Options<FileRenameData>>): UseMutationOptions<FileRenameResponse, FileRenameError, Options<FileRenameData>> => {
  const mutationOptions: UseMutationOptions<FileRenameResponse, FileRenameError, Options<FileRenameData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileRename({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const rejectMessageMutation = (options?: Partial<Options<RejectMessageData>>): UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> => {
  const mutationOptions: UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await rejectMessage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 본인인증 ID로 유저정보 수정
 */
export const updateMemberVerificationMutation = (options?: Partial<Options<UpdateMemberVerificationData>>): UseMutationOptions<UpdateMemberVerificationResponse, UpdateMemberVerificationError, Options<UpdateMemberVerificationData>> => {
  const mutationOptions: UseMutationOptions<UpdateMemberVerificationResponse, UpdateMemberVerificationError, Options<UpdateMemberVerificationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateMemberVerification({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const memberQueryKey = (options?: Options<MemberData>) => createQueryKey('member', options);

/**
 * 유저 프로필 조회
 *
 * 가입된 유저의 프로필을 조회합니다
 */
export const memberOptions = (options?: Options<MemberData>) => queryOptions<MemberResponse, MemberError, MemberResponse, ReturnType<typeof memberQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await member({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberQueryKey(options)
});

/**
 * 유저 가입정보 등록
 */
export const saveMemberNickNameMutation = (options?: Partial<Options<SaveMemberNickNameData>>): UseMutationOptions<SaveMemberNickNameResponse, SaveMemberNickNameError, Options<SaveMemberNickNameData>> => {
  const mutationOptions: UseMutationOptions<SaveMemberNickNameResponse, SaveMemberNickNameError, Options<SaveMemberNickNameData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveMemberNickName({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 유저 정보 수정
 *
 * 가입된 유저 정보를 수정합니다
 */
export const updateMemberNickNameMutation = (options?: Partial<Options<UpdateMemberNickNameData>>): UseMutationOptions<UpdateMemberNickNameResponse, UpdateMemberNickNameError, Options<UpdateMemberNickNameData>> => {
  const mutationOptions: UseMutationOptions<UpdateMemberNickNameResponse, UpdateMemberNickNameError, Options<UpdateMemberNickNameData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateMemberNickName({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const messageReceiveMutation = (options?: Partial<Options<MessageReceiveData>>): UseMutationOptions<MessageReceiveResponse, MessageReceiveError, Options<MessageReceiveData>> => {
  const mutationOptions: UseMutationOptions<MessageReceiveResponse, MessageReceiveError, Options<MessageReceiveData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await messageReceive({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getPrivateDataConsentQueryKey = (options?: Options<GetPrivateDataConsentData>) => createQueryKey('getPrivateDataConsent', options);

/**
 * 개인 정보 수집 동의 여부 조회
 */
export const getPrivateDataConsentOptions = (options?: Options<GetPrivateDataConsentData>) => queryOptions<GetPrivateDataConsentResponse, GetPrivateDataConsentError, GetPrivateDataConsentResponse, ReturnType<typeof getPrivateDataConsentQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPrivateDataConsent({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPrivateDataConsentQueryKey(options)
});

/**
 * 개인 정보 수집 동의 여부 수정
 */
export const updatePrivateDataConsentMutation = (options?: Partial<Options<UpdatePrivateDataConsentData>>): UseMutationOptions<UpdatePrivateDataConsentResponse, UpdatePrivateDataConsentError, Options<UpdatePrivateDataConsentData>> => {
  const mutationOptions: UseMutationOptions<UpdatePrivateDataConsentResponse, UpdatePrivateDataConsentError, Options<UpdatePrivateDataConsentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updatePrivateDataConsent({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getLocationServiceConsentQueryKey = (options?: Options<GetLocationServiceConsentData>) => createQueryKey('getLocationServiceConsent', options);

/**
 * 위치 기반 동의 여부 조회
 */
export const getLocationServiceConsentOptions = (options?: Options<GetLocationServiceConsentData>) => queryOptions<GetLocationServiceConsentResponse, GetLocationServiceConsentError, GetLocationServiceConsentResponse, ReturnType<typeof getLocationServiceConsentQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getLocationServiceConsent({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLocationServiceConsentQueryKey(options)
});

/**
 * 위치 기반 동의 여부 수정
 */
export const updateLocationServiceConsentMutation = (options?: Partial<Options<UpdateLocationServiceConsentData>>): UseMutationOptions<UpdateLocationServiceConsentResponse, UpdateLocationServiceConsentError, Options<UpdateLocationServiceConsentData>> => {
  const mutationOptions: UseMutationOptions<UpdateLocationServiceConsentResponse, UpdateLocationServiceConsentError, Options<UpdateLocationServiceConsentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateLocationServiceConsent({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const memberCardListQueryKey = (options?: Options<MemberCardListData>) => createQueryKey('memberCardList', options);

/**
 * 카드 신청 여정 목록
 */
export const memberCardListOptions = (options?: Options<MemberCardListData>) => queryOptions<MemberCardListResponse, MemberCardListError, MemberCardListResponse, ReturnType<typeof memberCardListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberCardList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberCardListQueryKey(options)
});

/**
 * 카드 신청
 */
export const saveMemberCardMutation = (options?: Partial<Options<SaveMemberCardData>>): UseMutationOptions<SaveMemberCardResponse, SaveMemberCardError, Options<SaveMemberCardData>> => {
  const mutationOptions: UseMutationOptions<SaveMemberCardResponse, SaveMemberCardError, Options<SaveMemberCardData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveMemberCard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 카드를 발급 받았어요
 */
export const updateIssueAtMutation = (options?: Partial<Options<UpdateIssueAtData>>): UseMutationOptions<UpdateIssueAtResponse, UpdateIssueAtError, Options<UpdateIssueAtData>> => {
  const mutationOptions: UseMutationOptions<UpdateIssueAtResponse, UpdateIssueAtError, Options<UpdateIssueAtData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateIssueAt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 카드를 발급 받았어요-카드뒷면 업로드
 */
export const uploadCardImageMutation = (options?: Partial<Options<UploadCardImageData>>): UseMutationOptions<UploadCardImageResponse, UploadCardImageError, Options<UploadCardImageData>> => {
  const mutationOptions: UseMutationOptions<UploadCardImageResponse, UploadCardImageError, Options<UploadCardImageData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await uploadCardImage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로페 입장하기
 */
export const updateLocalfestaParticipantEntryMutation = (options?: Partial<Options<UpdateLocalfestaParticipantEntryData>>): UseMutationOptions<UpdateLocalfestaParticipantEntryResponse, UpdateLocalfestaParticipantEntryError, Options<UpdateLocalfestaParticipantEntryData>> => {
  const mutationOptions: UseMutationOptions<UpdateLocalfestaParticipantEntryResponse, UpdateLocalfestaParticipantEntryError, Options<UpdateLocalfestaParticipantEntryData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateLocalfestaParticipantEntry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 내가 쓴 리뷰 삭제
 *
 * 내 리뷰를 삭제한다.
 */
export const deleteMyReviewMutation = (options?: Partial<Options<DeleteMyReviewData>>): UseMutationOptions<DeleteMyReviewResponse, DeleteMyReviewError, Options<DeleteMyReviewData>> => {
  const mutationOptions: UseMutationOptions<DeleteMyReviewResponse, DeleteMyReviewError, Options<DeleteMyReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteMyReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const findMyReviewQueryKey = (options: Options<FindMyReviewData>) => createQueryKey('findMyReview', options);

/**
 * 내가 쓴 리뷰 상세 조회
 *
 * 내 리뷰 상세를 조회한다.
 */
export const findMyReviewOptions = (options: Options<FindMyReviewData>) => queryOptions<FindMyReviewResponse, FindMyReviewError, FindMyReviewResponse, ReturnType<typeof findMyReviewQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findMyReview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findMyReviewQueryKey(options)
});

/**
 * 내가 쓴 리뷰 수정
 *
 * 내 리뷰를 수정한다.
 */
export const updateMyReviewMutation = (options?: Partial<Options<UpdateMyReviewData>>): UseMutationOptions<UpdateMyReviewResponse, UpdateMyReviewError, Options<UpdateMyReviewData>> => {
  const mutationOptions: UseMutationOptions<UpdateMyReviewResponse, UpdateMyReviewError, Options<UpdateMyReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateMyReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 사전주문 체크아웃 (배송지 + 구매자 정보 확정)
 *
 * 사전주문 체크아웃 (배송지 + 구매자 정보 확정).
 *
 * <p>배송비를 계산하고 최종 결제 금액을 확정한다.</p>
 */
export const checkoutMutation = (options?: Partial<Options<CheckoutData>>): UseMutationOptions<CheckoutResponse, CheckoutError, Options<CheckoutData>> => {
  const mutationOptions: UseMutationOptions<CheckoutResponse, CheckoutError, Options<CheckoutData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await checkout({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 수량 변경
 *
 * 장바구니 수량 변경.
 */
export const updateQuantityMutation = (options?: Partial<Options<UpdateQuantityData>>): UseMutationOptions<UpdateQuantityResponse, UpdateQuantityError, Options<UpdateQuantityData>> => {
  const mutationOptions: UseMutationOptions<UpdateQuantityResponse, UpdateQuantityError, Options<UpdateQuantityData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateQuantity({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 옵션 변경
 *
 * 장바구니 옵션 변경.
 */
export const updateOptionMutation = (options?: Partial<Options<UpdateOptionData>>): UseMutationOptions<UpdateOptionResponse, UpdateOptionError, Options<UpdateOptionData>> => {
  const mutationOptions: UseMutationOptions<UpdateOptionResponse, UpdateOptionError, Options<UpdateOptionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateOption({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 입점업체별 배송지 변경
 *
 * 입점업체별 배송지 변경.
 *
 * <p>특정 입점업체의 배송지만 변경한다.
 * 해당 입점업체의 모든 상품이 주문 완료(PRODUCT_ORDERED) 상태일 때만 변경 가능하다.</p>
 */
export const updateVendorDeliveryAddressMutation = (options?: Partial<Options<UpdateVendorDeliveryAddressData>>): UseMutationOptions<UpdateVendorDeliveryAddressResponse, UpdateVendorDeliveryAddressError, Options<UpdateVendorDeliveryAddressData>> => {
  const mutationOptions: UseMutationOptions<UpdateVendorDeliveryAddressResponse, UpdateVendorDeliveryAddressError, Options<UpdateVendorDeliveryAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateVendorDeliveryAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 반품 요청 취소
 *
 * 반품 요청 취소 (관리자 승인 전만 가능).
 */
export const cancelReturnMutation = (options?: Partial<Options<CancelReturnData>>): UseMutationOptions<CancelReturnResponse, CancelReturnError, Options<CancelReturnData>> => {
  const mutationOptions: UseMutationOptions<CancelReturnResponse, CancelReturnError, Options<CancelReturnData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelReturn({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품별 구매 확정
 *
 * 본인의 주문 내 특정 상품을 구매 확정 처리합니다.
 */
export const confirmOrderProductMutation = (options?: Partial<Options<ConfirmOrderProductData>>): UseMutationOptions<ConfirmOrderProductResponse, ConfirmOrderProductError, Options<ConfirmOrderProductData>> => {
  const mutationOptions: UseMutationOptions<ConfirmOrderProductResponse, ConfirmOrderProductError, Options<ConfirmOrderProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await confirmOrderProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품별 취소
 *
 * 본인의 주문 내 특정 상품을 취소합니다.
 */
export const cancelOrderProductMutation = (options?: Partial<Options<CancelOrderProductData>>): UseMutationOptions<CancelOrderProductResponse, CancelOrderProductError, Options<CancelOrderProductData>> => {
  const mutationOptions: UseMutationOptions<CancelOrderProductResponse, CancelOrderProductError, Options<CancelOrderProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelOrderProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 전체 취소 (같은 상품의 모든 옵션)
 */
export const cancelProductMutation = (options?: Partial<Options<CancelProductData>>): UseMutationOptions<CancelProductResponse, CancelProductError, Options<CancelProductData>> => {
  const mutationOptions: UseMutationOptions<CancelProductResponse, CancelProductError, Options<CancelProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 개별/선택 취소 (선택한 orderProduct 일괄)
 */
export const cancelOrderProductsMutation = (options?: Partial<Options<CancelOrderProductsData>>): UseMutationOptions<CancelOrderProductsResponse, CancelOrderProductsError, Options<CancelOrderProductsData>> => {
  const mutationOptions: UseMutationOptions<CancelOrderProductsResponse, CancelOrderProductsError, Options<CancelOrderProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelOrderProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 주문 배송지 일괄 변경
 *
 * 주문 배송지 일괄 변경.
 *
 * <p>주문 내 모든 입점업체의 배송지를 동일하게 변경한다.
 * 모든 상품이 주문 완료(PRODUCT_ORDERED) 상태일 때만 변경 가능하다.</p>
 */
export const updateAllDeliveryAddressMutation = (options?: Partial<Options<UpdateAllDeliveryAddressData>>): UseMutationOptions<UpdateAllDeliveryAddressResponse, UpdateAllDeliveryAddressError, Options<UpdateAllDeliveryAddressData>> => {
  const mutationOptions: UseMutationOptions<UpdateAllDeliveryAddressResponse, UpdateAllDeliveryAddressError, Options<UpdateAllDeliveryAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateAllDeliveryAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 구매 확정
 *
 * 본인의 주문을 구매 확정 처리합니다.
 */
export const confirmPurchaseMutation = (options?: Partial<Options<ConfirmPurchaseData>>): UseMutationOptions<ConfirmPurchaseResponse, ConfirmPurchaseError, Options<ConfirmPurchaseData>> => {
  const mutationOptions: UseMutationOptions<ConfirmPurchaseResponse, ConfirmPurchaseError, Options<ConfirmPurchaseData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await confirmPurchase({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 주문 취소
 *
 * 본인의 주문을 취소합니다.
 */
export const cancelOrderMutation = (options?: Partial<Options<CancelOrderData>>): UseMutationOptions<CancelOrderResponse, CancelOrderError, Options<CancelOrderData>> => {
  const mutationOptions: UseMutationOptions<CancelOrderResponse, CancelOrderError, Options<CancelOrderData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelOrder({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 답례품 주문 취소/교환/환불 신청
 */
export const updateGiftOrderStatusMutation = (options?: Partial<Options<UpdateGiftOrderStatusData>>): UseMutationOptions<UpdateGiftOrderStatusResponse, UpdateGiftOrderStatusError, Options<UpdateGiftOrderStatusData>> => {
  const mutationOptions: UseMutationOptions<UpdateGiftOrderStatusResponse, UpdateGiftOrderStatusError, Options<UpdateGiftOrderStatusData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateGiftOrderStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 답례품 주문 배송지 변경
 */
export const updateGiftOrderAddressMutation = (options?: Partial<Options<UpdateGiftOrderAddressData>>): UseMutationOptions<UpdateGiftOrderAddressResponse, UpdateGiftOrderAddressError, Options<UpdateGiftOrderAddressData>> => {
  const mutationOptions: UseMutationOptions<UpdateGiftOrderAddressResponse, UpdateGiftOrderAddressError, Options<UpdateGiftOrderAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateGiftOrderAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 아이템 옵션 변경
 */
export const updateOptionItemListMutation = (options?: Partial<Options<UpdateOptionItemListData>>): UseMutationOptions<UpdateOptionItemListResponse, UpdateOptionItemListError, Options<UpdateOptionItemListData>> => {
  const mutationOptions: UseMutationOptions<UpdateOptionItemListResponse, UpdateOptionItemListError, Options<UpdateOptionItemListData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateOptionItemList({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 아이템 옵션 수량 증가
 */
export const increaseOptionQuantityMutation = (options?: Partial<Options<IncreaseOptionQuantityData>>): UseMutationOptions<IncreaseOptionQuantityResponse, IncreaseOptionQuantityError, Options<IncreaseOptionQuantityData>> => {
  const mutationOptions: UseMutationOptions<IncreaseOptionQuantityResponse, IncreaseOptionQuantityError, Options<IncreaseOptionQuantityData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await increaseOptionQuantity({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 아이템 옵션 수량 감소 (1개일 때 감소하면 삭제)
 */
export const decreaseOptionQuantityMutation = (options?: Partial<Options<DecreaseOptionQuantityData>>): UseMutationOptions<DecreaseOptionQuantityResponse, DecreaseOptionQuantityError, Options<DecreaseOptionQuantityData>> => {
  const mutationOptions: UseMutationOptions<DecreaseOptionQuantityResponse, DecreaseOptionQuantityError, Options<DecreaseOptionQuantityData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await decreaseOptionQuantity({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getGiftOrderProductReviewListQueryKey = (options?: Options<GetGiftOrderProductReviewListData>) => createQueryKey('getGiftOrderProductReviewList', options);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListOptions = (options?: Options<GetGiftOrderProductReviewListData>) => queryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, ReturnType<typeof getGiftOrderProductReviewListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getGiftOrderProductReviewList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderProductReviewListQueryKey(options)
});
export const getGiftOrderProductReviewListInfiniteQueryKey = (options?: Options<GetGiftOrderProductReviewListData>): QueryKey<Options<GetGiftOrderProductReviewListData>> => createQueryKey('getGiftOrderProductReviewList', options, true);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListInfiniteOptions = (options?: Options<GetGiftOrderProductReviewListData>) => infiniteQueryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, InfiniteData<GetGiftOrderProductReviewListResponse>, QueryKey<Options<GetGiftOrderProductReviewListData>>, number | Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getGiftOrderProductReviewList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderProductReviewListInfiniteQueryKey(options)
});

/**
 * 리뷰 등록
 */
export const saveGiftOrderProductReviewMutation = (options?: Partial<Options<SaveGiftOrderProductReviewData>>): UseMutationOptions<SaveGiftOrderProductReviewResponse, SaveGiftOrderProductReviewError, Options<SaveGiftOrderProductReviewData>> => {
  const mutationOptions: UseMutationOptions<SaveGiftOrderProductReviewResponse, SaveGiftOrderProductReviewError, Options<SaveGiftOrderProductReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveGiftOrderProductReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 리뷰 수정
 */
export const updateGiftOrderProductReviewMutation = (options?: Partial<Options<UpdateGiftOrderProductReviewData>>): UseMutationOptions<UpdateGiftOrderProductReviewResponse, UpdateGiftOrderProductReviewError, Options<UpdateGiftOrderProductReviewData>> => {
  const mutationOptions: UseMutationOptions<UpdateGiftOrderProductReviewResponse, UpdateGiftOrderProductReviewError, Options<UpdateGiftOrderProductReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateGiftOrderProductReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 랜덤티켓 오픈
 */
export const openRandomTicketMutation = (options?: Partial<Options<OpenRandomTicketData>>): UseMutationOptions<OpenRandomTicketResponse, OpenRandomTicketError, Options<OpenRandomTicketData>> => {
  const mutationOptions: UseMutationOptions<OpenRandomTicketResponse, OpenRandomTicketError, Options<OpenRandomTicketData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await openRandomTicket({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 지정사업 응원하기 삭제
 */
export const deleteDonationBusinessCommentMutation = (options?: Partial<Options<DeleteDonationBusinessCommentData>>): UseMutationOptions<DeleteDonationBusinessCommentResponse2, DeleteDonationBusinessCommentError, Options<DeleteDonationBusinessCommentData>> => {
  const mutationOptions: UseMutationOptions<DeleteDonationBusinessCommentResponse2, DeleteDonationBusinessCommentError, Options<DeleteDonationBusinessCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteDonationBusinessComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getDonationBusinessCommentListQueryKey = (options: Options<GetDonationBusinessCommentListData>) => createQueryKey('getDonationBusinessCommentList', options);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListOptions = (options: Options<GetDonationBusinessCommentListData>) => queryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, ReturnType<typeof getDonationBusinessCommentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDonationBusinessCommentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDonationBusinessCommentListQueryKey(options)
});
export const getDonationBusinessCommentListInfiniteQueryKey = (options: Options<GetDonationBusinessCommentListData>): QueryKey<Options<GetDonationBusinessCommentListData>> => createQueryKey('getDonationBusinessCommentList', options, true);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListInfiniteOptions = (options: Options<GetDonationBusinessCommentListData>) => infiniteQueryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, InfiniteData<GetDonationBusinessCommentListResponse>, QueryKey<Options<GetDonationBusinessCommentListData>>, number | Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getDonationBusinessCommentList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDonationBusinessCommentListInfiniteQueryKey(options)
});

/**
 * 지정사업 응원하기
 */
export const saveDonationBusinessCommentMutation = (options?: Partial<Options<SaveDonationBusinessCommentData>>): UseMutationOptions<SaveDonationBusinessCommentResponse2, SaveDonationBusinessCommentError, Options<SaveDonationBusinessCommentData>> => {
  const mutationOptions: UseMutationOptions<SaveDonationBusinessCommentResponse2, SaveDonationBusinessCommentError, Options<SaveDonationBusinessCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveDonationBusinessComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 지정사업 응원하기 수정
 */
export const updateDonationBusinessCommentMutation = (options?: Partial<Options<UpdateDonationBusinessCommentData>>): UseMutationOptions<UpdateDonationBusinessCommentResponse2, UpdateDonationBusinessCommentError, Options<UpdateDonationBusinessCommentData>> => {
  const mutationOptions: UseMutationOptions<UpdateDonationBusinessCommentResponse2, UpdateDonationBusinessCommentError, Options<UpdateDonationBusinessCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateDonationBusinessComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 배송지 삭제
 */
export const deleteDeliveryAddressMutation = (options?: Partial<Options<DeleteDeliveryAddressData>>): UseMutationOptions<DeleteDeliveryAddressResponse, DeleteDeliveryAddressError, Options<DeleteDeliveryAddressData>> => {
  const mutationOptions: UseMutationOptions<DeleteDeliveryAddressResponse, DeleteDeliveryAddressError, Options<DeleteDeliveryAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteDeliveryAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getDeliveryAddressQueryKey = (options: Options<GetDeliveryAddressData>) => createQueryKey('getDeliveryAddress', options);

/**
 * 배송지 상세 조회
 */
export const getDeliveryAddressOptions = (options: Options<GetDeliveryAddressData>) => queryOptions<GetDeliveryAddressResponse, GetDeliveryAddressError, GetDeliveryAddressResponse, ReturnType<typeof getDeliveryAddressQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDeliveryAddress({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryAddressQueryKey(options)
});

/**
 * 배송지 수정
 */
export const updateDeliveryAddressMutation = (options?: Partial<Options<UpdateDeliveryAddressData>>): UseMutationOptions<UpdateDeliveryAddressResponse, UpdateDeliveryAddressError, Options<UpdateDeliveryAddressData>> => {
  const mutationOptions: UseMutationOptions<UpdateDeliveryAddressResponse, UpdateDeliveryAddressError, Options<UpdateDeliveryAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateDeliveryAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 1:1 문의 삭제
 */
export const deleteHomeInquiryMutation = (options?: Partial<Options<DeleteHomeInquiryData>>): UseMutationOptions<DeleteHomeInquiryResponse, DeleteHomeInquiryError, Options<DeleteHomeInquiryData>> => {
  const mutationOptions: UseMutationOptions<DeleteHomeInquiryResponse, DeleteHomeInquiryError, Options<DeleteHomeInquiryData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteHomeInquiry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getHomeInquiryQueryKey = (options: Options<GetHomeInquiryData>) => createQueryKey('getHomeInquiry', options);

/**
 * 1:1 문의 상세 조회
 */
export const getHomeInquiryOptions = (options: Options<GetHomeInquiryData>) => queryOptions<GetHomeInquiryResponse, GetHomeInquiryError, GetHomeInquiryResponse, ReturnType<typeof getHomeInquiryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInquiry({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInquiryQueryKey(options)
});

/**
 * 1:1 문의 수정
 */
export const saveHomeInquiryMutation = (options?: Partial<Options<SaveHomeInquiryData>>): UseMutationOptions<SaveHomeInquiryResponse, SaveHomeInquiryError, Options<SaveHomeInquiryData>> => {
  const mutationOptions: UseMutationOptions<SaveHomeInquiryResponse, SaveHomeInquiryError, Options<SaveHomeInquiryData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveHomeInquiry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getWelloMemberFamilyQueryKey = (options?: Options<GetWelloMemberFamilyData>) => createQueryKey('getWelloMemberFamily', options);

/**
 * 웰로멤버 가족 목록 조회
 *
 * 웰로멤버 가족 목록을 조회합니다
 */
export const getWelloMemberFamilyOptions = (options?: Options<GetWelloMemberFamilyData>) => queryOptions<GetWelloMemberFamilyResponse, GetWelloMemberFamilyError, GetWelloMemberFamilyResponse, ReturnType<typeof getWelloMemberFamilyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloMemberFamily({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloMemberFamilyQueryKey(options)
});

/**
 * 웰로멤버 가족 프로필 추가
 *
 * 웰로멤버 가족 프로필을 추가합니다
 */
export const saveWelloMemberFamilyMutation = (options?: Partial<Options<SaveWelloMemberFamilyData>>): UseMutationOptions<SaveWelloMemberFamilyResponse, SaveWelloMemberFamilyError, Options<SaveWelloMemberFamilyData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloMemberFamilyResponse, SaveWelloMemberFamilyError, Options<SaveWelloMemberFamilyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloMemberFamily({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로멤버 가족 프로필 수정
 *
 * 웰로멤버 가족 프로필 정보를 수정합니다
 */
export const updateWelloMemberFamilyMutation = (options?: Partial<Options<UpdateWelloMemberFamilyData>>): UseMutationOptions<UpdateWelloMemberFamilyResponse, UpdateWelloMemberFamilyError, Options<UpdateWelloMemberFamilyData>> => {
  const mutationOptions: UseMutationOptions<UpdateWelloMemberFamilyResponse, UpdateWelloMemberFamilyError, Options<UpdateWelloMemberFamilyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateWelloMemberFamily({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 비밀번호 변경 요청
 *
 * 서울특별시 비밀번호 변경을 시도합니다.
 */
export const changeMemberPasswordMutation = (options?: Partial<Options<ChangeMemberPasswordData>>): UseMutationOptions<ChangeMemberPasswordResponse, ChangeMemberPasswordError, Options<ChangeMemberPasswordData>> => {
  const mutationOptions: UseMutationOptions<ChangeMemberPasswordResponse, ChangeMemberPasswordError, Options<ChangeMemberPasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await changeMemberPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 축제 리뷰 삭제
 *
 * 본인이 작성한 축제 리뷰를 소프트 삭제합니다.
 */
export const deleteTourReviewMutation = (options?: Partial<Options<DeleteTourReviewData>>): UseMutationOptions<DeleteTourReviewResponse, DeleteTourReviewError, Options<DeleteTourReviewData>> => {
  const mutationOptions: UseMutationOptions<DeleteTourReviewResponse, DeleteTourReviewError, Options<DeleteTourReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteTourReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const findTourReviewQueryKey = (options: Options<FindTourReviewData>) => createQueryKey('findTourReview', options);

/**
 * 축제 리뷰 단건 조회
 *
 * 본인이 작성한 축제 리뷰를 단건 조회합니다.
 */
export const findTourReviewOptions = (options: Options<FindTourReviewData>) => queryOptions<FindTourReviewResponse, FindTourReviewError, FindTourReviewResponse, ReturnType<typeof findTourReviewQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findTourReview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findTourReviewQueryKey(options)
});

/**
 * 축제 리뷰 수정
 *
 * 본인이 작성한 축제 리뷰를 전체 교체합니다.
 */
export const updateTourReviewMutation = (options?: Partial<Options<UpdateTourReviewData>>): UseMutationOptions<UpdateTourReviewResponse, UpdateTourReviewError, Options<UpdateTourReviewData>> => {
  const mutationOptions: UseMutationOptions<UpdateTourReviewResponse, UpdateTourReviewError, Options<UpdateTourReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await updateTourReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 회원 트래킹 정보 저장
 */
export const saveWelloTrackingMutation = (options?: Partial<Options<SaveWelloTrackingData>>): UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloTracking({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 좋아요 삭제
 */
export const deleteWelloLikeMutation = (options?: Partial<Options<DeleteWelloLikeData>>): UseMutationOptions<DeleteWelloLikeResponse, DeleteWelloLikeError, Options<DeleteWelloLikeData>> => {
  const mutationOptions: UseMutationOptions<DeleteWelloLikeResponse, DeleteWelloLikeError, Options<DeleteWelloLikeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteWelloLike({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 좋아요 등록
 */
export const saveWelloLikeMutation = (options?: Partial<Options<SaveWelloLikeData>>): UseMutationOptions<SaveWelloLikeResponse, SaveWelloLikeError, Options<SaveWelloLikeData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloLikeResponse, SaveWelloLikeError, Options<SaveWelloLikeData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloLike({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 헬퍼 등록
 */
export const saveWelloHelperMutation = (options?: Partial<Options<SaveWelloHelperData>>): UseMutationOptions<SaveWelloHelperResponse, SaveWelloHelperError, Options<SaveWelloHelperData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloHelperResponse, SaveWelloHelperError, Options<SaveWelloHelperData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloHelper({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 이벤트 참여
 */
export const saveWelloParticipationMutation = (options?: Partial<Options<SaveWelloParticipationData>>): UseMutationOptions<SaveWelloParticipationResponse, SaveWelloParticipationError, Options<SaveWelloParticipationData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloParticipationResponse, SaveWelloParticipationError, Options<SaveWelloParticipationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloParticipation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 가입 유저용 웰로 디바이스 정보 저장
 */
export const saveWelloDeviceInfoMutation = (options?: Partial<Options<SaveWelloDeviceInfoData>>): UseMutationOptions<SaveWelloDeviceInfoResponse, SaveWelloDeviceInfoError, Options<SaveWelloDeviceInfoData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloDeviceInfoResponse, SaveWelloDeviceInfoError, Options<SaveWelloDeviceInfoData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloDeviceInfo({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getWelloCommentListQueryKey = (options: Options<GetWelloCommentListData>) => createQueryKey('getWelloCommentList', options);

/**
 * 웰로 댓글 목록 조회
 */
export const getWelloCommentListOptions = (options: Options<GetWelloCommentListData>) => queryOptions<GetWelloCommentListResponse, GetWelloCommentListError, GetWelloCommentListResponse, ReturnType<typeof getWelloCommentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloCommentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloCommentListQueryKey(options)
});
export const getWelloCommentListInfiniteQueryKey = (options: Options<GetWelloCommentListData>): QueryKey<Options<GetWelloCommentListData>> => createQueryKey('getWelloCommentList', options, true);

/**
 * 웰로 댓글 목록 조회
 */
export const getWelloCommentListInfiniteOptions = (options: Options<GetWelloCommentListData>) => infiniteQueryOptions<GetWelloCommentListResponse, GetWelloCommentListError, InfiniteData<GetWelloCommentListResponse>, QueryKey<Options<GetWelloCommentListData>>, number | Pick<QueryKey<Options<GetWelloCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetWelloCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getWelloCommentList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloCommentListInfiniteQueryKey(options)
});

/**
 * 웰로 댓글 등록
 */
export const saveWelloCommentMutation = (options?: Partial<Options<SaveWelloCommentData>>): UseMutationOptions<SaveWelloCommentResponse2, SaveWelloCommentError, Options<SaveWelloCommentData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloCommentResponse2, SaveWelloCommentError, Options<SaveWelloCommentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 댓글 신고 등록
 */
export const saveWelloCommentReportMutation = (options?: Partial<Options<SaveWelloCommentReportData>>): UseMutationOptions<SaveWelloCommentReportResponse, SaveWelloCommentReportError, Options<SaveWelloCommentReportData>> => {
  const mutationOptions: UseMutationOptions<SaveWelloCommentReportResponse, SaveWelloCommentReportError, Options<SaveWelloCommentReportData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWelloCommentReport({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 재 업로드
 */
export const fileReUploadMutation = (options?: Partial<Options<FileReUploadData>>): UseMutationOptions<FileReUploadResponse, FileReUploadError, Options<FileReUploadData>> => {
  const mutationOptions: UseMutationOptions<FileReUploadResponse, FileReUploadError, Options<FileReUploadData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileReUpload({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 파일 복사
 */
export const fileCopyMutation = (options?: Partial<Options<FileCopyData>>): UseMutationOptions<FileCopyResponse, FileCopyError, Options<FileCopyData>> => {
  const mutationOptions: UseMutationOptions<FileCopyResponse, FileCopyError, Options<FileCopyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileCopy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 투표하기
 *
 * 설문에 투표합니다 (전체 질문 답변 한번에 제출)
 */
export const createPollVoteMutation = (options?: Partial<Options<CreatePollVoteData>>): UseMutationOptions<CreatePollVoteResponse, CreatePollVoteError, Options<CreatePollVoteData>> => {
  const mutationOptions: UseMutationOptions<CreatePollVoteResponse, CreatePollVoteError, Options<CreatePollVoteData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createPollVote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 제외정책-삭제
 *
 * 제외정책을 삭제합니다
 */
export const removeWishlistMutation = (options?: Partial<Options<RemoveWishlistData>>): UseMutationOptions<RemoveWishlistResponse, RemoveWishlistError, Options<RemoveWishlistData>> => {
  const mutationOptions: UseMutationOptions<RemoveWishlistResponse, RemoveWishlistError, Options<RemoveWishlistData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await removeWishlist({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 제외정책 등록
 *
 * 제외정책을 등록합니다
 */
export const saveWishlistMutation = (options?: Partial<Options<SaveWishlistData>>): UseMutationOptions<SaveWishlistResponse, SaveWishlistError, Options<SaveWishlistData>> => {
  const mutationOptions: UseMutationOptions<SaveWishlistResponse, SaveWishlistError, Options<SaveWishlistData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWishlist({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 채무자신고 내역 저장 (각종 정보 제공 동의 및 채무자신고내역 저장)
 */
export const saveReportMutation = (options?: Partial<Options<SaveReportData>>): UseMutationOptions<SaveReportResponse, SaveReportError, Options<SaveReportData>> => {
  const mutationOptions: UseMutationOptions<SaveReportResponse, SaveReportError, Options<SaveReportData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveReport({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getListPointAttendanceQueryKey = (options?: Options<GetListPointAttendanceData>) => createQueryKey('getListPointAttendance', options);

/**
 * 출석 내역 조회
 *
 * 출석 내역 목록을 조회합니다.
 */
export const getListPointAttendanceOptions = (options?: Options<GetListPointAttendanceData>) => queryOptions<GetListPointAttendanceResponse, GetListPointAttendanceError, GetListPointAttendanceResponse, ReturnType<typeof getListPointAttendanceQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getListPointAttendance({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListPointAttendanceQueryKey(options)
});

/**
 * 출석 체크
 *
 * 오늘 날짜로 출석 내역을 저장합니다.
 */
export const saveTodayAttendanceMutation = (options?: Partial<Options<SaveTodayAttendanceData>>): UseMutationOptions<SaveTodayAttendanceResponse, SaveTodayAttendanceError, Options<SaveTodayAttendanceData>> => {
  const mutationOptions: UseMutationOptions<SaveTodayAttendanceResponse, SaveTodayAttendanceError, Options<SaveTodayAttendanceData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveTodayAttendance({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProductMutation = (options?: Partial<Options<FeedbackPointMarketProductData>>): UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> => {
  const mutationOptions: UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await feedbackPointMarketProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 쿠폰 재발송
 */
export const reissueCouponMutation = (options?: Partial<Options<ReissueCouponData>>): UseMutationOptions<ReissueCouponResponse2, ReissueCouponError, Options<ReissueCouponData>> => {
  const mutationOptions: UseMutationOptions<ReissueCouponResponse2, ReissueCouponError, Options<ReissueCouponData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await reissueCoupon({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 주문 결제
 */
export const payPointMarketOrderMutation = (options?: Partial<Options<PayPointMarketOrderData>>): UseMutationOptions<PayPointMarketOrderResponse, PayPointMarketOrderError, Options<PayPointMarketOrderData>> => {
  const mutationOptions: UseMutationOptions<PayPointMarketOrderResponse, PayPointMarketOrderError, Options<PayPointMarketOrderData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await payPointMarketOrder({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Nice SafeKey 발급요청
 */
export const sendNiceSafeKeyMutation = (options?: Partial<Options<SendNiceSafeKeyData>>): UseMutationOptions<SendNiceSafeKeyResponse, SendNiceSafeKeyError, Options<SendNiceSafeKeyData>> => {
  const mutationOptions: UseMutationOptions<SendNiceSafeKeyResponse, SendNiceSafeKeyError, Options<SendNiceSafeKeyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await sendNiceSafeKey({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 회원 탈퇴
 *
 * 회원 탈퇴요청을 처리합니다
 */
export const resignMemberMutation = (options?: Partial<Options<ResignMemberData>>): UseMutationOptions<ResignMemberResponse, ResignMemberError, Options<ResignMemberData>> => {
  const mutationOptions: UseMutationOptions<ResignMemberResponse, ResignMemberError, Options<ResignMemberData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await resignMember({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 유저 프로필 이미지 업로드
 *
 * 유저 프로필 이미지를 업로드 한다.
 */
export const fileUpload1Mutation = (options?: Partial<Options<FileUpload1Data>>): UseMutationOptions<FileUpload1Response, FileUpload1Error, Options<FileUpload1Data>> => {
  const mutationOptions: UseMutationOptions<FileUpload1Response, FileUpload1Error, Options<FileUpload1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await fileUpload1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 스크랩 삭제
 */
export const deleteWishlistMutation = (options?: Partial<Options<DeleteWishlistData>>): UseMutationOptions<DeleteWishlistResponse, DeleteWishlistError, Options<DeleteWishlistData>> => {
  const mutationOptions: UseMutationOptions<DeleteWishlistResponse, DeleteWishlistError, Options<DeleteWishlistData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteWishlist({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 스크랩 등록
 */
export const saveWishlist1Mutation = (options?: Partial<Options<SaveWishlist1Data>>): UseMutationOptions<SaveWishlist1Response, SaveWishlist1Error, Options<SaveWishlist1Data>> => {
  const mutationOptions: UseMutationOptions<SaveWishlist1Response, SaveWishlist1Error, Options<SaveWishlist1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveWishlist1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * KB 연동 체크
 */
export const kbMemberCheckMutation = (options?: Partial<Options<KbMemberCheckData>>): UseMutationOptions<KbMemberCheckResponse, KbMemberCheckError, Options<KbMemberCheckData>> => {
  const mutationOptions: UseMutationOptions<KbMemberCheckResponse, KbMemberCheckError, Options<KbMemberCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await kbMemberCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로 사용자 차단 - By Community
 */
export const blockWelloMemberByCommunityMutation = (options?: Partial<Options<BlockWelloMemberByCommunityData>>): UseMutationOptions<BlockWelloMemberByCommunityResponse, BlockWelloMemberByCommunityError, Options<BlockWelloMemberByCommunityData>> => {
  const mutationOptions: UseMutationOptions<BlockWelloMemberByCommunityResponse, BlockWelloMemberByCommunityError, Options<BlockWelloMemberByCommunityData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await blockWelloMemberByCommunity({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 최근 인증된 멤버 CI 조회
 */
export const getLatestCompletedCiMutation = (options?: Partial<Options<GetLatestCompletedCiData>>): UseMutationOptions<GetLatestCompletedCiResponse, GetLatestCompletedCiError, Options<GetLatestCompletedCiData>> => {
  const mutationOptions: UseMutationOptions<GetLatestCompletedCiResponse, GetLatestCompletedCiError, Options<GetLatestCompletedCiData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getLatestCompletedCi({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 최근 인증된 멤버 정보 조회
 */
export const getLatestCompletedMutation = (options?: Partial<Options<GetLatestCompletedData>>): UseMutationOptions<GetLatestCompletedResponse, GetLatestCompletedError, Options<GetLatestCompletedData>> => {
  const mutationOptions: UseMutationOptions<GetLatestCompletedResponse, GetLatestCompletedError, Options<GetLatestCompletedData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getLatestCompleted({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 본인인증 정보 복호화
 */
export const decryptMemberVerificationMutation = (options?: Partial<Options<DecryptMemberVerificationData>>): UseMutationOptions<DecryptMemberVerificationResponse2, DecryptMemberVerificationError, Options<DecryptMemberVerificationData>> => {
  const mutationOptions: UseMutationOptions<DecryptMemberVerificationResponse2, DecryptMemberVerificationError, Options<DecryptMemberVerificationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await decryptMemberVerification({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getMemberTermAgreementByAgreementTypeQueryKey = (options: Options<GetMemberTermAgreementByAgreementTypeData>) => createQueryKey('getMemberTermAgreementByAgreementType', options);

/**
 * 약관 동의 여부 조회
 */
export const getMemberTermAgreementByAgreementTypeOptions = (options: Options<GetMemberTermAgreementByAgreementTypeData>) => queryOptions<GetMemberTermAgreementByAgreementTypeResponse, GetMemberTermAgreementByAgreementTypeError, GetMemberTermAgreementByAgreementTypeResponse, ReturnType<typeof getMemberTermAgreementByAgreementTypeQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMemberTermAgreementByAgreementType({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMemberTermAgreementByAgreementTypeQueryKey(options)
});

/**
 * 약관 동의 저장/수정
 */
export const saveOrUpdateMemberTermAgreementMutation = (options?: Partial<Options<SaveOrUpdateMemberTermAgreementData>>): UseMutationOptions<SaveOrUpdateMemberTermAgreementResponse, SaveOrUpdateMemberTermAgreementError, Options<SaveOrUpdateMemberTermAgreementData>> => {
  const mutationOptions: UseMutationOptions<SaveOrUpdateMemberTermAgreementResponse, SaveOrUpdateMemberTermAgreementError, Options<SaveOrUpdateMemberTermAgreementData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveOrUpdateMemberTermAgreement({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const logoutMemberMutation = (options?: Partial<Options<LogoutMemberData>>): UseMutationOptions<LogoutMemberResponse, LogoutMemberError, Options<LogoutMemberData>> => {
  const mutationOptions: UseMutationOptions<LogoutMemberResponse, LogoutMemberError, Options<LogoutMemberData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await logoutMember({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 지역 필터 저장
 */
export const noticeListMutation = (options?: Partial<Options<NoticeListData>>): UseMutationOptions<NoticeListResponse, NoticeListError, Options<NoticeListData>> => {
  const mutationOptions: UseMutationOptions<NoticeListResponse, NoticeListError, Options<NoticeListData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await noticeList({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 *  KB 기본 필터 저장
 */
export const saveKbFilterMutation = (options?: Partial<Options<SaveKbFilterData>>): UseMutationOptions<SaveKbFilterResponse, SaveKbFilterError, Options<SaveKbFilterData>> => {
  const mutationOptions: UseMutationOptions<SaveKbFilterResponse, SaveKbFilterError, Options<SaveKbFilterData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveKbFilter({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const interestFilterQueryKey = (options?: Options<InterestFilterData>) => createQueryKey('interestFilter', options);

/**
 * 관심 필터 조회
 */
export const interestFilterOptions = (options?: Options<InterestFilterData>) => queryOptions<InterestFilterResponse, InterestFilterError, InterestFilterResponse, ReturnType<typeof interestFilterQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await interestFilter({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: interestFilterQueryKey(options)
});

/**
 * 관심 필터 코드 저장
 */
export const saveInterestFilterMutation = (options?: Partial<Options<SaveInterestFilterData>>): UseMutationOptions<SaveInterestFilterResponse, SaveInterestFilterError, Options<SaveInterestFilterData>> => {
  const mutationOptions: UseMutationOptions<SaveInterestFilterResponse, SaveInterestFilterError, Options<SaveInterestFilterData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveInterestFilter({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 맞춤 정보 저장
 */
export const putFitFilterMutation = (options?: Partial<Options<PutFitFilterData>>): UseMutationOptions<PutFitFilterResponse, PutFitFilterError, Options<PutFitFilterData>> => {
  const mutationOptions: UseMutationOptions<PutFitFilterResponse, PutFitFilterError, Options<PutFitFilterData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await putFitFilter({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 회원가입 맞춤 정보 저장
 */
export const saveFitFilterMutation = (options?: Partial<Options<SaveFitFilterData>>): UseMutationOptions<SaveFitFilterResponse, SaveFitFilterError, Options<SaveFitFilterData>> => {
  const mutationOptions: UseMutationOptions<SaveFitFilterResponse, SaveFitFilterError, Options<SaveFitFilterData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveFitFilter({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const memberAccountListQueryKey = (options?: Options<MemberAccountListData>) => createQueryKey('memberAccountList', options);

/**
 * 계좌 목록 조회
 */
export const memberAccountListOptions = (options?: Options<MemberAccountListData>) => queryOptions<MemberAccountListResponse, MemberAccountListError, MemberAccountListResponse, ReturnType<typeof memberAccountListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberAccountList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberAccountListQueryKey(options)
});

/**
 * 계좌 등록/변경
 */
export const saveMemberAccountMutation = (options?: Partial<Options<SaveMemberAccountData>>): UseMutationOptions<SaveMemberAccountResponse, SaveMemberAccountError, Options<SaveMemberAccountData>> => {
  const mutationOptions: UseMutationOptions<SaveMemberAccountResponse, SaveMemberAccountError, Options<SaveMemberAccountData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveMemberAccount({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getLocalfestaParticipantInfoQueryKey = (options?: Options<GetLocalfestaParticipantInfoData>) => createQueryKey('getLocalfestaParticipantInfo', options);

/**
 * 웰로페 참여 정보 조회
 */
export const getLocalfestaParticipantInfoOptions = (options?: Options<GetLocalfestaParticipantInfoData>) => queryOptions<GetLocalfestaParticipantInfoResponse, GetLocalfestaParticipantInfoError, GetLocalfestaParticipantInfoResponse, ReturnType<typeof getLocalfestaParticipantInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getLocalfestaParticipantInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLocalfestaParticipantInfoQueryKey(options)
});

/**
 * 웰로페 참여 등록
 */
export const saveLocalfestaParticipantMutation = (options?: Partial<Options<SaveLocalfestaParticipantData>>): UseMutationOptions<SaveLocalfestaParticipantResponse, SaveLocalfestaParticipantError, Options<SaveLocalfestaParticipantData>> => {
  const mutationOptions: UseMutationOptions<SaveLocalfestaParticipantResponse, SaveLocalfestaParticipantError, Options<SaveLocalfestaParticipantData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveLocalfestaParticipant({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 문의 등록
 *
 * 상품 문의 등록
 */
export const saveInquiryMutation = (options?: Partial<Options<SaveInquiryData>>): UseMutationOptions<SaveInquiryResponse, SaveInquiryError, Options<SaveInquiryData>> => {
  const mutationOptions: UseMutationOptions<SaveInquiryResponse, SaveInquiryError, Options<SaveInquiryData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveInquiry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 결제 취소
 *
 * 결제를 취소합니다.
 */
export const cancelOrder1Mutation = (options?: Partial<Options<CancelOrder1Data>>): UseMutationOptions<CancelOrder1Response, CancelOrder1Error, Options<CancelOrder1Data>> => {
  const mutationOptions: UseMutationOptions<CancelOrder1Response, CancelOrder1Error, Options<CancelOrder1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await cancelOrder1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 결제 승인
 *
 * 결제를 승인합니다.
 *
 * @deprecated
 */
export const approvePaymentMutation = (options?: Partial<Options<ApprovePaymentData>>): UseMutationOptions<ApprovePaymentResponse2, ApprovePaymentError, Options<ApprovePaymentData>> => {
  const mutationOptions: UseMutationOptions<ApprovePaymentResponse2, ApprovePaymentError, Options<ApprovePaymentData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await approvePayment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 리뷰 작성
 *
 * 주문 상품에 대한 리뷰를 작성한다.
 */
export const saveReviewMutation = (options?: Partial<Options<SaveReviewData>>): UseMutationOptions<SaveReviewResponse, SaveReviewError, Options<SaveReviewData>> => {
  const mutationOptions: UseMutationOptions<SaveReviewResponse, SaveReviewError, Options<SaveReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 쿠폰 다운로드
 *
 * 쿠폰 개별 다운로드
 */
export const downloadCouponMutation = (options?: Partial<Options<DownloadCouponData>>): UseMutationOptions<DownloadCouponResponse2, DownloadCouponError, Options<DownloadCouponData>> => {
  const mutationOptions: UseMutationOptions<DownloadCouponResponse2, DownloadCouponError, Options<DownloadCouponData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await downloadCoupon({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 쿠폰 일괄 다운로드
 *
 * 쿠폰 일괄 다운로드
 */
export const downloadAllCouponsMutation = (options?: Partial<Options<DownloadAllCouponsData>>): UseMutationOptions<DownloadAllCouponsResponse2, DownloadAllCouponsError, Options<DownloadAllCouponsData>> => {
  const mutationOptions: UseMutationOptions<DownloadAllCouponsResponse2, DownloadAllCouponsError, Options<DownloadAllCouponsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await downloadAllCoupons({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품별 적용 가능 쿠폰 조회
 *
 * 상품별 적용 가능 쿠폰 조회
 */
export const findApplicableCouponsForProductsMutation = (options?: Partial<Options<FindApplicableCouponsForProductsData>>): UseMutationOptions<FindApplicableCouponsForProductsResponse2, FindApplicableCouponsForProductsError, Options<FindApplicableCouponsForProductsData>> => {
  const mutationOptions: UseMutationOptions<FindApplicableCouponsForProductsResponse2, FindApplicableCouponsForProductsError, Options<FindApplicableCouponsForProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await findApplicableCouponsForProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 다건 삭제
 *
 * 장바구니 아이템 다건 삭제.
 */
export const deleteCartItemsMutation = (options?: Partial<Options<DeleteCartItemsData>>): UseMutationOptions<DeleteCartItemsResponse, DeleteCartItemsError, Options<DeleteCartItemsData>> => {
  const mutationOptions: UseMutationOptions<DeleteCartItemsResponse, DeleteCartItemsError, Options<DeleteCartItemsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteCartItems({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const findCartItemsQueryKey = (options?: Options<FindCartItemsData>) => createQueryKey('findCartItems', options);

/**
 * 장바구니 목록 조회
 *
 * 장바구니 목록 조회.
 */
export const findCartItemsOptions = (options?: Options<FindCartItemsData>) => queryOptions<FindCartItemsResponse, FindCartItemsError, FindCartItemsResponse, ReturnType<typeof findCartItemsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findCartItems({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findCartItemsQueryKey(options)
});

/**
 * 장바구니 상품 추가
 *
 * 장바구니 상품 추가.
 */
export const saveCartItemMutation = (options?: Partial<Options<SaveCartItemData>>): UseMutationOptions<SaveCartItemResponse, SaveCartItemError, Options<SaveCartItemData>> => {
  const mutationOptions: UseMutationOptions<SaveCartItemResponse, SaveCartItemError, Options<SaveCartItemData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveCartItem({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 사전주문 생성 (장바구니 → 주문서)
 *
 * 사전주문 생성.
 *
 * <p>장바구니에서 선택한 아이템으로 사전주문을 생성하고, 주문서 화면에 필요한 데이터를 반환한다.</p>
 */
export const createBeforeOrderMutation = (options?: Partial<Options<CreateBeforeOrderData>>): UseMutationOptions<CreateBeforeOrderResponse2, CreateBeforeOrderError, Options<CreateBeforeOrderData>> => {
  const mutationOptions: UseMutationOptions<CreateBeforeOrderResponse2, CreateBeforeOrderError, Options<CreateBeforeOrderData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createBeforeOrder({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 사전주문 더미 결제 완료 (테스트용)
 *
 * 사전주문 더미 결제 완료 (테스트용, PG 없이 주문 생성).
 *
 * <p>체크아웃 완료된 사전주문을 PG 없이 정식 주문으로 전환한다.
 * 포인트 차감, 쿠폰 사용, 적립 포인트 유예 등록이 모두 처리된다.</p>
 */
export const dummyCompleteMutation = (options?: Partial<Options<DummyCompleteData>>): UseMutationOptions<DummyCompleteResponse, DummyCompleteError, Options<DummyCompleteData>> => {
  const mutationOptions: UseMutationOptions<DummyCompleteResponse, DummyCompleteError, Options<DummyCompleteData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await dummyComplete({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 전체 반품 (같은 상품의 모든 옵션)
 */
export const returnProductMutation = (options?: Partial<Options<ReturnProductData>>): UseMutationOptions<ReturnProductResponse, ReturnProductError, Options<ReturnProductData>> => {
  const mutationOptions: UseMutationOptions<ReturnProductResponse, ReturnProductError, Options<ReturnProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await returnProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 전체 교환 (같은 상품의 모든 옵션)
 */
export const exchangeProductMutation = (options?: Partial<Options<ExchangeProductData>>): UseMutationOptions<ExchangeProductResponse, ExchangeProductError, Options<ExchangeProductData>> => {
  const mutationOptions: UseMutationOptions<ExchangeProductResponse, ExchangeProductError, Options<ExchangeProductData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await exchangeProduct({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 반품 요청
 *
 * 반품 요청.
 */
export const requestReturnMutation = (options?: Partial<Options<RequestReturnData>>): UseMutationOptions<RequestReturnResponse, RequestReturnError, Options<RequestReturnData>> => {
  const mutationOptions: UseMutationOptions<RequestReturnResponse, RequestReturnError, Options<RequestReturnData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestReturn({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 개별/선택 반품 (선택한 orderProduct 일괄)
 */
export const returnOrderProductsMutation = (options?: Partial<Options<ReturnOrderProductsData>>): UseMutationOptions<ReturnOrderProductsResponse, ReturnOrderProductsError, Options<ReturnOrderProductsData>> => {
  const mutationOptions: UseMutationOptions<ReturnOrderProductsResponse, ReturnOrderProductsError, Options<ReturnOrderProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await returnOrderProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 개별/선택 교환 (선택한 orderProduct 일괄)
 */
export const exchangeOrderProductsMutation = (options?: Partial<Options<ExchangeOrderProductsData>>): UseMutationOptions<ExchangeOrderProductsResponse, ExchangeOrderProductsError, Options<ExchangeOrderProductsData>> => {
  const mutationOptions: UseMutationOptions<ExchangeOrderProductsResponse, ExchangeOrderProductsError, Options<ExchangeOrderProductsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await exchangeOrderProducts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 포스트백 신호(Pinkey) 전달
 */
export const sendPinkeyMutation = (options?: Partial<Options<SendPinkeyData>>): UseMutationOptions<SendPinkeyResponse, SendPinkeyError, Options<SendPinkeyData>> => {
  const mutationOptions: UseMutationOptions<SendPinkeyResponse, SendPinkeyError, Options<SendPinkeyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await sendPinkey({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 아이템 삭제
 */
export const deleteCartItems1Mutation = (options?: Partial<Options<DeleteCartItems1Data>>): UseMutationOptions<DeleteCartItems1Response, DeleteCartItems1Error, Options<DeleteCartItems1Data>> => {
  const mutationOptions: UseMutationOptions<DeleteCartItems1Response, DeleteCartItems1Error, Options<DeleteCartItems1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteCartItems1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const findAllByMemberOAuthIdQueryKey = (options?: Options<FindAllByMemberOAuthIdData>) => createQueryKey('findAllByMemberOAuthId', options);

/**
 * 장바구니 목록 조회
 */
export const findAllByMemberOAuthIdOptions = (options?: Options<FindAllByMemberOAuthIdData>) => queryOptions<FindAllByMemberOAuthIdResponse, FindAllByMemberOAuthIdError, FindAllByMemberOAuthIdResponse, ReturnType<typeof findAllByMemberOAuthIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findAllByMemberOAuthId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findAllByMemberOAuthIdQueryKey(options)
});

/**
 * 장바구니 아이템 등록
 */
export const addCartItemMutation = (options?: Partial<Options<AddCartItemData>>): UseMutationOptions<AddCartItemResponse, AddCartItemError, Options<AddCartItemData>> => {
  const mutationOptions: UseMutationOptions<AddCartItemResponse, AddCartItemError, Options<AddCartItemData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await addCartItem({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 기부예약
 */
export const createDonationReservationMutation = (options?: Partial<Options<CreateDonationReservationData>>): UseMutationOptions<CreateDonationReservationResponse, CreateDonationReservationError, Options<CreateDonationReservationData>> => {
  const mutationOptions: UseMutationOptions<CreateDonationReservationResponse, CreateDonationReservationError, Options<CreateDonationReservationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createDonationReservation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getDeliveryAddressListQueryKey = (options: Options<GetDeliveryAddressListData>) => createQueryKey('getDeliveryAddressList', options);

/**
 * 배송지 목록 조회
 */
export const getDeliveryAddressListOptions = (options: Options<GetDeliveryAddressListData>) => queryOptions<GetDeliveryAddressListResponse, GetDeliveryAddressListError, GetDeliveryAddressListResponse, ReturnType<typeof getDeliveryAddressListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDeliveryAddressList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryAddressListQueryKey(options)
});
export const getDeliveryAddressListInfiniteQueryKey = (options: Options<GetDeliveryAddressListData>): QueryKey<Options<GetDeliveryAddressListData>> => createQueryKey('getDeliveryAddressList', options, true);

/**
 * 배송지 목록 조회
 */
export const getDeliveryAddressListInfiniteOptions = (options: Options<GetDeliveryAddressListData>) => infiniteQueryOptions<GetDeliveryAddressListResponse, GetDeliveryAddressListError, InfiniteData<GetDeliveryAddressListResponse>, QueryKey<Options<GetDeliveryAddressListData>>, number | Pick<QueryKey<Options<GetDeliveryAddressListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetDeliveryAddressListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getDeliveryAddressList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryAddressListInfiniteQueryKey(options)
});

/**
 * 배송지 등록
 */
export const createDeliveryAddressMutation = (options?: Partial<Options<CreateDeliveryAddressData>>): UseMutationOptions<CreateDeliveryAddressResponse2, CreateDeliveryAddressError, Options<CreateDeliveryAddressData>> => {
  const mutationOptions: UseMutationOptions<CreateDeliveryAddressResponse2, CreateDeliveryAddressError, Options<CreateDeliveryAddressData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createDeliveryAddress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 회원가입
 */
export const createMemberMutation = (options?: Partial<Options<CreateMemberData>>): UseMutationOptions<CreateMemberResponse, CreateMemberError, Options<CreateMemberData>> => {
  const mutationOptions: UseMutationOptions<CreateMemberResponse, CreateMemberError, Options<CreateMemberData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createMember({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 기부 프로세스 처리 (기부만)
 */
export const processDonationMutation = (options?: Partial<Options<ProcessDonationData>>): UseMutationOptions<ProcessDonationResponse2, ProcessDonationError, Options<ProcessDonationData>> => {
  const mutationOptions: UseMutationOptions<ProcessDonationResponse2, ProcessDonationError, Options<ProcessDonationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await processDonation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 기부 프로세스 처리 (장바구니)
 */
export const processDonationCartMutation = (options?: Partial<Options<ProcessDonationCartData>>): UseMutationOptions<ProcessDonationCartResponse, ProcessDonationCartError, Options<ProcessDonationCartData>> => {
  const mutationOptions: UseMutationOptions<ProcessDonationCartResponse, ProcessDonationCartError, Options<ProcessDonationCartData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await processDonationCart({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 기부 수납 완료 처리
 */
export const completeDonationMutation = (options?: Partial<Options<CompleteDonationData>>): UseMutationOptions<CompleteDonationResponse2, CompleteDonationError, Options<CompleteDonationData>> => {
  const mutationOptions: UseMutationOptions<CompleteDonationResponse2, CompleteDonationError, Options<CompleteDonationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await completeDonation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 기부가능 여부 조회
 */
export const checkDonationAvailableMutation = (options?: Partial<Options<CheckDonationAvailableData>>): UseMutationOptions<CheckDonationAvailableResponse, CheckDonationAvailableError, Options<CheckDonationAvailableData>> => {
  const mutationOptions: UseMutationOptions<CheckDonationAvailableResponse, CheckDonationAvailableError, Options<CheckDonationAvailableData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await checkDonationAvailable({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 이전 기부 이력 수납 완료 처리
 */
export const beforeCompleteDonationMutation = (options?: Partial<Options<BeforeCompleteDonationData>>): UseMutationOptions<BeforeCompleteDonationResponse, BeforeCompleteDonationError, Options<BeforeCompleteDonationData>> => {
  const mutationOptions: UseMutationOptions<BeforeCompleteDonationResponse, BeforeCompleteDonationError, Options<BeforeCompleteDonationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await beforeCompleteDonation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getHomeInquiryListQueryKey = (options: Options<GetHomeInquiryListData>) => createQueryKey('getHomeInquiryList', options);

/**
 * 1:1 문의 전체 목록 조회
 */
export const getHomeInquiryListOptions = (options: Options<GetHomeInquiryListData>) => queryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, GetHomeInquiryListResponse, ReturnType<typeof getHomeInquiryListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInquiryList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInquiryListQueryKey(options)
});
export const getHomeInquiryListInfiniteQueryKey = (options: Options<GetHomeInquiryListData>): QueryKey<Options<GetHomeInquiryListData>> => createQueryKey('getHomeInquiryList', options, true);

/**
 * 1:1 문의 전체 목록 조회
 */
export const getHomeInquiryListInfiniteOptions = (options: Options<GetHomeInquiryListData>) => infiniteQueryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, InfiniteData<GetHomeInquiryListResponse>, QueryKey<Options<GetHomeInquiryListData>>, number | Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getHomeInquiryList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInquiryListInfiniteQueryKey(options)
});

/**
 * 1:1 문의 등록
 */
export const saveHomeInquiry1Mutation = (options?: Partial<Options<SaveHomeInquiry1Data>>): UseMutationOptions<SaveHomeInquiry1Response, SaveHomeInquiry1Error, Options<SaveHomeInquiry1Data>> => {
  const mutationOptions: UseMutationOptions<SaveHomeInquiry1Response, SaveHomeInquiry1Error, Options<SaveHomeInquiry1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveHomeInquiry1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 이벤트 신청
 */
export const applyHomeDonationEventMutation = (options?: Partial<Options<ApplyHomeDonationEventData>>): UseMutationOptions<ApplyHomeDonationEventResponse2, ApplyHomeDonationEventError, Options<ApplyHomeDonationEventData>> => {
  const mutationOptions: UseMutationOptions<ApplyHomeDonationEventResponse2, ApplyHomeDonationEventError, Options<ApplyHomeDonationEventData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await applyHomeDonationEvent({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 사전뽑기
 */
export const drawEventPreselectionMutation = (options?: Partial<Options<DrawEventPreselectionData>>): UseMutationOptions<DrawEventPreselectionResponse, DrawEventPreselectionError, Options<DrawEventPreselectionData>> => {
  const mutationOptions: UseMutationOptions<DrawEventPreselectionResponse, DrawEventPreselectionError, Options<DrawEventPreselectionData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await drawEventPreselection({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 모든 선물 상자 열기
 */
export const openAllEventGiftBoxMutation = (options?: Partial<Options<OpenAllEventGiftBoxData>>): UseMutationOptions<OpenAllEventGiftBoxResponse2, OpenAllEventGiftBoxError, Options<OpenAllEventGiftBoxData>> => {
  const mutationOptions: UseMutationOptions<OpenAllEventGiftBoxResponse2, OpenAllEventGiftBoxError, Options<OpenAllEventGiftBoxData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await openAllEventGiftBox({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 피드 목록 조회 (회원)
 *
 * 회원 맞춤 필터가 적용된 피드 목록을 조회합니다
 */
export const getFeedListMutation = (options?: Partial<Options<GetFeedListData>>): UseMutationOptions<GetFeedListResponse, GetFeedListError, Options<GetFeedListData>> => {
  const mutationOptions: UseMutationOptions<GetFeedListResponse, GetFeedListError, Options<GetFeedListData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getFeedList({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 학자금대출 신용회복 주민번호 사전 확인 요청
 */
export const getDlpSeoulLoanCrdtRcvrCheckMutation = (options?: Partial<Options<GetDlpSeoulLoanCrdtRcvrCheckData>>): UseMutationOptions<GetDlpSeoulLoanCrdtRcvrCheckResponse, GetDlpSeoulLoanCrdtRcvrCheckError, Options<GetDlpSeoulLoanCrdtRcvrCheckData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulLoanCrdtRcvrCheckResponse, GetDlpSeoulLoanCrdtRcvrCheckError, Options<GetDlpSeoulLoanCrdtRcvrCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulLoanCrdtRcvrCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 학자금대출 신용회복 신청
 */
export const getDlpSeoulLoanCrdtRcvrApplyMutation = (options?: Partial<Options<GetDlpSeoulLoanCrdtRcvrApplyData>>): UseMutationOptions<GetDlpSeoulLoanCrdtRcvrApplyResponse, GetDlpSeoulLoanCrdtRcvrApplyError, Options<GetDlpSeoulLoanCrdtRcvrApplyData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulLoanCrdtRcvrApplyResponse, GetDlpSeoulLoanCrdtRcvrApplyError, Options<GetDlpSeoulLoanCrdtRcvrApplyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulLoanCrdtRcvrApply({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 고립•은둔청년 지원사업 주민번호 사전 확인 요청
 */
export const getDlpSeoulIsltYoungSprtCheckMutation = (options?: Partial<Options<GetDlpSeoulIsltYoungSprtCheckData>>): UseMutationOptions<GetDlpSeoulIsltYoungSprtCheckResponse, GetDlpSeoulIsltYoungSprtCheckError, Options<GetDlpSeoulIsltYoungSprtCheckData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulIsltYoungSprtCheckResponse, GetDlpSeoulIsltYoungSprtCheckError, Options<GetDlpSeoulIsltYoungSprtCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulIsltYoungSprtCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 고립•은둔청년 지원사업 신청
 */
export const getDlpSeoulIsltYoungSprtApplyMutation = (options?: Partial<Options<GetDlpSeoulIsltYoungSprtApplyData>>): UseMutationOptions<GetDlpSeoulIsltYoungSprtApplyResponse, GetDlpSeoulIsltYoungSprtApplyError, Options<GetDlpSeoulIsltYoungSprtApplyData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulIsltYoungSprtApplyResponse, GetDlpSeoulIsltYoungSprtApplyError, Options<GetDlpSeoulIsltYoungSprtApplyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulIsltYoungSprtApply({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 청년문화 패스 주민번호 사전 확인 요청
 */
export const getDlpSeoulCltrPassCheckMutation = (options?: Partial<Options<GetDlpSeoulCltrPassCheckData>>): UseMutationOptions<GetDlpSeoulCltrPassCheckResponse, GetDlpSeoulCltrPassCheckError, Options<GetDlpSeoulCltrPassCheckData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulCltrPassCheckResponse, GetDlpSeoulCltrPassCheckError, Options<GetDlpSeoulCltrPassCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulCltrPassCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 청년문화 패스 신청
 */
export const getDlpSeoulCulturePassApplyMutation = (options?: Partial<Options<GetDlpSeoulCulturePassApplyData>>): UseMutationOptions<GetDlpSeoulCulturePassApplyResponse, GetDlpSeoulCulturePassApplyError, Options<GetDlpSeoulCulturePassApplyData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulCulturePassApplyResponse, GetDlpSeoulCulturePassApplyError, Options<GetDlpSeoulCulturePassApplyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulCulturePassApply({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 신청한 정책 보기
 */
export const getDlpSeoulAppliedPolicyListMutation = (options?: Partial<Options<GetDlpSeoulAppliedPolicyListData>>): UseMutationOptions<GetDlpSeoulAppliedPolicyListResponse, GetDlpSeoulAppliedPolicyListError, Options<GetDlpSeoulAppliedPolicyListData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulAppliedPolicyListResponse, GetDlpSeoulAppliedPolicyListError, Options<GetDlpSeoulAppliedPolicyListData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulAppliedPolicyList({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 계정 확인 및 로그인
 *
 * 서울특별시 계정 저장 여부를 반환하고 로그인을 시도합니다.
 */
export const getDlpSeoulAccountAndRequestLoginMutation = (options?: Partial<Options<GetDlpSeoulAccountAndRequestLoginData>>): UseMutationOptions<GetDlpSeoulAccountAndRequestLoginResponse, GetDlpSeoulAccountAndRequestLoginError, Options<GetDlpSeoulAccountAndRequestLoginData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulAccountAndRequestLoginResponse, GetDlpSeoulAccountAndRequestLoginError, Options<GetDlpSeoulAccountAndRequestLoginData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulAccountAndRequestLogin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 본인인증 요청
 *
 * 서울특별시 본인인증을 시도합니다.
 */
export const requestDlpSeoulVerificationMutation = (options?: Partial<Options<RequestDlpSeoulVerificationData>>): UseMutationOptions<RequestDlpSeoulVerificationResponse, RequestDlpSeoulVerificationError, Options<RequestDlpSeoulVerificationData>> => {
  const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationResponse, RequestDlpSeoulVerificationError, Options<RequestDlpSeoulVerificationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestDlpSeoulVerification({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 본인인증 확인 요청
 *
 * 서울특별시 본인인증 확인을 시도합니다.
 */
export const requestDlpSeoulVerificationCheckMutation = (options?: Partial<Options<RequestDlpSeoulVerificationCheckData>>): UseMutationOptions<RequestDlpSeoulVerificationCheckResponse, RequestDlpSeoulVerificationCheckError, Options<RequestDlpSeoulVerificationCheckData>> => {
  const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationCheckResponse, RequestDlpSeoulVerificationCheckError, Options<RequestDlpSeoulVerificationCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestDlpSeoulVerificationCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 비밀번호 변경 본인인증 요청
 *
 * 서울특별시 비밀번호 변경 본인인증을 시도합니다.
 */
export const requestDlpSeoulVerificationForPasswordMutation = (options?: Partial<Options<RequestDlpSeoulVerificationForPasswordData>>): UseMutationOptions<RequestDlpSeoulVerificationForPasswordResponse, RequestDlpSeoulVerificationForPasswordError, Options<RequestDlpSeoulVerificationForPasswordData>> => {
  const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationForPasswordResponse, RequestDlpSeoulVerificationForPasswordError, Options<RequestDlpSeoulVerificationForPasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestDlpSeoulVerificationForPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 비밀번호 변경 본인인증 확인 요청
 *
 * 서울특별시 비밀번호 변경 본인인증 확인을 시도합니다.
 */
export const requestDlpSeoulVerificationCheckForPasswordMutation = (options?: Partial<Options<RequestDlpSeoulVerificationCheckForPasswordData>>): UseMutationOptions<RequestDlpSeoulVerificationCheckForPasswordResponse, RequestDlpSeoulVerificationCheckForPasswordError, Options<RequestDlpSeoulVerificationCheckForPasswordData>> => {
  const mutationOptions: UseMutationOptions<RequestDlpSeoulVerificationCheckForPasswordResponse, RequestDlpSeoulVerificationCheckForPasswordError, Options<RequestDlpSeoulVerificationCheckForPasswordData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestDlpSeoulVerificationCheckForPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 관련 회원 정보 조회
 */
export const getDlpSeoulMemberInfoMutation = (options?: Partial<Options<GetDlpSeoulMemberInfoData>>): UseMutationOptions<GetDlpSeoulMemberInfoResponse, GetDlpSeoulMemberInfoError, Options<GetDlpSeoulMemberInfoData>> => {
  const mutationOptions: UseMutationOptions<GetDlpSeoulMemberInfoResponse, GetDlpSeoulMemberInfoError, Options<GetDlpSeoulMemberInfoData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await getDlpSeoulMemberInfo({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 로그인 요청
 *
 * 서울특별시 로그인 요청을 시도합니다.
 */
export const requestLoginMutation = (options?: Partial<Options<RequestLoginData>>): UseMutationOptions<RequestLoginResponse, RequestLoginError, Options<RequestLoginData>> => {
  const mutationOptions: UseMutationOptions<RequestLoginResponse, RequestLoginError, Options<RequestLoginData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestLogin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 회원가입 요청
 *
 * 서울특별시 회원가입을 시도합니다.
 */
export const createAccountMutation = (options?: Partial<Options<CreateAccountData>>): UseMutationOptions<CreateAccountResponse, CreateAccountError, Options<CreateAccountData>> => {
  const mutationOptions: UseMutationOptions<CreateAccountResponse, CreateAccountError, Options<CreateAccountData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await createAccount({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * DLP 서울특별시 아이디 중복 확인 요청
 *
 * 서울특별시 아이디 중복 확인을 시도합니다.
 */
export const requestDlpSeoulIdCheckMutation = (options?: Partial<Options<RequestDlpSeoulIdCheckData>>): UseMutationOptions<RequestDlpSeoulIdCheckResponse, RequestDlpSeoulIdCheckError, Options<RequestDlpSeoulIdCheckData>> => {
  const mutationOptions: UseMutationOptions<RequestDlpSeoulIdCheckResponse, RequestDlpSeoulIdCheckError, Options<RequestDlpSeoulIdCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await requestDlpSeoulIdCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 가입 과정 Step 1.1 - 본인인증
 *
 * 휴대폰 본인인증을 합니다. 사용자 ID 을 찾는데도 사용할 수 있습니다.
 */
export const verifyDlpGyeonggiAccountIdentificationMutation = (options?: Partial<Options<VerifyDlpGyeonggiAccountIdentificationData>>): UseMutationOptions<VerifyDlpGyeonggiAccountIdentificationResponse, VerifyDlpGyeonggiAccountIdentificationError, Options<VerifyDlpGyeonggiAccountIdentificationData>> => {
  const mutationOptions: UseMutationOptions<VerifyDlpGyeonggiAccountIdentificationResponse, VerifyDlpGyeonggiAccountIdentificationError, Options<VerifyDlpGyeonggiAccountIdentificationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await verifyDlpGyeonggiAccountIdentification({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 가입 과정 Step 1.2 - 본인인증 확인 및 가입 여부 확인
 *
 * SMS 인증 코드 값을 입력해 가입 여부를 확인하고 다음 단계를 진행할 준비를 합니다.
 */
export const checkDlpGyeonggiAccountIdentificationMutation = (options?: Partial<Options<CheckDlpGyeonggiAccountIdentificationData>>): UseMutationOptions<CheckDlpGyeonggiAccountIdentificationResponse, CheckDlpGyeonggiAccountIdentificationError, Options<CheckDlpGyeonggiAccountIdentificationData>> => {
  const mutationOptions: UseMutationOptions<CheckDlpGyeonggiAccountIdentificationResponse, CheckDlpGyeonggiAccountIdentificationError, Options<CheckDlpGyeonggiAccountIdentificationData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await checkDlpGyeonggiAccountIdentification({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 로그인
 *
 * ID, PW 으로 로그인 합니다.
 */
export const loginDlpGyeonggiAccountMutation = (options?: Partial<Options<LoginDlpGyeonggiAccountData>>): UseMutationOptions<LoginDlpGyeonggiAccountResponse2, LoginDlpGyeonggiAccountError, Options<LoginDlpGyeonggiAccountData>> => {
  const mutationOptions: UseMutationOptions<LoginDlpGyeonggiAccountResponse2, LoginDlpGyeonggiAccountError, Options<LoginDlpGyeonggiAccountData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await loginDlpGyeonggiAccount({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 가입 과정 Step 3 - 회원 가입 진행
 *
 * 주어진 정보로 회원가입을 진행합니다.
 */
export const saveDlpGyeonggiAccountMutation = (options?: Partial<Options<SaveDlpGyeonggiAccountData>>): UseMutationOptions<SaveDlpGyeonggiAccountResponse, SaveDlpGyeonggiAccountError, Options<SaveDlpGyeonggiAccountData>> => {
  const mutationOptions: UseMutationOptions<SaveDlpGyeonggiAccountResponse, SaveDlpGyeonggiAccountError, Options<SaveDlpGyeonggiAccountData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveDlpGyeonggiAccount({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 가입 과정 Step 2 - 아이디 중복 확인
 *
 * 아이디가 사용 가능한 지 확인합니다.
 */
export const checkDlpGyeonggiAccountIdMutation = (options?: Partial<Options<CheckDlpGyeonggiAccountIdData>>): UseMutationOptions<CheckDlpGyeonggiAccountIdResponse2, CheckDlpGyeonggiAccountIdError, Options<CheckDlpGyeonggiAccountIdData>> => {
  const mutationOptions: UseMutationOptions<CheckDlpGyeonggiAccountIdResponse2, CheckDlpGyeonggiAccountIdError, Options<CheckDlpGyeonggiAccountIdData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await checkDlpGyeonggiAccountId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const inquiryListQueryKey = (options: Options<InquiryListData>) => createQueryKey('inquiryList', options);

/**
 * 문의내역 조회
 *
 * 문의 내역을 조회합니다
 */
export const inquiryListOptions = (options: Options<InquiryListData>) => queryOptions<InquiryListResponse, InquiryListError, InquiryListResponse, ReturnType<typeof inquiryListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await inquiryList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: inquiryListQueryKey(options)
});
export const inquiryListInfiniteQueryKey = (options: Options<InquiryListData>): QueryKey<Options<InquiryListData>> => createQueryKey('inquiryList', options, true);

/**
 * 문의내역 조회
 *
 * 문의 내역을 조회합니다
 */
export const inquiryListInfiniteOptions = (options: Options<InquiryListData>) => infiniteQueryOptions<InquiryListResponse, InquiryListError, InfiniteData<InquiryListResponse>, QueryKey<Options<InquiryListData>>, number | Pick<QueryKey<Options<InquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<InquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await inquiryList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: inquiryListInfiniteQueryKey(options)
});

/**
 * 문의하기
 *
 * 문의내용을 등록합니다
 */
export const saveInquiry1Mutation = (options?: Partial<Options<SaveInquiry1Data>>): UseMutationOptions<SaveInquiry1Response, SaveInquiry1Error, Options<SaveInquiry1Data>> => {
  const mutationOptions: UseMutationOptions<SaveInquiry1Response, SaveInquiry1Error, Options<SaveInquiry1Data>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveInquiry1({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 커뮤니티 게시글 신고
 */
export const reportCommunityMutation = (options?: Partial<Options<ReportCommunityData>>): UseMutationOptions<ReportCommunityResponse, ReportCommunityError, Options<ReportCommunityData>> => {
  const mutationOptions: UseMutationOptions<ReportCommunityResponse, ReportCommunityError, Options<ReportCommunityData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await reportCommunity({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 인증 번호 확인
 */
export const certificationCheckMutation = (options?: Partial<Options<CertificationCheckData>>): UseMutationOptions<CertificationCheckResponse, CertificationCheckError, Options<CertificationCheckData>> => {
  const mutationOptions: UseMutationOptions<CertificationCheckResponse, CertificationCheckError, Options<CertificationCheckData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await certificationCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 휴대전화번호 인증 발송
 */
export const sendCertificationCellphoneMutation = (options?: Partial<Options<SendCertificationCellphoneData>>): UseMutationOptions<SendCertificationCellphoneResponse, SendCertificationCellphoneError, Options<SendCertificationCellphoneData>> => {
  const mutationOptions: UseMutationOptions<SendCertificationCellphoneResponse, SendCertificationCellphoneError, Options<SendCertificationCellphoneData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await sendCertificationCellphone({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 혜택 알리미 - 신청 정보 저장
 */
export const saveBenefitNotificationApplicationInfoMutation = (options?: Partial<Options<SaveBenefitNotificationApplicationInfoData>>): UseMutationOptions<SaveBenefitNotificationApplicationInfoResponse, SaveBenefitNotificationApplicationInfoError, Options<SaveBenefitNotificationApplicationInfoData>> => {
  const mutationOptions: UseMutationOptions<SaveBenefitNotificationApplicationInfoResponse, SaveBenefitNotificationApplicationInfoError, Options<SaveBenefitNotificationApplicationInfoData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveBenefitNotificationApplicationInfo({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 축제 리뷰 작성
 *
 * 인증된 회원이 축제에 대한 리뷰를 작성합니다.
 */
export const saveTourReviewMutation = (options?: Partial<Options<SaveTourReviewData>>): UseMutationOptions<SaveTourReviewResponse, SaveTourReviewError, Options<SaveTourReviewData>> => {
  const mutationOptions: UseMutationOptions<SaveTourReviewResponse, SaveTourReviewError, Options<SaveTourReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await saveTourReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getDeliveryTrackingQueryKey = (options: Options<GetDeliveryTrackingData>) => createQueryKey('getDeliveryTracking', options);

/**
 * 배송 조회 v3 (provider 통합)
 *
 * 배송 추적 조회 (provider 통합).
 *
 * <p>tracking provider(GOODSFLOW/LOGIS_TRACKING)에 따라 적절한 API로 배송 상태를 조회한다.</p>
 */
export const getDeliveryTrackingOptions = (options: Options<GetDeliveryTrackingData>) => queryOptions<GetDeliveryTrackingResponse, GetDeliveryTrackingError, GetDeliveryTrackingResponse, ReturnType<typeof getDeliveryTrackingQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDeliveryTracking({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryTrackingQueryKey(options)
});
export const authReverseGeocodingQueryKey = (options: Options<AuthReverseGeocodingData>) => createQueryKey('authReverseGeocoding', options);

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const authReverseGeocodingOptions = (options: Options<AuthReverseGeocodingData>) => queryOptions<AuthReverseGeocodingResponse, AuthReverseGeocodingError, AuthReverseGeocodingResponse, ReturnType<typeof authReverseGeocodingQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await authReverseGeocoding({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: authReverseGeocodingQueryKey(options)
});
export const authGeolocationQueryKey = (options: Options<AuthGeolocationData>) => createQueryKey('authGeolocation', options);

/**
 * IP로 현재 위치의 지역정보 조회
 */
export const authGeolocationOptions = (options: Options<AuthGeolocationData>) => queryOptions<AuthGeolocationResponse, AuthGeolocationError, AuthGeolocationResponse, ReturnType<typeof authGeolocationQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await authGeolocation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: authGeolocationQueryKey(options)
});
export const getListLikeContentsQueryKey = (options: Options<GetListLikeContentsData>) => createQueryKey('getListLikeContents', options);

/**
 * 내가 좋아요한 글 목록
 */
export const getListLikeContentsOptions = (options: Options<GetListLikeContentsData>) => queryOptions<GetListLikeContentsResponse, GetListLikeContentsError, GetListLikeContentsResponse, ReturnType<typeof getListLikeContentsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getListLikeContents({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListLikeContentsQueryKey(options)
});
export const getListLikeContentsInfiniteQueryKey = (options: Options<GetListLikeContentsData>): QueryKey<Options<GetListLikeContentsData>> => createQueryKey('getListLikeContents', options, true);

/**
 * 내가 좋아요한 글 목록
 */
export const getListLikeContentsInfiniteOptions = (options: Options<GetListLikeContentsData>) => infiniteQueryOptions<GetListLikeContentsResponse, GetListLikeContentsError, InfiniteData<GetListLikeContentsResponse>, QueryKey<Options<GetListLikeContentsData>>, number | Pick<QueryKey<Options<GetListLikeContentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetListLikeContentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getListLikeContents({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListLikeContentsInfiniteQueryKey(options)
});
export const getListLikeContentsTypeQueryKey = (options?: Options<GetListLikeContentsTypeData>) => createQueryKey('getListLikeContentsType', options);

/**
 * 내가 좋아요한 글 유형 목록
 */
export const getListLikeContentsTypeOptions = (options?: Options<GetListLikeContentsTypeData>) => queryOptions<GetListLikeContentsTypeResponse, GetListLikeContentsTypeError, GetListLikeContentsTypeResponse, ReturnType<typeof getListLikeContentsTypeQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getListLikeContentsType({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListLikeContentsTypeQueryKey(options)
});
export const getMyWelloCommentListQueryKey = (options: Options<GetMyWelloCommentListData>) => createQueryKey('getMyWelloCommentList', options);

/**
 * 웰로 유저가 작성한 댓글 목록
 */
export const getMyWelloCommentListOptions = (options: Options<GetMyWelloCommentListData>) => queryOptions<GetMyWelloCommentListResponse, GetMyWelloCommentListError, GetMyWelloCommentListResponse, ReturnType<typeof getMyWelloCommentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyWelloCommentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyWelloCommentListQueryKey(options)
});
export const getMyWelloCommentListInfiniteQueryKey = (options: Options<GetMyWelloCommentListData>): QueryKey<Options<GetMyWelloCommentListData>> => createQueryKey('getMyWelloCommentList', options, true);

/**
 * 웰로 유저가 작성한 댓글 목록
 */
export const getMyWelloCommentListInfiniteOptions = (options: Options<GetMyWelloCommentListData>) => infiniteQueryOptions<GetMyWelloCommentListResponse, GetMyWelloCommentListError, InfiniteData<GetMyWelloCommentListResponse>, QueryKey<Options<GetMyWelloCommentListData>>, number | Pick<QueryKey<Options<GetMyWelloCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetMyWelloCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getMyWelloCommentList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyWelloCommentListInfiniteQueryKey(options)
});
export const getLiveWelloCommentListQueryKey = (options?: Options<GetLiveWelloCommentListData>) => createQueryKey('getLiveWelloCommentList', options);

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentListOptions = (options?: Options<GetLiveWelloCommentListData>) => queryOptions<GetLiveWelloCommentListResponse, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, ReturnType<typeof getLiveWelloCommentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getLiveWelloCommentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLiveWelloCommentListQueryKey(options)
});
export const findTourFeedbackQueryKey = (options: Options<FindTourFeedbackData>) => createQueryKey('findTourFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (로그인)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedbackOptions = (options: Options<FindTourFeedbackData>) => queryOptions<FindTourFeedbackResponse, FindTourFeedbackError, FindTourFeedbackResponse, ReturnType<typeof findTourFeedbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findTourFeedback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findTourFeedbackQueryKey(options)
});
export const fileDecryptionDownloadQueryKey = (options: Options<FileDecryptionDownloadData>) => createQueryKey('fileDecryptionDownload', options);

/**
 * 파일 복호화 다운로드
 */
export const fileDecryptionDownloadOptions = (options: Options<FileDecryptionDownloadData>) => queryOptions<FileDecryptionDownloadResponse, FileDecryptionDownloadError, FileDecryptionDownloadResponse, ReturnType<typeof fileDecryptionDownloadQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await fileDecryptionDownload({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: fileDecryptionDownloadQueryKey(options)
});
export const recommendPolicyListQueryKey = (options: Options<RecommendPolicyListData>) => createQueryKey('recommendPolicyList', options);

/**
 * 멤버/가족 신청가능한 맞춤정책 조회
 */
export const recommendPolicyListOptions = (options: Options<RecommendPolicyListData>) => queryOptions<RecommendPolicyListResponse, RecommendPolicyListError, RecommendPolicyListResponse, ReturnType<typeof recommendPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await recommendPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: recommendPolicyListQueryKey(options)
});
export const getPollQueryKey = (options: Options<GetPollData>) => createQueryKey('getPoll', options);

/**
 * 설문 통합 조회
 *
 * 투표 여부에 따라 투표 화면(pollDetail) 또는 결과 화면(pollResult) 데이터를 반환합니다
 */
export const getPollOptions = (options: Options<GetPollData>) => queryOptions<GetPollResponse, GetPollError, GetPollResponse, ReturnType<typeof getPollQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPoll({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPollQueryKey(options)
});
export const checkVotedQueryKey = (options: Options<CheckVotedData>) => createQueryKey('checkVoted', options);

/**
 * 투표 여부 확인
 *
 * 해당 설문에 본인이 투표했는지 확인합니다 (화면 분기용)
 */
export const checkVotedOptions = (options: Options<CheckVotedData>) => queryOptions<CheckVotedResponse, CheckVotedError, CheckVotedResponse, ReturnType<typeof checkVotedQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkVoted({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkVotedQueryKey(options)
});
export const getPollResultQueryKey = (options: Options<GetPollResultData>) => createQueryKey('getPollResult', options);

/**
 * 투표 결과 조회
 *
 * 설문 투표 결과를 질문별로 조회합니다
 */
export const getPollResultOptions = (options: Options<GetPollResultData>) => queryOptions<GetPollResultResponse, GetPollResultError, GetPollResultResponse, ReturnType<typeof getPollResultQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPollResult({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPollResultQueryKey(options)
});
export const metaPolicyListQueryKey = (options: Options<MetaPolicyListData>) => createQueryKey('metaPolicyList', options);

/**
 * 정책 검색목록 조회
 */
export const metaPolicyListOptions = (options: Options<MetaPolicyListData>) => queryOptions<MetaPolicyListResponse, MetaPolicyListError, MetaPolicyListResponse, ReturnType<typeof metaPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await metaPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: metaPolicyListQueryKey(options)
});
export const metaPolicyListInfiniteQueryKey = (options: Options<MetaPolicyListData>): QueryKey<Options<MetaPolicyListData>> => createQueryKey('metaPolicyList', options, true);

/**
 * 정책 검색목록 조회
 */
export const metaPolicyListInfiniteOptions = (options: Options<MetaPolicyListData>) => infiniteQueryOptions<MetaPolicyListResponse, MetaPolicyListError, InfiniteData<MetaPolicyListResponse>, QueryKey<Options<MetaPolicyListData>>, number | Pick<QueryKey<Options<MetaPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<MetaPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await metaPolicyList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: metaPolicyListInfiniteQueryKey(options)
});
export const metaPolicyQueryKey = (options: Options<MetaPolicyData>) => createQueryKey('metaPolicy', options);

/**
 * 회원 정책 상세 조회
 */
export const metaPolicyOptions = (options: Options<MetaPolicyData>) => queryOptions<MetaPolicyResponse, MetaPolicyError, MetaPolicyResponse, ReturnType<typeof metaPolicyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await metaPolicy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: metaPolicyQueryKey(options)
});
export const getRelatedMetaPolicyListQueryKey = (options: Options<GetRelatedMetaPolicyListData>) => createQueryKey('getRelatedMetaPolicyList', options);

/**
 * 관련 정책 목록 조회(최대 7개)
 */
export const getRelatedMetaPolicyListOptions = (options: Options<GetRelatedMetaPolicyListData>) => queryOptions<GetRelatedMetaPolicyListResponse, GetRelatedMetaPolicyListError, GetRelatedMetaPolicyListResponse, ReturnType<typeof getRelatedMetaPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getRelatedMetaPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRelatedMetaPolicyListQueryKey(options)
});
export const getInterestPolicyListQueryKey = (options: Options<GetInterestPolicyListData>) => createQueryKey('getInterestPolicyList', options);

/**
 * 관심 분야별 정책 조회
 */
export const getInterestPolicyListOptions = (options: Options<GetInterestPolicyListData>) => queryOptions<GetInterestPolicyListResponse, GetInterestPolicyListError, GetInterestPolicyListResponse, ReturnType<typeof getInterestPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getInterestPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInterestPolicyListQueryKey(options)
});
export const getInterestPolicyListInfiniteQueryKey = (options: Options<GetInterestPolicyListData>): QueryKey<Options<GetInterestPolicyListData>> => createQueryKey('getInterestPolicyList', options, true);

/**
 * 관심 분야별 정책 조회
 */
export const getInterestPolicyListInfiniteOptions = (options: Options<GetInterestPolicyListData>) => infiniteQueryOptions<GetInterestPolicyListResponse, GetInterestPolicyListError, InfiniteData<GetInterestPolicyListResponse>, QueryKey<Options<GetInterestPolicyListData>>, number | Pick<QueryKey<Options<GetInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getInterestPolicyList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInterestPolicyListInfiniteQueryKey(options)
});
export const metaPolicyFeedbackQueryKey = (options: Options<MetaPolicyFeedbackData>) => createQueryKey('metaPolicyFeedback', options);

/**
 * 로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedbackOptions = (options: Options<MetaPolicyFeedbackData>) => queryOptions<MetaPolicyFeedbackResponse, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, ReturnType<typeof metaPolicyFeedbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await metaPolicyFeedback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: metaPolicyFeedbackQueryKey(options)
});
export const dislikeQueryKey = (options?: Options<DislikeData>) => createQueryKey('dislike', options);

/**
 * 제외정책 목록조회
 *
 * 제외정책 목록을 조회합니다
 */
export const dislikeOptions = (options?: Options<DislikeData>) => queryOptions<DislikeResponse, DislikeError, DislikeResponse, ReturnType<typeof dislikeQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await dislike({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: dislikeQueryKey(options)
});
export const getListChildcareRelatedPolicyQueryKey = (options: Options<GetListChildcareRelatedPolicyData>) => createQueryKey('getListChildcareRelatedPolicy', options);

/**
 * 내 상황에 맞는 육아 정책 관련 정책 조회
 */
export const getListChildcareRelatedPolicyOptions = (options: Options<GetListChildcareRelatedPolicyData>) => queryOptions<GetListChildcareRelatedPolicyResponse, GetListChildcareRelatedPolicyError, GetListChildcareRelatedPolicyResponse, ReturnType<typeof getListChildcareRelatedPolicyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getListChildcareRelatedPolicy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListChildcareRelatedPolicyQueryKey(options)
});
export const getWelloPolicyApplyListQueryKey = (options?: Options<GetWelloPolicyApplyListData>) => createQueryKey('getWelloPolicyApplyList', options);

/**
 * 정책 바로신청 내역 조회
 */
export const getWelloPolicyApplyListOptions = (options?: Options<GetWelloPolicyApplyListData>) => queryOptions<GetWelloPolicyApplyListResponse, GetWelloPolicyApplyListError, GetWelloPolicyApplyListResponse, ReturnType<typeof getWelloPolicyApplyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloPolicyApplyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloPolicyApplyListQueryKey(options)
});
export const getWelloPolicyApplyCountQueryKey = (options?: Options<GetWelloPolicyApplyCountData>) => createQueryKey('getWelloPolicyApplyCount', options);

/**
 * 정책 바로신청 내역 수
 */
export const getWelloPolicyApplyCountOptions = (options?: Options<GetWelloPolicyApplyCountData>) => queryOptions<GetWelloPolicyApplyCountResponse, GetWelloPolicyApplyCountError, GetWelloPolicyApplyCountResponse, ReturnType<typeof getWelloPolicyApplyCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloPolicyApplyCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloPolicyApplyCountQueryKey(options)
});
export const checkWelloPolicyApplyQueryKey = (options: Options<CheckWelloPolicyApplyData>) => createQueryKey('checkWelloPolicyApply', options);

/**
 * 정책 바로신청 체크
 */
export const checkWelloPolicyApplyOptions = (options: Options<CheckWelloPolicyApplyData>) => queryOptions<CheckWelloPolicyApplyResponse2, CheckWelloPolicyApplyError, CheckWelloPolicyApplyResponse2, ReturnType<typeof checkWelloPolicyApplyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkWelloPolicyApply({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkWelloPolicyApplyQueryKey(options)
});
export const getDetailPointBalanceQueryKey = (options?: Options<GetDetailPointBalanceData>) => createQueryKey('getDetailPointBalance', options);

/**
 * 포인트 정보 조회
 *
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getDetailPointBalanceOptions = (options?: Options<GetDetailPointBalanceData>) => queryOptions<GetDetailPointBalanceResponse, GetDetailPointBalanceError, GetDetailPointBalanceResponse, ReturnType<typeof getDetailPointBalanceQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDetailPointBalance({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDetailPointBalanceQueryKey(options)
});
export const getListPointHistoryQueryKey = (options: Options<GetListPointHistoryData>) => createQueryKey('getListPointHistory', options);

/**
 * 포인트 사용, 출금, 차감 내역 조회
 *
 * 포인트 사용, 출금, 차감 내역 목록을 조회합니다.
 */
export const getListPointHistoryOptions = (options: Options<GetListPointHistoryData>) => queryOptions<GetListPointHistoryResponse, GetListPointHistoryError, GetListPointHistoryResponse, ReturnType<typeof getListPointHistoryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getListPointHistory({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListPointHistoryQueryKey(options)
});
export const getListPointHistoryInfiniteQueryKey = (options: Options<GetListPointHistoryData>): QueryKey<Options<GetListPointHistoryData>> => createQueryKey('getListPointHistory', options, true);

/**
 * 포인트 사용, 출금, 차감 내역 조회
 *
 * 포인트 사용, 출금, 차감 내역 목록을 조회합니다.
 */
export const getListPointHistoryInfiniteOptions = (options: Options<GetListPointHistoryData>) => infiniteQueryOptions<GetListPointHistoryResponse, GetListPointHistoryError, InfiniteData<GetListPointHistoryResponse>, QueryKey<Options<GetListPointHistoryData>>, number | Pick<QueryKey<Options<GetListPointHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetListPointHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getListPointHistory({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getListPointHistoryInfiniteQueryKey(options)
});
export const getPointBudgetQueryKey = (options?: Options<GetPointBudgetData>) => createQueryKey('getPointBudget', options);

/**
 * 포인트 이벤트 정보 조회
 *
 * 포인트 이벤트 관련 정보를 조회합니다.
 */
export const getPointBudgetOptions = (options?: Options<GetPointBudgetData>) => queryOptions<GetPointBudgetResponse, GetPointBudgetError, GetPointBudgetResponse, ReturnType<typeof getPointBudgetQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPointBudget({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPointBudgetQueryKey(options)
});
export const getAvailablePointProductListQueryKey = (options?: Options<GetAvailablePointProductListData>) => createQueryKey('getAvailablePointProductList', options);

/**
 * 내 포인트로 살 수 있는 상품 목록 조회
 */
export const getAvailablePointProductListOptions = (options?: Options<GetAvailablePointProductListData>) => queryOptions<GetAvailablePointProductListResponse, GetAvailablePointProductListError, GetAvailablePointProductListResponse, ReturnType<typeof getAvailablePointProductListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getAvailablePointProductList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAvailablePointProductListQueryKey(options)
});
export const getAvailablePointProductListInfiniteQueryKey = (options?: Options<GetAvailablePointProductListData>): QueryKey<Options<GetAvailablePointProductListData>> => createQueryKey('getAvailablePointProductList', options, true);

/**
 * 내 포인트로 살 수 있는 상품 목록 조회
 */
export const getAvailablePointProductListInfiniteOptions = (options?: Options<GetAvailablePointProductListData>) => infiniteQueryOptions<GetAvailablePointProductListResponse, GetAvailablePointProductListError, InfiniteData<GetAvailablePointProductListResponse>, QueryKey<Options<GetAvailablePointProductListData>>, number | Pick<QueryKey<Options<GetAvailablePointProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetAvailablePointProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getAvailablePointProductList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAvailablePointProductListInfiniteQueryKey(options)
});
export const getPointMarketOrderListQueryKey = (options?: Options<GetPointMarketOrderListData>) => createQueryKey('getPointMarketOrderList', options);

/**
 * 주문 목록 조회
 */
export const getPointMarketOrderListOptions = (options?: Options<GetPointMarketOrderListData>) => queryOptions<GetPointMarketOrderListResponse, GetPointMarketOrderListError, GetPointMarketOrderListResponse, ReturnType<typeof getPointMarketOrderListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPointMarketOrderList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPointMarketOrderListQueryKey(options)
});
export const getPointMarketOrderListInfiniteQueryKey = (options?: Options<GetPointMarketOrderListData>): QueryKey<Options<GetPointMarketOrderListData>> => createQueryKey('getPointMarketOrderList', options, true);

/**
 * 주문 목록 조회
 */
export const getPointMarketOrderListInfiniteOptions = (options?: Options<GetPointMarketOrderListData>) => infiniteQueryOptions<GetPointMarketOrderListResponse, GetPointMarketOrderListError, InfiniteData<GetPointMarketOrderListResponse>, QueryKey<Options<GetPointMarketOrderListData>>, number | Pick<QueryKey<Options<GetPointMarketOrderListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetPointMarketOrderListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getPointMarketOrderList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPointMarketOrderListInfiniteQueryKey(options)
});
export const getPointMarketOrderPreviewQueryKey = (options: Options<GetPointMarketOrderPreviewData>) => createQueryKey('getPointMarketOrderPreview', options);

/**
 * 결제 전 정보 조회
 */
export const getPointMarketOrderPreviewOptions = (options: Options<GetPointMarketOrderPreviewData>) => queryOptions<GetPointMarketOrderPreviewResponse, GetPointMarketOrderPreviewError, GetPointMarketOrderPreviewResponse, ReturnType<typeof getPointMarketOrderPreviewQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPointMarketOrderPreview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPointMarketOrderPreviewQueryKey(options)
});
export const paymentHisListQueryKey = (options?: Options<PaymentHisListData>) => createQueryKey('paymentHisList', options);

/**
 * 혜택내역 조회
 */
export const paymentHisListOptions = (options?: Options<PaymentHisListData>) => queryOptions<PaymentHisListResponse, PaymentHisListError, PaymentHisListResponse, ReturnType<typeof paymentHisListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await paymentHisList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: paymentHisListQueryKey(options)
});
export const totalPaymentHisListQueryKey = (options?: Options<TotalPaymentHisListData>) => createQueryKey('totalPaymentHisList', options);

/**
 * 총 리워드 지급 수
 */
export const totalPaymentHisListOptions = (options?: Options<TotalPaymentHisListData>) => queryOptions<TotalPaymentHisListResponse, TotalPaymentHisListError, TotalPaymentHisListResponse, ReturnType<typeof totalPaymentHisListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await totalPaymentHisList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: totalPaymentHisListQueryKey(options)
});
export const checkPlusFailQueryKey = (options?: Options<CheckPlusFailData>) => createQueryKey('checkPlusFail', options);

/**
 * Nice 신용인증 실패시 이동될 URL
 */
export const checkPlusFailOptions = (options?: Options<CheckPlusFailData>) => queryOptions<CheckPlusFailResponse, CheckPlusFailError, CheckPlusFailResponse, ReturnType<typeof checkPlusFailQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkPlusFail({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkPlusFailQueryKey(options)
});
export const checkPlusSendResultQueryKey = (options?: Options<CheckPlusSendResultData>) => createQueryKey('checkPlusSendResult', options);

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSendResultOptions = (options?: Options<CheckPlusSendResultData>) => queryOptions<CheckPlusSendResultResponse, CheckPlusSendResultError, CheckPlusSendResultResponse, ReturnType<typeof checkPlusSendResultQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkPlusSendResult({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkPlusSendResultQueryKey(options)
});
export const getTourFestivalWishlistQueryKey = (options?: Options<GetTourFestivalWishlistData>) => createQueryKey('getTourFestivalWishlist', options);

/**
 * 축제 스크랩 목록 조회
 */
export const getTourFestivalWishlistOptions = (options?: Options<GetTourFestivalWishlistData>) => queryOptions<GetTourFestivalWishlistResponse, GetTourFestivalWishlistError, GetTourFestivalWishlistResponse, ReturnType<typeof getTourFestivalWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getTourFestivalWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTourFestivalWishlistQueryKey(options)
});
export const metaPolicyWishlistQueryKey = (options?: Options<MetaPolicyWishlistData>) => createQueryKey('metaPolicyWishlist', options);

/**
 * 정책 스크랩 목록 조회
 */
export const metaPolicyWishlistOptions = (options?: Options<MetaPolicyWishlistData>) => queryOptions<MetaPolicyWishlistResponse2, MetaPolicyWishlistError, MetaPolicyWishlistResponse2, ReturnType<typeof metaPolicyWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await metaPolicyWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: metaPolicyWishlistQueryKey(options)
});
export const hometownNewsWishlistQueryKey = (options?: Options<HometownNewsWishlistData>) => createQueryKey('hometownNewsWishlist', options);

/**
 * 동네소식 스크랩 목록 조회
 */
export const hometownNewsWishlistOptions = (options?: Options<HometownNewsWishlistData>) => queryOptions<HometownNewsWishlistResponse2, HometownNewsWishlistError, HometownNewsWishlistResponse2, ReturnType<typeof hometownNewsWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await hometownNewsWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: hometownNewsWishlistQueryKey(options)
});
export const getEmergencyRoomWishlistQueryKey = (options?: Options<GetEmergencyRoomWishlistData>) => createQueryKey('getEmergencyRoomWishlist', options);

/**
 * 응급실 스크랩 목록 조회
 */
export const getEmergencyRoomWishlistOptions = (options?: Options<GetEmergencyRoomWishlistData>) => queryOptions<GetEmergencyRoomWishlistResponse, GetEmergencyRoomWishlistError, GetEmergencyRoomWishlistResponse, ReturnType<typeof getEmergencyRoomWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getEmergencyRoomWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEmergencyRoomWishlistQueryKey(options)
});
export const getCommunityWelloNewsWishlistQueryKey = (options?: Options<GetCommunityWelloNewsWishlistData>) => createQueryKey('getCommunityWelloNewsWishlist', options);

/**
 * 커뮤니티 스크랩 목록 조회 - 웰로소식
 */
export const getCommunityWelloNewsWishlistOptions = (options?: Options<GetCommunityWelloNewsWishlistData>) => queryOptions<GetCommunityWelloNewsWishlistResponse, GetCommunityWelloNewsWishlistError, GetCommunityWelloNewsWishlistResponse, ReturnType<typeof getCommunityWelloNewsWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getCommunityWelloNewsWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommunityWelloNewsWishlistQueryKey(options)
});
export const bestContentsWishlistQueryKey = (options?: Options<BestContentsWishlistData>) => createQueryKey('bestContentsWishlist', options);

/**
 * 정책소식 스크랩 목록 조회
 */
export const bestContentsWishlistOptions = (options?: Options<BestContentsWishlistData>) => queryOptions<BestContentsWishlistResponse2, BestContentsWishlistError, BestContentsWishlistResponse2, ReturnType<typeof bestContentsWishlistQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await bestContentsWishlist({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bestContentsWishlistQueryKey(options)
});
export const userPropertyQueryKey = (options?: Options<UserPropertyData>) => createQueryKey('userProperty', options);

/**
 * 유저 프로필 조회
 *
 * 가입된 유저의 프로필을 조회합니다
 */
export const userPropertyOptions = (options?: Options<UserPropertyData>) => queryOptions<UserPropertyResponse2, UserPropertyError, UserPropertyResponse2, ReturnType<typeof userPropertyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await userProperty({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: userPropertyQueryKey(options)
});

/**
 * 연동된 소셜계정 해제
 */
export const deleteMemberSocialAccountsMutation = (options?: Partial<Options<DeleteMemberSocialAccountsData>>): UseMutationOptions<DeleteMemberSocialAccountsResponse, DeleteMemberSocialAccountsError, Options<DeleteMemberSocialAccountsData>> => {
  const mutationOptions: UseMutationOptions<DeleteMemberSocialAccountsResponse, DeleteMemberSocialAccountsError, Options<DeleteMemberSocialAccountsData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteMemberSocialAccounts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const memberSocialAccountsQueryKey = (options?: Options<MemberSocialAccountsData>) => createQueryKey('memberSocialAccounts', options);

/**
 * 연동된 소셜계정 목록
 */
export const memberSocialAccountsOptions = (options?: Options<MemberSocialAccountsData>) => queryOptions<MemberSocialAccountsResponse, MemberSocialAccountsError, MemberSocialAccountsResponse, ReturnType<typeof memberSocialAccountsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberSocialAccounts({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberSocialAccountsQueryKey(options)
});
export const memberRecommendPolicyByRecentListQueryKey = (options?: Options<MemberRecommendPolicyByRecentListData>) => createQueryKey('memberRecommendPolicyByRecentList', options);

/**
 * 내가 본 정책과 비슷한 정책 조회
 */
export const memberRecommendPolicyByRecentListOptions = (options?: Options<MemberRecommendPolicyByRecentListData>) => queryOptions<MemberRecommendPolicyByRecentListResponse, MemberRecommendPolicyByRecentListError, MemberRecommendPolicyByRecentListResponse, ReturnType<typeof memberRecommendPolicyByRecentListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberRecommendPolicyByRecentList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberRecommendPolicyByRecentListQueryKey(options)
});
export const memberRecentPolicyListQueryKey = (options?: Options<MemberRecentPolicyListData>) => createQueryKey('memberRecentPolicyList', options);

/**
 * 최근 본 정책 조회
 */
export const memberRecentPolicyListOptions = (options?: Options<MemberRecentPolicyListData>) => queryOptions<MemberRecentPolicyListResponse, MemberRecentPolicyListError, MemberRecentPolicyListResponse, ReturnType<typeof memberRecentPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberRecentPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberRecentPolicyListQueryKey(options)
});
export const memberPolicyListQueryKey = (options?: Options<MemberPolicyListData>) => createQueryKey('memberPolicyList', options);

/**
 * 지원유형별 맞춤정책 건수
 *
 * 지원유형별 맞춤정책 건수를 조회합니다
 */
export const memberPolicyListOptions = (options?: Options<MemberPolicyListData>) => queryOptions<MemberPolicyListResponse, MemberPolicyListError, MemberPolicyListResponse, ReturnType<typeof memberPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberPolicyListQueryKey(options)
});
export const memberPeerGroupPolicyListQueryKey = (options?: Options<MemberPeerGroupPolicyListData>) => createQueryKey('memberPeerGroupPolicyList', options);

/**
 * 내 또래가 많이 본 정책 조회
 */
export const memberPeerGroupPolicyListOptions = (options?: Options<MemberPeerGroupPolicyListData>) => queryOptions<MemberPeerGroupPolicyListResponse, MemberPeerGroupPolicyListError, MemberPeerGroupPolicyListResponse, ReturnType<typeof memberPeerGroupPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberPeerGroupPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberPeerGroupPolicyListQueryKey(options)
});
export const memberNeighborPolicyListQueryKey = (options?: Options<MemberNeighborPolicyListData>) => createQueryKey('memberNeighborPolicyList', options);

/**
 * 우리 동네 이웃이 많이 본 정책 조회
 */
export const memberNeighborPolicyListOptions = (options?: Options<MemberNeighborPolicyListData>) => queryOptions<MemberNeighborPolicyListResponse, MemberNeighborPolicyListError, MemberNeighborPolicyListResponse, ReturnType<typeof memberNeighborPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberNeighborPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberNeighborPolicyListQueryKey(options)
});
export const getInvitedMemberCountQueryKey = (options?: Options<GetInvitedMemberCountData>) => createQueryKey('getInvitedMemberCount', options);

/**
 * 유저가 초대한 회원 수 조회
 */
export const getInvitedMemberCountOptions = (options?: Options<GetInvitedMemberCountData>) => queryOptions<GetInvitedMemberCountResponse, GetInvitedMemberCountError, GetInvitedMemberCountResponse, ReturnType<typeof getInvitedMemberCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getInvitedMemberCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInvitedMemberCountQueryKey(options)
});
export const memberInterestPolicyListQueryKey = (options?: Options<MemberInterestPolicyListData>) => createQueryKey('memberInterestPolicyList', options);

/**
 * 회원 관심 분야별 맞춤정책 조회
 */
export const memberInterestPolicyListOptions = (options?: Options<MemberInterestPolicyListData>) => queryOptions<MemberInterestPolicyListResponse, MemberInterestPolicyListError, MemberInterestPolicyListResponse, ReturnType<typeof memberInterestPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberInterestPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberInterestPolicyListQueryKey(options)
});
export const memberContentCountQueryKey = (options?: Options<MemberContentCountData>) => createQueryKey('memberContentCount', options);

/**
 * 메인 페이지 멤버 컨텐츠 별 건수
 */
export const memberContentCountOptions = (options?: Options<MemberContentCountData>) => queryOptions<MemberContentCountResponse2, MemberContentCountError, MemberContentCountResponse2, ReturnType<typeof memberContentCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await memberContentCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: memberContentCountQueryKey(options)
});
export const getActionCountQueryKey = (options?: Options<GetActionCountData>) => createQueryKey('getActionCount', options);

/**
 * 유저의 행동 관련 수치 조회
 *
 * 유저의 맞춤 정책, 스크랩 목록 수를 조회합니다.
 */
export const getActionCountOptions = (options?: Options<GetActionCountData>) => queryOptions<GetActionCountResponse, GetActionCountError, GetActionCountResponse, ReturnType<typeof getActionCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getActionCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getActionCountQueryKey(options)
});
export const getWelloMemberBlockListQueryKey = (options: Options<GetWelloMemberBlockListData>) => createQueryKey('getWelloMemberBlockList', options);

/**
 * 웰로 사용자 차단 목록 조회
 */
export const getWelloMemberBlockListOptions = (options: Options<GetWelloMemberBlockListData>) => queryOptions<GetWelloMemberBlockListResponse, GetWelloMemberBlockListError, GetWelloMemberBlockListResponse, ReturnType<typeof getWelloMemberBlockListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloMemberBlockList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloMemberBlockListQueryKey(options)
});
export const getWelloMemberBlockListInfiniteQueryKey = (options: Options<GetWelloMemberBlockListData>): QueryKey<Options<GetWelloMemberBlockListData>> => createQueryKey('getWelloMemberBlockList', options, true);

/**
 * 웰로 사용자 차단 목록 조회
 */
export const getWelloMemberBlockListInfiniteOptions = (options: Options<GetWelloMemberBlockListData>) => infiniteQueryOptions<GetWelloMemberBlockListResponse, GetWelloMemberBlockListError, InfiniteData<GetWelloMemberBlockListResponse>, QueryKey<Options<GetWelloMemberBlockListData>>, number | Pick<QueryKey<Options<GetWelloMemberBlockListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetWelloMemberBlockListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getWelloMemberBlockList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloMemberBlockListInfiniteQueryKey(options)
});
export const getMemberDetailInfoQueryKey = (options?: Options<GetMemberDetailInfoData>) => createQueryKey('getMemberDetailInfo', options);

/**
 * 멤버 상세 정보 조회
 */
export const getMemberDetailInfoOptions = (options?: Options<GetMemberDetailInfoData>) => queryOptions<GetMemberDetailInfoResponse, GetMemberDetailInfoError, GetMemberDetailInfoResponse, ReturnType<typeof getMemberDetailInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMemberDetailInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMemberDetailInfoQueryKey(options)
});
export const getMemberVerificationIdQueryKey = (options?: Options<GetMemberVerificationIdData>) => createQueryKey('getMemberVerificationId', options);

/**
 * 본인인증 ID 조회
 */
export const getMemberVerificationIdOptions = (options?: Options<GetMemberVerificationIdData>) => queryOptions<GetMemberVerificationIdResponse, GetMemberVerificationIdError, GetMemberVerificationIdResponse, ReturnType<typeof getMemberVerificationIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMemberVerificationId({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMemberVerificationIdQueryKey(options)
});
export const getMemberQueryKey = (options?: Options<GetMemberData>) => createQueryKey('getMember', options);
export const getMemberOptions = (options?: Options<GetMemberData>) => queryOptions<GetMemberResponse, GetMemberError, GetMemberResponse, ReturnType<typeof getMemberQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMember({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMemberQueryKey(options)
});
export const requiredFilterQueryKey = (options?: Options<RequiredFilterData>) => createQueryKey('requiredFilter', options);

/**
 * 필터 조회(관심필터 제외)
 */
export const requiredFilterOptions = (options?: Options<RequiredFilterData>) => queryOptions<RequiredFilterResponse, RequiredFilterError, RequiredFilterResponse, ReturnType<typeof requiredFilterQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await requiredFilter({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: requiredFilterQueryKey(options)
});
export const getMemberAccountQueryKey = (options?: Options<GetMemberAccountData>) => createQueryKey('getMemberAccount', options);

/**
 * 사용 가능한 계좌 조회
 */
export const getMemberAccountOptions = (options?: Options<GetMemberAccountData>) => queryOptions<GetMemberAccountResponse, GetMemberAccountError, GetMemberAccountResponse, ReturnType<typeof getMemberAccountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMemberAccount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMemberAccountQueryKey(options)
});
export const findAllTermsQueryKey = (options?: Options<FindAllTermsData>) => createQueryKey('findAllTerms', options);

/**
 * 결제 약관 전체 조회
 *
 * 결제 약관 전체(3종)를 조회합니다.
 */
export const findAllTermsOptions = (options?: Options<FindAllTermsData>) => queryOptions<FindAllTermsResponse, FindAllTermsError, FindAllTermsResponse, ReturnType<typeof findAllTermsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findAllTerms({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findAllTermsQueryKey(options)
});
export const findTermsQueryKey = (options: Options<FindTermsData>) => createQueryKey('findTerms', options);

/**
 * 결제 약관 단건 조회
 *
 * 특정 결제 약관을 조회합니다.
 */
export const findTermsOptions = (options: Options<FindTermsData>) => queryOptions<FindTermsResponse, FindTermsError, FindTermsResponse, ReturnType<typeof findTermsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findTerms({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findTermsQueryKey(options)
});
export const findPaymentConfigQueryKey = (options?: Options<FindPaymentConfigData>) => createQueryKey('findPaymentConfig', options);

/**
 * 결제 설정 조회
 *
 * 결제 설정을 조회합니다.
 */
export const findPaymentConfigOptions = (options?: Options<FindPaymentConfigData>) => queryOptions<FindPaymentConfigResponse, FindPaymentConfigError, FindPaymentConfigResponse, ReturnType<typeof findPaymentConfigQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findPaymentConfig({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findPaymentConfigQueryKey(options)
});
export const findSimplePayMethodsQueryKey = (options?: Options<FindSimplePayMethodsData>) => createQueryKey('findSimplePayMethods', options);

/**
 * 간편결제수단 목록 조회
 *
 * 간편결제수단 목록을 조회합니다.
 */
export const findSimplePayMethodsOptions = (options?: Options<FindSimplePayMethodsData>) => queryOptions<FindSimplePayMethodsResponse, FindSimplePayMethodsError, FindSimplePayMethodsResponse, ReturnType<typeof findSimplePayMethodsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findSimplePayMethods({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findSimplePayMethodsQueryKey(options)
});
export const findMyReviewsQueryKey = (options?: Options<FindMyReviewsData>) => createQueryKey('findMyReviews', options);

/**
 * 내가 쓴 리뷰 목록 조회
 *
 * 내가 쓴 리뷰 목록을 조회한다.
 */
export const findMyReviewsOptions = (options?: Options<FindMyReviewsData>) => queryOptions<FindMyReviewsResponse, FindMyReviewsError, FindMyReviewsResponse, ReturnType<typeof findMyReviewsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findMyReviews({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findMyReviewsQueryKey(options)
});
export const findMyReviewsInfiniteQueryKey = (options?: Options<FindMyReviewsData>): QueryKey<Options<FindMyReviewsData>> => createQueryKey('findMyReviews', options, true);

/**
 * 내가 쓴 리뷰 목록 조회
 *
 * 내가 쓴 리뷰 목록을 조회한다.
 */
export const findMyReviewsInfiniteOptions = (options?: Options<FindMyReviewsData>) => infiniteQueryOptions<FindMyReviewsResponse, FindMyReviewsError, InfiniteData<FindMyReviewsResponse>, QueryKey<Options<FindMyReviewsData>>, number | Pick<QueryKey<Options<FindMyReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<FindMyReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await findMyReviews({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findMyReviewsInfiniteQueryKey(options)
});
export const getReviewFormQueryKey = (options: Options<GetReviewFormData>) => createQueryKey('getReviewForm', options);

/**
 * 리뷰 작성 폼 조회
 *
 * 리뷰 작성 폼 데이터를 조회한다.
 */
export const getReviewFormOptions = (options: Options<GetReviewFormData>) => queryOptions<GetReviewFormResponse, GetReviewFormError, GetReviewFormResponse, ReturnType<typeof getReviewFormQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getReviewForm({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getReviewFormQueryKey(options)
});
export const findMyCouponsQueryKey = (options?: Options<FindMyCouponsData>) => createQueryKey('findMyCoupons', options);

/**
 * 내 보유 쿠폰 목록 조회
 *
 * 내 보유 쿠폰 목록 조회
 */
export const findMyCouponsOptions = (options?: Options<FindMyCouponsData>) => queryOptions<FindMyCouponsResponse, FindMyCouponsError, FindMyCouponsResponse, ReturnType<typeof findMyCouponsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findMyCoupons({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findMyCouponsQueryKey(options)
});
export const findDownloadableCouponsQueryKey = (options: Options<FindDownloadableCouponsData>) => createQueryKey('findDownloadableCoupons', options);

/**
 * 다운로드 가능 쿠폰 목록 조회
 *
 * 상품별 다운로드 가능 쿠폰 목록 조회
 */
export const findDownloadableCouponsOptions = (options: Options<FindDownloadableCouponsData>) => queryOptions<FindDownloadableCouponsResponse, FindDownloadableCouponsError, FindDownloadableCouponsResponse, ReturnType<typeof findDownloadableCouponsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findDownloadableCoupons({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findDownloadableCouponsQueryKey(options)
});
export const existsDownloadableCouponQueryKey = (options: Options<ExistsDownloadableCouponData>) => createQueryKey('existsDownloadableCoupon', options);

/**
 * 다운로드 가능 쿠폰 존재 여부 확인
 *
 * 다운로드 가능 쿠폰 존재 여부 확인
 */
export const existsDownloadableCouponOptions = (options: Options<ExistsDownloadableCouponData>) => queryOptions<ExistsDownloadableCouponResponse, ExistsDownloadableCouponError, ExistsDownloadableCouponResponse, ReturnType<typeof existsDownloadableCouponQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await existsDownloadableCoupon({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: existsDownloadableCouponQueryKey(options)
});
export const findAvailableCouponsQueryKey = (options?: Options<FindAvailableCouponsData>) => createQueryKey('findAvailableCoupons', options);

/**
 * 사용 가능 쿠폰 목록 조회
 *
 * 사용 가능 쿠폰 목록 조회
 */
export const findAvailableCouponsOptions = (options?: Options<FindAvailableCouponsData>) => queryOptions<FindAvailableCouponsResponse, FindAvailableCouponsError, FindAvailableCouponsResponse, ReturnType<typeof findAvailableCouponsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findAvailableCoupons({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findAvailableCouponsQueryKey(options)
});
export const findApplicableCouponsQueryKey = (options: Options<FindApplicableCouponsData>) => createQueryKey('findApplicableCoupons', options);

/**
 * 결제 시 적용 가능한 쿠폰 목록 조회
 *
 * 결제 시 적용 가능한 쿠폰 목록 조회
 */
export const findApplicableCouponsOptions = (options: Options<FindApplicableCouponsData>) => queryOptions<FindApplicableCouponsResponse, FindApplicableCouponsError, FindApplicableCouponsResponse, ReturnType<typeof findApplicableCouponsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findApplicableCoupons({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findApplicableCouponsQueryKey(options)
});
export const getProductOptionsByIdQueryKey = (options: Options<GetProductOptionsByIdData>) => createQueryKey('getProductOptionsById', options);

/**
 * 상품 ID로 옵션 목록 조회 (옵션 변경용)
 */
export const getProductOptionsByIdOptions = (options: Options<GetProductOptionsByIdData>) => queryOptions<GetProductOptionsByIdResponse, GetProductOptionsByIdError, GetProductOptionsByIdResponse, ReturnType<typeof getProductOptionsByIdQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getProductOptionsById({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProductOptionsByIdQueryKey(options)
});
export const findCouponAvailableQueryKey = (options?: Options<FindCouponAvailableData>) => createQueryKey('findCouponAvailable', options);

/**
 * 쿠폰 다운로드 가능 여부 조회 (장바구니 배너용)
 *
 * 쿠폰 다운로드 가능 여부 조회.
 */
export const findCouponAvailableOptions = (options?: Options<FindCouponAvailableData>) => queryOptions<FindCouponAvailableResponse, FindCouponAvailableError, FindCouponAvailableResponse, ReturnType<typeof findCouponAvailableQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findCouponAvailable({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findCouponAvailableQueryKey(options)
});
export const getBeforeOrderQueryKey = (options: Options<GetBeforeOrderData>) => createQueryKey('getBeforeOrder', options);

/**
 * 사전주문 단건 조회
 *
 * 사전주문 단건 조회.
 */
export const getBeforeOrderOptions = (options: Options<GetBeforeOrderData>) => queryOptions<GetBeforeOrderResponse2, GetBeforeOrderError, GetBeforeOrderResponse2, ReturnType<typeof getBeforeOrderQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBeforeOrder({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBeforeOrderQueryKey(options)
});
export const findAllOrdersQueryKey = (options?: Options<FindAllOrdersData>) => createQueryKey('findAllOrders', options);

/**
 * 본인 주문 목록 조회
 *
 * 본인의 주문 목록을 페이징 조회합니다.
 */
export const findAllOrdersOptions = (options?: Options<FindAllOrdersData>) => queryOptions<FindAllOrdersResponse, FindAllOrdersError, FindAllOrdersResponse, ReturnType<typeof findAllOrdersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findAllOrders({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findAllOrdersQueryKey(options)
});
export const findAllOrdersInfiniteQueryKey = (options?: Options<FindAllOrdersData>): QueryKey<Options<FindAllOrdersData>> => createQueryKey('findAllOrders', options, true);

/**
 * 본인 주문 목록 조회
 *
 * 본인의 주문 목록을 페이징 조회합니다.
 */
export const findAllOrdersInfiniteOptions = (options?: Options<FindAllOrdersData>) => infiniteQueryOptions<FindAllOrdersResponse, FindAllOrdersError, InfiniteData<FindAllOrdersResponse>, QueryKey<Options<FindAllOrdersData>>, number | Pick<QueryKey<Options<FindAllOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<FindAllOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await findAllOrders({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findAllOrdersInfiniteQueryKey(options)
});
export const findOrderQueryKey = (options: Options<FindOrderData>) => createQueryKey('findOrder', options);

/**
 * 본인 주문 상세 조회
 *
 * 본인의 주문 단건 상세 정보를 조회합니다.
 */
export const findOrderOptions = (options: Options<FindOrderData>) => queryOptions<FindOrderResponse, FindOrderError, FindOrderResponse, ReturnType<typeof findOrderQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findOrder({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findOrderQueryKey(options)
});
export const getTransactionStatementQueryKey = (options: Options<GetTransactionStatementData>) => createQueryKey('getTransactionStatement', options);

/**
 * 거래명세서 조회
 *
 * 본인의 주문에 대한 거래명세서를 조회합니다.
 */
export const getTransactionStatementOptions = (options: Options<GetTransactionStatementData>) => queryOptions<GetTransactionStatementResponse, GetTransactionStatementError, GetTransactionStatementResponse, ReturnType<typeof getTransactionStatementQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getTransactionStatement({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTransactionStatementQueryKey(options)
});
export const getRefundInfoQueryKey = (options: Options<GetRefundInfoData>) => createQueryKey('getRefundInfo', options);

/**
 * 환불 정보 조회 (교환 제외)
 *
 * 주문의 환불 정보를 조회한다 (교환 제외).
 *
 * <p>결제 정보, 포인트/쿠폰 환불 현황, 반품 이력을 반환한다.</p>
 */
export const getRefundInfoOptions = (options: Options<GetRefundInfoData>) => queryOptions<GetRefundInfoResponse, GetRefundInfoError, GetRefundInfoResponse, ReturnType<typeof getRefundInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getRefundInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRefundInfoQueryKey(options)
});
export const getReceiptQueryKey = (options: Options<GetReceiptData>) => createQueryKey('getReceipt', options);

/**
 * 결제 영수증 조회
 *
 * 본인의 주문에 대한 결제 영수증을 조회합니다.
 */
export const getReceiptOptions = (options: Options<GetReceiptData>) => queryOptions<GetReceiptResponse, GetReceiptError, GetReceiptResponse, ReturnType<typeof getReceiptQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getReceipt({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getReceiptQueryKey(options)
});
export const getProductRefundInfoQueryKey = (options: Options<GetProductRefundInfoData>) => createQueryKey('getProductRefundInfo', options);

/**
 * 상품 기준 환불 정보 조회 (교환 제외)
 *
 * 주문-상품 기준 환불 정보를 조회한다 (교환 제외).
 *
 * <p>특정 상품 그룹의 결제/포인트/쿠폰 환불 현황과 반품 이력을 반환한다.</p>
 */
export const getProductRefundInfoOptions = (options: Options<GetProductRefundInfoData>) => queryOptions<GetProductRefundInfoResponse, GetProductRefundInfoError, GetProductRefundInfoResponse, ReturnType<typeof getProductRefundInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getProductRefundInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProductRefundInfoQueryKey(options)
});
export const getRefundEstimateQueryKey = (options: Options<GetRefundEstimateData>) => createQueryKey('getRefundEstimate', options);

/**
 * 상품 기준 환불 예상 금액 조회
 *
 * 상품 기준 환불 예상 금액 조회.
 *
 * <p>반품 요청 전, 해당 상품을 반품했을 때 예상되는 환불 금액을 미리 계산하여 반환한다.</p>
 */
export const getRefundEstimateOptions = (options: Options<GetRefundEstimateData>) => queryOptions<GetRefundEstimateResponse, GetRefundEstimateError, GetRefundEstimateResponse, ReturnType<typeof getRefundEstimateQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getRefundEstimate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRefundEstimateQueryKey(options)
});
export const getOrderItemsForActionQueryKey = (options: Options<GetOrderItemsForActionData>) => createQueryKey('getOrderItemsForAction', options);

/**
 * 취소/반품/교환용 주문 상품 조회
 *
 * 취소/반품/교환 화면에 필요한 주문 상품(옵션) 목록을 조회한다.
 */
export const getOrderItemsForActionOptions = (options: Options<GetOrderItemsForActionData>) => queryOptions<GetOrderItemsForActionResponse, GetOrderItemsForActionError, GetOrderItemsForActionResponse, ReturnType<typeof getOrderItemsForActionQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getOrderItemsForAction({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrderItemsForActionQueryKey(options)
});
export const getDeliveryTracking1QueryKey = (options: Options<GetDeliveryTracking1Data>) => createQueryKey('getDeliveryTracking1', options);

/**
 * 배송 조회
 *
 * 배송 조회.
 *
 * <p>굿스플로우 배송 추적 API를 통해 실시간 배송 상태 및 이력을 조회한다.
 * 주문 상세의 <code>deliveryId</code>를 사용하여 호출한다.</p>
 */
export const getDeliveryTracking1Options = (options: Options<GetDeliveryTracking1Data>) => queryOptions<GetDeliveryTracking1Response, GetDeliveryTracking1Error, GetDeliveryTracking1Response, ReturnType<typeof getDeliveryTracking1QueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDeliveryTracking1({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryTracking1QueryKey(options)
});
export const findUnifiedOrdersQueryKey = (options?: Options<FindUnifiedOrdersData>) => createQueryKey('findUnifiedOrders', options);

/**
 * 통합 주문 목록 조회 (기부몰 + 포인트몰)
 *
 * 통합 주문 목록을 조회합니다 (기부몰 + 포인트몰).
 */
export const findUnifiedOrdersOptions = (options?: Options<FindUnifiedOrdersData>) => queryOptions<FindUnifiedOrdersResponse, FindUnifiedOrdersError, FindUnifiedOrdersResponse, ReturnType<typeof findUnifiedOrdersQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findUnifiedOrders({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findUnifiedOrdersQueryKey(options)
});
export const findUnifiedOrdersInfiniteQueryKey = (options?: Options<FindUnifiedOrdersData>): QueryKey<Options<FindUnifiedOrdersData>> => createQueryKey('findUnifiedOrders', options, true);

/**
 * 통합 주문 목록 조회 (기부몰 + 포인트몰)
 *
 * 통합 주문 목록을 조회합니다 (기부몰 + 포인트몰).
 */
export const findUnifiedOrdersInfiniteOptions = (options?: Options<FindUnifiedOrdersData>) => infiniteQueryOptions<FindUnifiedOrdersResponse, FindUnifiedOrdersError, InfiniteData<FindUnifiedOrdersResponse>, QueryKey<Options<FindUnifiedOrdersData>>, number | Pick<QueryKey<Options<FindUnifiedOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<FindUnifiedOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await findUnifiedOrders({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findUnifiedOrdersInfiniteQueryKey(options)
});
export const findOrderByNumberQueryKey = (options: Options<FindOrderByNumberData>) => createQueryKey('findOrderByNumber', options);

/**
 * 본인 주문 상세 조회 (주문번호)
 *
 * 주문번호(orderNo)로 본인의 주문 상세 정보를 조회합니다.
 */
export const findOrderByNumberOptions = (options: Options<FindOrderByNumberData>) => queryOptions<FindOrderByNumberResponse, FindOrderByNumberError, FindOrderByNumberResponse, ReturnType<typeof findOrderByNumberQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findOrderByNumber({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findOrderByNumberQueryKey(options)
});
export const confirmHouseholdInfoAgreementQueryKey = (options: Options<ConfirmHouseholdInfoAgreementData>) => createQueryKey('confirmHouseholdInfoAgreement', options);

/**
 * 1. 가구원 정보제공 동의 링크 조회
 */
export const confirmHouseholdInfoAgreementOptions = (options: Options<ConfirmHouseholdInfoAgreementData>) => queryOptions<ConfirmHouseholdInfoAgreementResponse2, ConfirmHouseholdInfoAgreementError, ConfirmHouseholdInfoAgreementResponse2, ReturnType<typeof confirmHouseholdInfoAgreementQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await confirmHouseholdInfoAgreement({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: confirmHouseholdInfoAgreementQueryKey(options)
});
export const hometownNewsListQueryKey = (options: Options<HometownNewsListData>) => createQueryKey('hometownNewsList', options);

/**
 * 동네 소식 콘텐츠 목록
 */
export const hometownNewsListOptions = (options: Options<HometownNewsListData>) => queryOptions<HometownNewsListResponse, HometownNewsListError, HometownNewsListResponse, ReturnType<typeof hometownNewsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await hometownNewsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: hometownNewsListQueryKey(options)
});
export const hometownNewsListInfiniteQueryKey = (options: Options<HometownNewsListData>): QueryKey<Options<HometownNewsListData>> => createQueryKey('hometownNewsList', options, true);

/**
 * 동네 소식 콘텐츠 목록
 */
export const hometownNewsListInfiniteOptions = (options: Options<HometownNewsListData>) => infiniteQueryOptions<HometownNewsListResponse, HometownNewsListError, InfiniteData<HometownNewsListResponse>, QueryKey<Options<HometownNewsListData>>, number | Pick<QueryKey<Options<HometownNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<HometownNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await hometownNewsList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: hometownNewsListInfiniteQueryKey(options)
});
export const hometownNewsQueryKey = (options: Options<HometownNewsData>) => createQueryKey('hometownNews', options);

/**
 * 동네 소식 콘텐츠 상세
 */
export const hometownNewsOptions = (options: Options<HometownNewsData>) => queryOptions<HometownNewsResponse, HometownNewsError, HometownNewsResponse, ReturnType<typeof hometownNewsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await hometownNews({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: hometownNewsQueryKey(options)
});
export const getPopularHometownNewsListQueryKey = (options?: Options<GetPopularHometownNewsListData>) => createQueryKey('getPopularHometownNewsList', options);

/**
 * 인기 동네 소식 목록
 */
export const getPopularHometownNewsListOptions = (options?: Options<GetPopularHometownNewsListData>) => queryOptions<GetPopularHometownNewsListResponse, GetPopularHometownNewsListError, GetPopularHometownNewsListResponse, ReturnType<typeof getPopularHometownNewsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPopularHometownNewsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPopularHometownNewsListQueryKey(options)
});
export const getPopularHometownNewsListForCommunityQueryKey = (options?: Options<GetPopularHometownNewsListForCommunityData>) => createQueryKey('getPopularHometownNewsListForCommunity', options);

/**
 * 커뮤니티 인기 동네 소식 목록
 */
export const getPopularHometownNewsListForCommunityOptions = (options?: Options<GetPopularHometownNewsListForCommunityData>) => queryOptions<GetPopularHometownNewsListForCommunityResponse, GetPopularHometownNewsListForCommunityError, GetPopularHometownNewsListForCommunityResponse, ReturnType<typeof getPopularHometownNewsListForCommunityQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPopularHometownNewsListForCommunity({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPopularHometownNewsListForCommunityQueryKey(options)
});
export const hometownNewsFeedbackQueryKey = (options: Options<HometownNewsFeedbackData>) => createQueryKey('hometownNewsFeedback', options);

/**
 * 로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedbackOptions = (options: Options<HometownNewsFeedbackData>) => queryOptions<HometownNewsFeedbackResponse, HometownNewsFeedbackError, HometownNewsFeedbackResponse, ReturnType<typeof hometownNewsFeedbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await hometownNewsFeedback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: hometownNewsFeedbackQueryKey(options)
});
export const getHomeInstitutionPolicyListQueryKey = (options: Options<GetHomeInstitutionPolicyListData>) => createQueryKey('getHomeInstitutionPolicyList', options);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListOptions = (options: Options<GetHomeInstitutionPolicyListData>) => queryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, ReturnType<typeof getHomeInstitutionPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInstitutionPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInstitutionPolicyListQueryKey(options)
});
export const getHomeInstitutionPolicyListInfiniteQueryKey = (options: Options<GetHomeInstitutionPolicyListData>): QueryKey<Options<GetHomeInstitutionPolicyListData>> => createQueryKey('getHomeInstitutionPolicyList', options, true);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListInfiniteOptions = (options: Options<GetHomeInstitutionPolicyListData>) => infiniteQueryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, InfiniteData<GetHomeInstitutionPolicyListResponse>, QueryKey<Options<GetHomeInstitutionPolicyListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getHomeInstitutionPolicyList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInstitutionPolicyListInfiniteQueryKey(options)
});
export const getHomeInstitutionEventListQueryKey = (options?: Options<GetHomeInstitutionEventListData>) => createQueryKey('getHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListOptions = (options?: Options<GetHomeInstitutionEventListData>) => queryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, ReturnType<typeof getHomeInstitutionEventListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInstitutionEventList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInstitutionEventListQueryKey(options)
});
export const getHomeInstitutionEventListInfiniteQueryKey = (options?: Options<GetHomeInstitutionEventListData>): QueryKey<Options<GetHomeInstitutionEventListData>> => createQueryKey('getHomeInstitutionEventList', options, true);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListInfiniteOptions = (options?: Options<GetHomeInstitutionEventListData>) => infiniteQueryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, InfiniteData<GetHomeInstitutionEventListResponse>, QueryKey<Options<GetHomeInstitutionEventListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getHomeInstitutionEventList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInstitutionEventListInfiniteQueryKey(options)
});
export const getOrderedHomeInstitutionEventListQueryKey = (options?: Options<GetOrderedHomeInstitutionEventListData>) => createQueryKey('getOrderedHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventListOptions = (options?: Options<GetOrderedHomeInstitutionEventListData>) => queryOptions<GetOrderedHomeInstitutionEventListResponse, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, ReturnType<typeof getOrderedHomeInstitutionEventListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getOrderedHomeInstitutionEventList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrderedHomeInstitutionEventListQueryKey(options)
});
export const getGiftOrderHistoryListQueryKey = (options: Options<GetGiftOrderHistoryListData>) => createQueryKey('getGiftOrderHistoryList', options);

/**
 * 답례품 주문 목록
 */
export const getGiftOrderHistoryListOptions = (options: Options<GetGiftOrderHistoryListData>) => queryOptions<GetGiftOrderHistoryListResponse, GetGiftOrderHistoryListError, GetGiftOrderHistoryListResponse, ReturnType<typeof getGiftOrderHistoryListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getGiftOrderHistoryList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderHistoryListQueryKey(options)
});
export const getGiftOrderHistoryListInfiniteQueryKey = (options: Options<GetGiftOrderHistoryListData>): QueryKey<Options<GetGiftOrderHistoryListData>> => createQueryKey('getGiftOrderHistoryList', options, true);

/**
 * 답례품 주문 목록
 */
export const getGiftOrderHistoryListInfiniteOptions = (options: Options<GetGiftOrderHistoryListData>) => infiniteQueryOptions<GetGiftOrderHistoryListResponse, GetGiftOrderHistoryListError, InfiniteData<GetGiftOrderHistoryListResponse>, QueryKey<Options<GetGiftOrderHistoryListData>>, number | Pick<QueryKey<Options<GetGiftOrderHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetGiftOrderHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getGiftOrderHistoryList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderHistoryListInfiniteQueryKey(options)
});
export const getGiftOrderHistoryQueryKey = (options: Options<GetGiftOrderHistoryData>) => createQueryKey('getGiftOrderHistory', options);

/**
 * 답례품 주문 상세
 */
export const getGiftOrderHistoryOptions = (options: Options<GetGiftOrderHistoryData>) => queryOptions<GetGiftOrderHistoryResponse, GetGiftOrderHistoryError, GetGiftOrderHistoryResponse, ReturnType<typeof getGiftOrderHistoryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getGiftOrderHistory({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderHistoryQueryKey(options)
});
export const getDeliveryTracking2QueryKey = (options: Options<GetDeliveryTracking2Data>) => createQueryKey('getDeliveryTracking2', options);

/**
 * 답례품 주문 배송조회
 */
export const getDeliveryTracking2Options = (options: Options<GetDeliveryTracking2Data>) => queryOptions<GetDeliveryTracking2Response, GetDeliveryTracking2Error, GetDeliveryTracking2Response, ReturnType<typeof getDeliveryTracking2QueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDeliveryTracking2({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDeliveryTracking2QueryKey(options)
});

/**
 * 리뷰 삭제
 */
export const removeGiftOrderProductReviewMutation = (options?: Partial<Options<RemoveGiftOrderProductReviewData>>): UseMutationOptions<RemoveGiftOrderProductReviewResponse, RemoveGiftOrderProductReviewError, Options<RemoveGiftOrderProductReviewData>> => {
  const mutationOptions: UseMutationOptions<RemoveGiftOrderProductReviewResponse, RemoveGiftOrderProductReviewError, Options<RemoveGiftOrderProductReviewData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await removeGiftOrderProductReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export const getGiftOrderProductReviewQueryKey = (options: Options<GetGiftOrderProductReviewData>) => createQueryKey('getGiftOrderProductReview', options);

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReviewOptions = (options: Options<GetGiftOrderProductReviewData>) => queryOptions<GetGiftOrderProductReviewResponse, GetGiftOrderProductReviewError, GetGiftOrderProductReviewResponse, ReturnType<typeof getGiftOrderProductReviewQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getGiftOrderProductReview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGiftOrderProductReviewQueryKey(options)
});
export const getMyGiftOrderProductReviewListQueryKey = (options?: Options<GetMyGiftOrderProductReviewListData>) => createQueryKey('getMyGiftOrderProductReviewList', options);

/**
 * 나의 리뷰 목록 조회
 */
export const getMyGiftOrderProductReviewListOptions = (options?: Options<GetMyGiftOrderProductReviewListData>) => queryOptions<GetMyGiftOrderProductReviewListResponse, GetMyGiftOrderProductReviewListError, GetMyGiftOrderProductReviewListResponse, ReturnType<typeof getMyGiftOrderProductReviewListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyGiftOrderProductReviewList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyGiftOrderProductReviewListQueryKey(options)
});
export const getMyGiftOrderProductReviewListInfiniteQueryKey = (options?: Options<GetMyGiftOrderProductReviewListData>): QueryKey<Options<GetMyGiftOrderProductReviewListData>> => createQueryKey('getMyGiftOrderProductReviewList', options, true);

/**
 * 나의 리뷰 목록 조회
 */
export const getMyGiftOrderProductReviewListInfiniteOptions = (options?: Options<GetMyGiftOrderProductReviewListData>) => infiniteQueryOptions<GetMyGiftOrderProductReviewListResponse, GetMyGiftOrderProductReviewListError, InfiniteData<GetMyGiftOrderProductReviewListResponse>, QueryKey<Options<GetMyGiftOrderProductReviewListData>>, number | Pick<QueryKey<Options<GetMyGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetMyGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getMyGiftOrderProductReviewList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyGiftOrderProductReviewListInfiniteQueryKey(options)
});
export const getDecemberRandomTicketCountQueryKey = (options?: Options<GetDecemberRandomTicketCountData>) => createQueryKey('getDecemberRandomTicketCount', options);

/**
 * 지급받은 랜덤티켓 수 및 참여 가능한지 여부 조회
 */
export const getDecemberRandomTicketCountOptions = (options?: Options<GetDecemberRandomTicketCountData>) => queryOptions<GetDecemberRandomTicketCountResponse, GetDecemberRandomTicketCountError, GetDecemberRandomTicketCountResponse, ReturnType<typeof getDecemberRandomTicketCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDecemberRandomTicketCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDecemberRandomTicketCountQueryKey(options)
});
export const getPrimaryDeliveryAddressQueryKey = (options?: Options<GetPrimaryDeliveryAddressData>) => createQueryKey('getPrimaryDeliveryAddress', options);

/**
 * 기본 배송지 상세 조회
 */
export const getPrimaryDeliveryAddressOptions = (options?: Options<GetPrimaryDeliveryAddressData>) => queryOptions<GetPrimaryDeliveryAddressResponse, GetPrimaryDeliveryAddressError, GetPrimaryDeliveryAddressResponse, ReturnType<typeof getPrimaryDeliveryAddressQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPrimaryDeliveryAddress({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPrimaryDeliveryAddressQueryKey(options)
});
export const getHomeNoticeListQueryKey = (options?: Options<GetHomeNoticeListData>) => createQueryKey('getHomeNoticeList', options);

/**
 * 목록 조회
 */
export const getHomeNoticeListOptions = (options?: Options<GetHomeNoticeListData>) => queryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, GetHomeNoticeListResponse, ReturnType<typeof getHomeNoticeListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeNoticeList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeNoticeListQueryKey(options)
});
export const getHomeNoticeListInfiniteQueryKey = (options?: Options<GetHomeNoticeListData>): QueryKey<Options<GetHomeNoticeListData>> => createQueryKey('getHomeNoticeList', options, true);

/**
 * 목록 조회
 */
export const getHomeNoticeListInfiniteOptions = (options?: Options<GetHomeNoticeListData>) => infiniteQueryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, InfiniteData<GetHomeNoticeListResponse>, QueryKey<Options<GetHomeNoticeListData>>, number | Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getHomeNoticeList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeNoticeListInfiniteQueryKey(options)
});
export const checkMemberQueryKey = (options?: Options<CheckMemberData>) => createQueryKey('checkMember', options);

/**
 * 회원여부 조회
 */
export const checkMemberOptions = (options?: Options<CheckMemberData>) => queryOptions<CheckMemberResponse, CheckMemberError, CheckMemberResponse, ReturnType<typeof checkMemberQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkMember({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkMemberQueryKey(options)
});
export const getHomeLoveMainInstitutionEventListQueryKey = (options?: Options<GetHomeLoveMainInstitutionEventListData>) => createQueryKey('getHomeLoveMainInstitutionEventList', options);

/**
 * 1. 지자체 이벤트
 */
export const getHomeLoveMainInstitutionEventListOptions = (options?: Options<GetHomeLoveMainInstitutionEventListData>) => queryOptions<GetHomeLoveMainInstitutionEventListResponse, GetHomeLoveMainInstitutionEventListError, GetHomeLoveMainInstitutionEventListResponse, ReturnType<typeof getHomeLoveMainInstitutionEventListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeLoveMainInstitutionEventList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeLoveMainInstitutionEventListQueryKey(options)
});
export const latestCompleteDonationQueryKey = (options?: Options<LatestCompleteDonationData>) => createQueryKey('latestCompleteDonation', options);

/**
 * 최근 기부 정보 조회
 */
export const latestCompleteDonationOptions = (options?: Options<LatestCompleteDonationData>) => queryOptions<LatestCompleteDonationResponse, LatestCompleteDonationError, LatestCompleteDonationResponse, ReturnType<typeof latestCompleteDonationQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await latestCompleteDonation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestCompleteDonationQueryKey(options)
});
export const getHomeInquiryMyListQueryKey = (options?: Options<GetHomeInquiryMyListData>) => createQueryKey('getHomeInquiryMyList', options);

/**
 * 1:1 문의 내 목록 조회
 */
export const getHomeInquiryMyListOptions = (options?: Options<GetHomeInquiryMyListData>) => queryOptions<GetHomeInquiryMyListResponse, GetHomeInquiryMyListError, GetHomeInquiryMyListResponse, ReturnType<typeof getHomeInquiryMyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInquiryMyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInquiryMyListQueryKey(options)
});
export const getMyDonationInfoQueryKey = (options?: Options<GetMyDonationInfoData>) => createQueryKey('getMyDonationInfo', options);

/**
 * 나의 기부 관련 내역 조회
 */
export const getMyDonationInfoOptions = (options?: Options<GetMyDonationInfoData>) => queryOptions<GetMyDonationInfoResponse, GetMyDonationInfoError, GetMyDonationInfoResponse, ReturnType<typeof getMyDonationInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyDonationInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyDonationInfoQueryKey(options)
});
export const getHomeDonationHistoryListQueryKey = (options: Options<GetHomeDonationHistoryListData>) => createQueryKey('getHomeDonationHistoryList', options);

/**
 * 기부내역 조회
 */
export const getHomeDonationHistoryListOptions = (options: Options<GetHomeDonationHistoryListData>) => queryOptions<GetHomeDonationHistoryListResponse, GetHomeDonationHistoryListError, GetHomeDonationHistoryListResponse, ReturnType<typeof getHomeDonationHistoryListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeDonationHistoryList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeDonationHistoryListQueryKey(options)
});
export const getHomeDonationHistoryListInfiniteQueryKey = (options: Options<GetHomeDonationHistoryListData>): QueryKey<Options<GetHomeDonationHistoryListData>> => createQueryKey('getHomeDonationHistoryList', options, true);

/**
 * 기부내역 조회
 */
export const getHomeDonationHistoryListInfiniteOptions = (options: Options<GetHomeDonationHistoryListData>) => infiniteQueryOptions<GetHomeDonationHistoryListResponse, GetHomeDonationHistoryListError, InfiniteData<GetHomeDonationHistoryListResponse>, QueryKey<Options<GetHomeDonationHistoryListData>>, number | Pick<QueryKey<Options<GetHomeDonationHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetHomeDonationHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getHomeDonationHistoryList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeDonationHistoryListInfiniteQueryKey(options)
});
export const getEventLocalTourQueryKey = (options?: Options<GetEventLocalTourData>) => createQueryKey('getEventLocalTour', options);

/**
 * 웰로투(웰로로컬투어) 이벤트 참여 정보 조회
 *
 * @deprecated
 */
export const getEventLocalTourOptions = (options?: Options<GetEventLocalTourData>) => queryOptions<GetEventLocalTourResponse, GetEventLocalTourError, GetEventLocalTourResponse, ReturnType<typeof getEventLocalTourQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getEventLocalTour({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEventLocalTourQueryKey(options)
});
export const getHomeDonationHistoryQueryKey = (options: Options<GetHomeDonationHistoryData>) => createQueryKey('getHomeDonationHistory', options);

/**
 * 기부내역 상세 조회
 */
export const getHomeDonationHistoryOptions = (options: Options<GetHomeDonationHistoryData>) => queryOptions<GetHomeDonationHistoryResponse, GetHomeDonationHistoryError, GetHomeDonationHistoryResponse, ReturnType<typeof getHomeDonationHistoryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeDonationHistory({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeDonationHistoryQueryKey(options)
});
export const getHomeInstitutionCertificateQueryKey = (options?: Options<GetHomeInstitutionCertificateData>) => createQueryKey('getHomeInstitutionCertificate', options);

/**
 * 제주패스 기부증서 조회
 */
export const getHomeInstitutionCertificateOptions = (options?: Options<GetHomeInstitutionCertificateData>) => queryOptions<GetHomeInstitutionCertificateResponse, GetHomeInstitutionCertificateError, GetHomeInstitutionCertificateResponse, ReturnType<typeof getHomeInstitutionCertificateQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getHomeInstitutionCertificate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getHomeInstitutionCertificateQueryKey(options)
});
export const getLatestHomeInstitutionCertificateQueryKey = (options?: Options<GetLatestHomeInstitutionCertificateData>) => createQueryKey('getLatestHomeInstitutionCertificate', options);

/**
 * 최근 투주패스 기부증서 아이디 조회
 */
export const getLatestHomeInstitutionCertificateOptions = (options?: Options<GetLatestHomeInstitutionCertificateData>) => queryOptions<GetLatestHomeInstitutionCertificateResponse, GetLatestHomeInstitutionCertificateError, GetLatestHomeInstitutionCertificateResponse, ReturnType<typeof getLatestHomeInstitutionCertificateQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getLatestHomeInstitutionCertificate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLatestHomeInstitutionCertificateQueryKey(options)
});
export const getParticipantDonationEventListQueryKey = (options: Options<GetParticipantDonationEventListData>) => createQueryKey('getParticipantDonationEventList', options);

/**
 * 참여한 이벤트 목록
 */
export const getParticipantDonationEventListOptions = (options: Options<GetParticipantDonationEventListData>) => queryOptions<GetParticipantDonationEventListResponse, GetParticipantDonationEventListError, GetParticipantDonationEventListResponse, ReturnType<typeof getParticipantDonationEventListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getParticipantDonationEventList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getParticipantDonationEventListQueryKey(options)
});
export const isEventInProgressQueryKey = (options: Options<IsEventInProgressData>) => createQueryKey('isEventInProgress', options);

/**
 * 이벤트 진행 여부
 */
export const isEventInProgressOptions = (options: Options<IsEventInProgressData>) => queryOptions<IsEventInProgressResponse, IsEventInProgressError, IsEventInProgressResponse, ReturnType<typeof isEventInProgressQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await isEventInProgress({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: isEventInProgressQueryKey(options)
});
export const preselectionStatusQueryKey = (options?: Options<PreselectionStatusData>) => createQueryKey('preselectionStatus', options);

/**
 * 사전 뽑기 참여여부
 */
export const preselectionStatusOptions = (options?: Options<PreselectionStatusData>) => queryOptions<PreselectionStatusResponse, PreselectionStatusError, PreselectionStatusResponse, ReturnType<typeof preselectionStatusQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await preselectionStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: preselectionStatusQueryKey(options)
});
export const getEventHistoryListQueryKey = (options?: Options<GetEventHistoryListData>) => createQueryKey('getEventHistoryList', options);

/**
 * 포인트 지급 목록
 */
export const getEventHistoryListOptions = (options?: Options<GetEventHistoryListData>) => queryOptions<GetEventHistoryListResponse, GetEventHistoryListError, GetEventHistoryListResponse, ReturnType<typeof getEventHistoryListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getEventHistoryList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEventHistoryListQueryKey(options)
});
export const getEventHistoryListInfiniteQueryKey = (options?: Options<GetEventHistoryListData>): QueryKey<Options<GetEventHistoryListData>> => createQueryKey('getEventHistoryList', options, true);

/**
 * 포인트 지급 목록
 */
export const getEventHistoryListInfiniteOptions = (options?: Options<GetEventHistoryListData>) => infiniteQueryOptions<GetEventHistoryListResponse, GetEventHistoryListError, InfiniteData<GetEventHistoryListResponse>, QueryKey<Options<GetEventHistoryListData>>, number | Pick<QueryKey<Options<GetEventHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetEventHistoryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getEventHistoryList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEventHistoryListInfiniteQueryKey(options)
});
export const getMyInviteEventHistorySummaryQueryKey = (options?: Options<GetMyInviteEventHistorySummaryData>) => createQueryKey('getMyInviteEventHistorySummary', options);

/**
 * 이벤트 요약(총 적립금, 가입한 친구, 친구 기부 횟수)
 */
export const getMyInviteEventHistorySummaryOptions = (options?: Options<GetMyInviteEventHistorySummaryData>) => queryOptions<GetMyInviteEventHistorySummaryResponse, GetMyInviteEventHistorySummaryError, GetMyInviteEventHistorySummaryResponse, ReturnType<typeof getMyInviteEventHistorySummaryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyInviteEventHistorySummary({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyInviteEventHistorySummaryQueryKey(options)
});
export const getInviteeEventReceivedQueryKey = (options: Options<GetInviteeEventReceivedData>) => createQueryKey('getInviteeEventReceived', options);

/**
 * 초대 이벤트 참여 여부
 */
export const getInviteeEventReceivedOptions = (options: Options<GetInviteeEventReceivedData>) => queryOptions<GetInviteeEventReceivedResponse, GetInviteeEventReceivedError, GetInviteeEventReceivedResponse, ReturnType<typeof getInviteeEventReceivedQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getInviteeEventReceived({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInviteeEventReceivedQueryKey(options)
});
export const getUnopenedGiftBoxIndicatorsQueryKey = (options?: Options<GetUnopenedGiftBoxIndicatorsData>) => createQueryKey('getUnopenedGiftBoxIndicators', options);

/**
 * 화면별 미개봉 선물박스 표시 여부
 */
export const getUnopenedGiftBoxIndicatorsOptions = (options?: Options<GetUnopenedGiftBoxIndicatorsData>) => queryOptions<GetUnopenedGiftBoxIndicatorsResponse, GetUnopenedGiftBoxIndicatorsError, GetUnopenedGiftBoxIndicatorsResponse, ReturnType<typeof getUnopenedGiftBoxIndicatorsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getUnopenedGiftBoxIndicators({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUnopenedGiftBoxIndicatorsQueryKey(options)
});
export const getUnopenedEventGiftBoxCountQueryKey = (options?: Options<GetUnopenedEventGiftBoxCountData>) => createQueryKey('getUnopenedEventGiftBoxCount', options);

/**
 * 열지 않은 선물 상자 수 조회
 */
export const getUnopenedEventGiftBoxCountOptions = (options?: Options<GetUnopenedEventGiftBoxCountData>) => queryOptions<GetUnopenedEventGiftBoxCountResponse, GetUnopenedEventGiftBoxCountError, GetUnopenedEventGiftBoxCountResponse, ReturnType<typeof getUnopenedEventGiftBoxCountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getUnopenedEventGiftBoxCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUnopenedEventGiftBoxCountQueryKey(options)
});
export const getMyInviteEventGiftBoxSummaryQueryKey = (options?: Options<GetMyInviteEventGiftBoxSummaryData>) => createQueryKey('getMyInviteEventGiftBoxSummary', options);

/**
 * 이벤트 요약(총 적립금, 가입한 친구, 친구 기부 횟수)
 */
export const getMyInviteEventGiftBoxSummaryOptions = (options?: Options<GetMyInviteEventGiftBoxSummaryData>) => queryOptions<GetMyInviteEventGiftBoxSummaryResponse, GetMyInviteEventGiftBoxSummaryError, GetMyInviteEventGiftBoxSummaryResponse, ReturnType<typeof getMyInviteEventGiftBoxSummaryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyInviteEventGiftBoxSummary({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyInviteEventGiftBoxSummaryQueryKey(options)
});
export const getOpenedEventGiftBoxListQueryKey = (options?: Options<GetOpenedEventGiftBoxListData>) => createQueryKey('getOpenedEventGiftBoxList', options);

/**
 * 선물 상자 목록 조회
 */
export const getOpenedEventGiftBoxListOptions = (options?: Options<GetOpenedEventGiftBoxListData>) => queryOptions<GetOpenedEventGiftBoxListResponse, GetOpenedEventGiftBoxListError, GetOpenedEventGiftBoxListResponse, ReturnType<typeof getOpenedEventGiftBoxListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getOpenedEventGiftBoxList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOpenedEventGiftBoxListQueryKey(options)
});
export const getOpenedEventGiftBoxListInfiniteQueryKey = (options?: Options<GetOpenedEventGiftBoxListData>): QueryKey<Options<GetOpenedEventGiftBoxListData>> => createQueryKey('getOpenedEventGiftBoxList', options, true);

/**
 * 선물 상자 목록 조회
 */
export const getOpenedEventGiftBoxListInfiniteOptions = (options?: Options<GetOpenedEventGiftBoxListData>) => infiniteQueryOptions<GetOpenedEventGiftBoxListResponse, GetOpenedEventGiftBoxListError, InfiniteData<GetOpenedEventGiftBoxListResponse>, QueryKey<Options<GetOpenedEventGiftBoxListData>>, number | Pick<QueryKey<Options<GetOpenedEventGiftBoxListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetOpenedEventGiftBoxListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getOpenedEventGiftBoxList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOpenedEventGiftBoxListInfiniteQueryKey(options)
});
export const getInviteeGiftBoxReceivedQueryKey = (options?: Options<GetInviteeGiftBoxReceivedData>) => createQueryKey('getInviteeGiftBoxReceived', options);

/**
 * 초대 선물 박스 수령 여부
 */
export const getInviteeGiftBoxReceivedOptions = (options?: Options<GetInviteeGiftBoxReceivedData>) => queryOptions<GetInviteeGiftBoxReceivedResponse, GetInviteeGiftBoxReceivedError, GetInviteeGiftBoxReceivedResponse, ReturnType<typeof getInviteeGiftBoxReceivedQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getInviteeGiftBoxReceived({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInviteeGiftBoxReceivedQueryKey(options)
});
export const getEmergencyRoomListQueryKey = (options: Options<GetEmergencyRoomListData>) => createQueryKey('getEmergencyRoomList', options);

/**
 * 병원 상세 조회
 */
export const getEmergencyRoomListOptions = (options: Options<GetEmergencyRoomListData>) => queryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, GetEmergencyRoomListResponse, ReturnType<typeof getEmergencyRoomListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getEmergencyRoomList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEmergencyRoomListQueryKey(options)
});
export const getEmergencyRoomListInfiniteQueryKey = (options: Options<GetEmergencyRoomListData>): QueryKey<Options<GetEmergencyRoomListData>> => createQueryKey('getEmergencyRoomList', options, true);

/**
 * 병원 상세 조회
 */
export const getEmergencyRoomListInfiniteOptions = (options: Options<GetEmergencyRoomListData>) => infiniteQueryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, InfiniteData<GetEmergencyRoomListResponse>, QueryKey<Options<GetEmergencyRoomListData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getEmergencyRoomList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEmergencyRoomListInfiniteQueryKey(options)
});
export const getEmergencyRoomQueryKey = (options: Options<GetEmergencyRoomData>) => createQueryKey('getEmergencyRoom', options);

/**
 * 병원 상세 조회
 */
export const getEmergencyRoomOptions = (options: Options<GetEmergencyRoomData>) => queryOptions<GetEmergencyRoomResponse, GetEmergencyRoomError, GetEmergencyRoomResponse, ReturnType<typeof getEmergencyRoomQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getEmergencyRoom({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEmergencyRoomQueryKey(options)
});
export const getDetailTermsOfServiceQueryKey = (options?: Options<GetDetailTermsOfServiceData>) => createQueryKey('getDetailTermsOfService', options);

/**
 * DLP 서울특별시 이용약관 요청
 *
 * 서울특별시 이용약관 정보를 요청합니다..
 */
export const getDetailTermsOfServiceOptions = (options?: Options<GetDetailTermsOfServiceData>) => queryOptions<GetDetailTermsOfServiceResponse, GetDetailTermsOfServiceError, GetDetailTermsOfServiceResponse, ReturnType<typeof getDetailTermsOfServiceQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDetailTermsOfService({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDetailTermsOfServiceQueryKey(options)
});
export const getDetailTermsOfPrivacyQueryKey = (options?: Options<GetDetailTermsOfPrivacyData>) => createQueryKey('getDetailTermsOfPrivacy', options);

/**
 * DLP 서울특별시 개인정보 수집이용내역 요청
 *
 * 서울특별시 개인정보 수집이용내역을 요청합니다..
 */
export const getDetailTermsOfPrivacyOptions = (options?: Options<GetDetailTermsOfPrivacyData>) => queryOptions<GetDetailTermsOfPrivacyResponse, GetDetailTermsOfPrivacyError, GetDetailTermsOfPrivacyResponse, ReturnType<typeof getDetailTermsOfPrivacyQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getDetailTermsOfPrivacy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDetailTermsOfPrivacyQueryKey(options)
});
export const checkDlpGyeonggiAccountQueryKey = (options?: Options<CheckDlpGyeonggiAccountData>) => createQueryKey('checkDlpGyeonggiAccount', options);

/**
 * 계정정보 확인 및 로그인
 *
 * 계정정보가 있는지 확인 후 로그인을 시도합니다.
 */
export const checkDlpGyeonggiAccountOptions = (options?: Options<CheckDlpGyeonggiAccountData>) => queryOptions<CheckDlpGyeonggiAccountResponse2, CheckDlpGyeonggiAccountError, CheckDlpGyeonggiAccountResponse2, ReturnType<typeof checkDlpGyeonggiAccountQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await checkDlpGyeonggiAccount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: checkDlpGyeonggiAccountQueryKey(options)
});
export const getInquiryQueryKey = (options: Options<GetInquiryData>) => createQueryKey('getInquiry', options);

/**
 * 문의상세 조회
 *
 * 문의 상세 내역을 조회합니다
 */
export const getInquiryOptions = (options: Options<GetInquiryData>) => queryOptions<GetInquiryResponse, GetInquiryError, GetInquiryResponse, ReturnType<typeof getInquiryQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getInquiry({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getInquiryQueryKey(options)
});
export const situationListQueryKey = (options?: Options<SituationListData>) => createQueryKey('situationList', options);

/**
 * 정책 꾸러미 목록 조회
 *
 * 정책 꾸러미 목록을 조회합니다
 */
export const situationListOptions = (options?: Options<SituationListData>) => queryOptions<SituationListResponse2, SituationListError, SituationListResponse2, ReturnType<typeof situationListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await situationList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: situationListQueryKey(options)
});
export const getSituationPolicyListQueryKey = (options: Options<GetSituationPolicyListData>) => createQueryKey('getSituationPolicyList', options);

/**
 * 정책 꾸러미 정책 목록 조회
 *
 * 정책 꾸러미 정책 목록을 조회합니다
 */
export const getSituationPolicyListOptions = (options: Options<GetSituationPolicyListData>) => queryOptions<GetSituationPolicyListResponse, GetSituationPolicyListError, GetSituationPolicyListResponse, ReturnType<typeof getSituationPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getSituationPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSituationPolicyListQueryKey(options)
});
export const welloPickListQueryKey = (options?: Options<WelloPickListData>) => createQueryKey('welloPickList', options);

/**
 * 웰로 대상별 정책 - 대상 조회
 *
 * 웰로 대상별 정책 - 대상 정보를 조회합니다
 */
export const welloPickListOptions = (options?: Options<WelloPickListData>) => queryOptions<WelloPickListResponse, WelloPickListError, WelloPickListResponse, ReturnType<typeof welloPickListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await welloPickList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: welloPickListQueryKey(options)
});
export const welloPickPolicyListQueryKey = (options: Options<WelloPickPolicyListData>) => createQueryKey('welloPickPolicyList', options);

/**
 * 웰로 대상별 정책 조회
 *
 * 웰로 대상별 정책 정보를 조회합니다
 */
export const welloPickPolicyListOptions = (options: Options<WelloPickPolicyListData>) => queryOptions<WelloPickPolicyListResponse, WelloPickPolicyListError, WelloPickPolicyListResponse, ReturnType<typeof welloPickPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await welloPickPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: welloPickPolicyListQueryKey(options)
});
export const bestContentsFeedbackQueryKey = (options: Options<BestContentsFeedbackData>) => createQueryKey('bestContentsFeedback', options);

/**
 * 로그인 멤버 정책 소식 좋아요&스크랩 정보 조회
 */
export const bestContentsFeedbackOptions = (options: Options<BestContentsFeedbackData>) => queryOptions<BestContentsFeedbackResponse, BestContentsFeedbackError, BestContentsFeedbackResponse, ReturnType<typeof bestContentsFeedbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await bestContentsFeedback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bestContentsFeedbackQueryKey(options)
});
export const bestContentsListQueryKey = (options: Options<BestContentsListData>) => createQueryKey('bestContentsList', options);

/**
 * 정책 소식 목록 조회
 *
 * 정책 소식 목록을 조회합니다
 */
export const bestContentsListOptions = (options: Options<BestContentsListData>) => queryOptions<BestContentsListResponse, BestContentsListError, BestContentsListResponse, ReturnType<typeof bestContentsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await bestContentsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bestContentsListQueryKey(options)
});
export const bestContentsListInfiniteQueryKey = (options: Options<BestContentsListData>): QueryKey<Options<BestContentsListData>> => createQueryKey('bestContentsList', options, true);

/**
 * 정책 소식 목록 조회
 *
 * 정책 소식 목록을 조회합니다
 */
export const bestContentsListInfiniteOptions = (options: Options<BestContentsListData>) => infiniteQueryOptions<BestContentsListResponse, BestContentsListError, InfiniteData<BestContentsListResponse>, QueryKey<Options<BestContentsListData>>, number | Pick<QueryKey<Options<BestContentsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<BestContentsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await bestContentsList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bestContentsListInfiniteQueryKey(options)
});
export const bestContentsQueryKey = (options: Options<BestContentsData>) => createQueryKey('bestContents', options);

/**
 * 정책 소식 상세 조회
 *
 * 정책 소식 상세 정보를 조회합니다
 */
export const bestContentsOptions = (options: Options<BestContentsData>) => queryOptions<BestContentsResponse, BestContentsError, BestContentsResponse, ReturnType<typeof bestContentsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await bestContents({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bestContentsQueryKey(options)
});
export const getPopularBestContentsListQueryKey = (options?: Options<GetPopularBestContentsListData>) => createQueryKey('getPopularBestContentsList', options);

/**
 * 인기 정책 소식 목록 조회
 */
export const getPopularBestContentsListOptions = (options?: Options<GetPopularBestContentsListData>) => queryOptions<GetPopularBestContentsListResponse, GetPopularBestContentsListError, GetPopularBestContentsListResponse, ReturnType<typeof getPopularBestContentsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getPopularBestContentsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPopularBestContentsListQueryKey(options)
});
export const getNewBestContentsListQueryKey = (options?: Options<GetNewBestContentsListData>) => createQueryKey('getNewBestContentsList', options);

/**
 * 신규 정책 소식 목록 조회
 */
export const getNewBestContentsListOptions = (options?: Options<GetNewBestContentsListData>) => queryOptions<GetNewBestContentsListResponse, GetNewBestContentsListError, GetNewBestContentsListResponse, ReturnType<typeof getNewBestContentsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getNewBestContentsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getNewBestContentsListQueryKey(options)
});
export const getCommunityWelloNewsListQueryKey = (options: Options<GetCommunityWelloNewsListData>) => createQueryKey('getCommunityWelloNewsList', options);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListOptions = (options: Options<GetCommunityWelloNewsListData>) => queryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, ReturnType<typeof getCommunityWelloNewsListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getCommunityWelloNewsList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommunityWelloNewsListQueryKey(options)
});
export const getCommunityWelloNewsListInfiniteQueryKey = (options: Options<GetCommunityWelloNewsListData>): QueryKey<Options<GetCommunityWelloNewsListData>> => createQueryKey('getCommunityWelloNewsList', options, true);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListInfiniteOptions = (options: Options<GetCommunityWelloNewsListData>) => infiniteQueryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, InfiniteData<GetCommunityWelloNewsListResponse>, QueryKey<Options<GetCommunityWelloNewsListData>>, number | Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getCommunityWelloNewsList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommunityWelloNewsListInfiniteQueryKey(options)
});
export const getCommunityWelloNewsQueryKey = (options: Options<GetCommunityWelloNewsData>) => createQueryKey('getCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 뉴스 상세
 */
export const getCommunityWelloNewsOptions = (options: Options<GetCommunityWelloNewsData>) => queryOptions<GetCommunityWelloNewsResponse, GetCommunityWelloNewsError, GetCommunityWelloNewsResponse, ReturnType<typeof getCommunityWelloNewsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getCommunityWelloNews({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommunityWelloNewsQueryKey(options)
});
export const feedbackCommunityWelloNewsQueryKey = (options: Options<FeedbackCommunityWelloNewsData>) => createQueryKey('feedbackCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNewsOptions = (options: Options<FeedbackCommunityWelloNewsData>) => queryOptions<FeedbackCommunityWelloNewsResponse, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, ReturnType<typeof feedbackCommunityWelloNewsQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await feedbackCommunityWelloNews({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: feedbackCommunityWelloNewsQueryKey(options)
});
export const getMyCommunityListQueryKey = (options: Options<GetMyCommunityListData>) => createQueryKey('getMyCommunityList', options);

/**
 * 내가 작성한 커뮤니티 글
 */
export const getMyCommunityListOptions = (options: Options<GetMyCommunityListData>) => queryOptions<GetMyCommunityListResponse, GetMyCommunityListError, GetMyCommunityListResponse, ReturnType<typeof getMyCommunityListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyCommunityList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyCommunityListQueryKey(options)
});
export const getMyCommunityListInfiniteQueryKey = (options: Options<GetMyCommunityListData>): QueryKey<Options<GetMyCommunityListData>> => createQueryKey('getMyCommunityList', options, true);

/**
 * 내가 작성한 커뮤니티 글
 */
export const getMyCommunityListInfiniteOptions = (options: Options<GetMyCommunityListData>) => infiniteQueryOptions<GetMyCommunityListResponse, GetMyCommunityListError, InfiniteData<GetMyCommunityListResponse>, QueryKey<Options<GetMyCommunityListData>>, number | Pick<QueryKey<Options<GetMyCommunityListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
  queryFn: async ({
    pageParam,
    queryKey,
    signal
  }) => {
    // @ts-ignore
    const page: Pick<QueryKey<Options<GetMyCommunityListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
      query: {
        page: pageParam
      }
    };
    const params = createInfiniteParams(queryKey, page);
    const {
      data
    } = await getMyCommunityList({
      ...options,
      ...params,
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyCommunityListInfiniteQueryKey(options)
});
export const getMyCommunityTypeListQueryKey = (options?: Options<GetMyCommunityTypeListData>) => createQueryKey('getMyCommunityTypeList', options);

/**
 * 내가 작성한 커뮤니티 글 유형
 */
export const getMyCommunityTypeListOptions = (options?: Options<GetMyCommunityTypeListData>) => queryOptions<GetMyCommunityTypeListResponse, GetMyCommunityTypeListError, GetMyCommunityTypeListResponse, ReturnType<typeof getMyCommunityTypeListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getMyCommunityTypeList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMyCommunityTypeListQueryKey(options)
});
export const getLatestCommunityListQueryKey = (options?: Options<GetLatestCommunityListData>) => createQueryKey('getLatestCommunityList', options);

/**
 * 커뮤니티 최신글
 */
export const getLatestCommunityListOptions = (options?: Options<GetLatestCommunityListData>) => queryOptions<GetLatestCommunityListResponse, GetLatestCommunityListError, GetLatestCommunityListResponse, ReturnType<typeof getLatestCommunityListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getLatestCommunityList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLatestCommunityListQueryKey(options)
});
export const getBenefitNotificationTermServiceUrlQueryKey = (options: Options<GetBenefitNotificationTermServiceUrlData>) => createQueryKey('getBenefitNotificationTermServiceUrl', options);

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 이용 약관 화면
 */
export const getBenefitNotificationTermServiceUrlOptions = (options: Options<GetBenefitNotificationTermServiceUrlData>) => queryOptions<GetBenefitNotificationTermServiceUrlResponse, GetBenefitNotificationTermServiceUrlError, GetBenefitNotificationTermServiceUrlResponse, ReturnType<typeof getBenefitNotificationTermServiceUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationTermServiceUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationTermServiceUrlQueryKey(options)
});
export const getBenefitNotificationSituationManagementUrlQueryKey = (options: Options<GetBenefitNotificationSituationManagementUrlData>) => createQueryKey('getBenefitNotificationSituationManagementUrl', options);

/**
 * 혜택알리미 - 13. 상황 인지데이터 화면 URL 조회(현재 상황 설정 화면 url)
 */
export const getBenefitNotificationSituationManagementUrlOptions = (options: Options<GetBenefitNotificationSituationManagementUrlData>) => queryOptions<GetBenefitNotificationSituationManagementUrlResponse, GetBenefitNotificationSituationManagementUrlError, GetBenefitNotificationSituationManagementUrlResponse, ReturnType<typeof getBenefitNotificationSituationManagementUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationSituationManagementUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationSituationManagementUrlQueryKey(options)
});
export const getBenefitNotificationServiceUsageAgreementUrlQueryKey = (options: Options<GetBenefitNotificationServiceUsageAgreementUrlData>) => createQueryKey('getBenefitNotificationServiceUsageAgreementUrl', options);

/**
 * 혜택 알리미 - 1. 서비스 이용 동의 화면 URL 조회
 */
export const getBenefitNotificationServiceUsageAgreementUrlOptions = (options: Options<GetBenefitNotificationServiceUsageAgreementUrlData>) => queryOptions<GetBenefitNotificationServiceUsageAgreementUrlResponse, GetBenefitNotificationServiceUsageAgreementUrlError, GetBenefitNotificationServiceUsageAgreementUrlResponse, ReturnType<typeof getBenefitNotificationServiceUsageAgreementUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationServiceUsageAgreementUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationServiceUsageAgreementUrlQueryKey(options)
});
export const getBenefitNotificationServiceUsageAgreementManagementUrlQueryKey = (options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlData>) => createQueryKey('getBenefitNotificationServiceUsageAgreementManagementUrl', options);

/**
 * 혜택알리미 - 16. 서비스 이용 동의 관리 화면 URL 조회 (서비스 이용동의/철회)
 */
export const getBenefitNotificationServiceUsageAgreementManagementUrlOptions = (options: Options<GetBenefitNotificationServiceUsageAgreementManagementUrlData>) => queryOptions<GetBenefitNotificationServiceUsageAgreementManagementUrlResponse, GetBenefitNotificationServiceUsageAgreementManagementUrlError, GetBenefitNotificationServiceUsageAgreementManagementUrlResponse, ReturnType<typeof getBenefitNotificationServiceUsageAgreementManagementUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationServiceUsageAgreementManagementUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationServiceUsageAgreementManagementUrlQueryKey(options)
});
export const getBenefitNotificationPublicServiceDetailUrlQueryKey = (options: Options<GetBenefitNotificationPublicServiceDetailUrlData>) => createQueryKey('getBenefitNotificationPublicServiceDetailUrl', options);

/**
 * 혜택 알리미 - 공공서비스 상세 화면 URL 조회
 */
export const getBenefitNotificationPublicServiceDetailUrlOptions = (options: Options<GetBenefitNotificationPublicServiceDetailUrlData>) => queryOptions<GetBenefitNotificationPublicServiceDetailUrlResponse, GetBenefitNotificationPublicServiceDetailUrlError, GetBenefitNotificationPublicServiceDetailUrlResponse, ReturnType<typeof getBenefitNotificationPublicServiceDetailUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationPublicServiceDetailUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationPublicServiceDetailUrlQueryKey(options)
});
export const getBenefitNotificationPrivacyUsageUrlQueryKey = (options: Options<GetBenefitNotificationPrivacyUsageUrlData>) => createQueryKey('getBenefitNotificationPrivacyUsageUrl', options);

/**
 * 혜택알리미 - 17. 개인정보 활용이력 화면 URL 조회
 */
export const getBenefitNotificationPrivacyUsageUrlOptions = (options: Options<GetBenefitNotificationPrivacyUsageUrlData>) => queryOptions<GetBenefitNotificationPrivacyUsageUrlResponse, GetBenefitNotificationPrivacyUsageUrlError, GetBenefitNotificationPrivacyUsageUrlResponse, ReturnType<typeof getBenefitNotificationPrivacyUsageUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationPrivacyUsageUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationPrivacyUsageUrlQueryKey(options)
});
export const getBenefitNotificationPrivatePolicyUrlQueryKey = (options: Options<GetBenefitNotificationPrivatePolicyUrlData>) => createQueryKey('getBenefitNotificationPrivatePolicyUrl', options);

/**
 * 혜택알리미 - 3. 혜택알리미 안내 화면 URL 조회 - 개인정보 처리방침
 */
export const getBenefitNotificationPrivatePolicyUrlOptions = (options: Options<GetBenefitNotificationPrivatePolicyUrlData>) => queryOptions<GetBenefitNotificationPrivatePolicyUrlResponse, GetBenefitNotificationPrivatePolicyUrlError, GetBenefitNotificationPrivatePolicyUrlResponse, ReturnType<typeof getBenefitNotificationPrivatePolicyUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationPrivatePolicyUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationPrivatePolicyUrlQueryKey(options)
});
export const getBenefitNotificationMainInfoQueryKey = (options?: Options<GetBenefitNotificationMainInfoData>) => createQueryKey('getBenefitNotificationMainInfo', options);

/**
 * 혜택 알리미 - 2. 혜택알리미 메인 정보 조회
 */
export const getBenefitNotificationMainInfoOptions = (options?: Options<GetBenefitNotificationMainInfoData>) => queryOptions<GetBenefitNotificationMainInfoResponse, GetBenefitNotificationMainInfoError, GetBenefitNotificationMainInfoResponse, ReturnType<typeof getBenefitNotificationMainInfoQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationMainInfo({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationMainInfoQueryKey(options)
});
export const getBenefitNotificationFitAnalysisQueryKey = (options?: Options<GetBenefitNotificationFitAnalysisData>) => createQueryKey('getBenefitNotificationFitAnalysis', options);

/**
 * 혜택 알리미 - 6. 맞춤 분석 요청
 */
export const getBenefitNotificationFitAnalysisOptions = (options?: Options<GetBenefitNotificationFitAnalysisData>) => queryOptions<GetBenefitNotificationFitAnalysisResponse, GetBenefitNotificationFitAnalysisError, GetBenefitNotificationFitAnalysisResponse, ReturnType<typeof getBenefitNotificationFitAnalysisQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationFitAnalysis({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationFitAnalysisQueryKey(options)
});
export const getBenefitNotificationFitAnalysisResultQueryKey = (options?: Options<GetBenefitNotificationFitAnalysisResultData>) => createQueryKey('getBenefitNotificationFitAnalysisResult', options);

/**
 * 혜택 알리미 - 맞춤 맞춤분석 요청 및 결과 조회
 */
export const getBenefitNotificationFitAnalysisResultOptions = (options?: Options<GetBenefitNotificationFitAnalysisResultData>) => queryOptions<GetBenefitNotificationFitAnalysisResultResponse, GetBenefitNotificationFitAnalysisResultError, GetBenefitNotificationFitAnalysisResultResponse, ReturnType<typeof getBenefitNotificationFitAnalysisResultQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationFitAnalysisResult({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationFitAnalysisResultQueryKey(options)
});
export const getBenefitNotificationApplicationResultsUrlQueryKey = (options: Options<GetBenefitNotificationApplicationResultsUrlData>) => createQueryKey('getBenefitNotificationApplicationResultsUrl', options);

/**
 * 혜택 알리미 - 신청 결과 목록 화면 URL 조회
 */
export const getBenefitNotificationApplicationResultsUrlOptions = (options: Options<GetBenefitNotificationApplicationResultsUrlData>) => queryOptions<GetBenefitNotificationApplicationResultsUrlResponse, GetBenefitNotificationApplicationResultsUrlError, GetBenefitNotificationApplicationResultsUrlResponse, ReturnType<typeof getBenefitNotificationApplicationResultsUrlQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getBenefitNotificationApplicationResultsUrl({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBenefitNotificationApplicationResultsUrlQueryKey(options)
});
export const bannerListQueryKey = (options: Options<BannerListData>) => createQueryKey('bannerList', options);

/**
 * 배너 목록 조회
 *
 * 배너 목록을 조회합니다
 */
export const bannerListOptions = (options: Options<BannerListData>) => queryOptions<BannerListResponse, BannerListError, BannerListResponse, ReturnType<typeof bannerListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await bannerList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: bannerListQueryKey(options)
});
export const getWelloApplyPolicyListQueryKey = (options?: Options<GetWelloApplyPolicyListData>) => createQueryKey('getWelloApplyPolicyList', options);

/**
 * 신청한 바로신청 목록 조회
 */
export const getWelloApplyPolicyListOptions = (options?: Options<GetWelloApplyPolicyListData>) => queryOptions<GetWelloApplyPolicyListResponse, GetWelloApplyPolicyListError, GetWelloApplyPolicyListResponse, ReturnType<typeof getWelloApplyPolicyListQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await getWelloApplyPolicyList({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWelloApplyPolicyListQueryKey(options)
});
export const findArticleFeedbackQueryKey = (options: Options<FindArticleFeedbackData>) => createQueryKey('findArticleFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedbackOptions = (options: Options<FindArticleFeedbackData>) => queryOptions<FindArticleFeedbackResponse, FindArticleFeedbackError, FindArticleFeedbackResponse, ReturnType<typeof findArticleFeedbackQueryKey>>({
  queryFn: async ({
    queryKey,
    signal
  }) => {
    const {
      data
    } = await findArticleFeedback({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: findArticleFeedbackQueryKey(options)
});

/**
 * 웰로 사용자 차단 해제 - 삭제
 */
export const deleteMemberWelloBlockMutation = (options?: Partial<Options<DeleteMemberWelloBlockData>>): UseMutationOptions<DeleteMemberWelloBlockResponse, DeleteMemberWelloBlockError, Options<DeleteMemberWelloBlockData>> => {
  const mutationOptions: UseMutationOptions<DeleteMemberWelloBlockResponse, DeleteMemberWelloBlockError, Options<DeleteMemberWelloBlockData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteMemberWelloBlock({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 상품 문의 삭제
 *
 * 상품 문의 삭제
 */
export const deleteInquiryMutation = (options?: Partial<Options<DeleteInquiryData>>): UseMutationOptions<DeleteInquiryResponse, DeleteInquiryError, Options<DeleteInquiryData>> => {
  const mutationOptions: UseMutationOptions<DeleteInquiryResponse, DeleteInquiryError, Options<DeleteInquiryData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteInquiry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 장바구니 단건 삭제
 *
 * 장바구니 아이템 단건 삭제.
 */
export const deleteCartItemMutation = (options?: Partial<Options<DeleteCartItemData>>): UseMutationOptions<DeleteCartItemResponse, DeleteCartItemError, Options<DeleteCartItemData>> => {
  const mutationOptions: UseMutationOptions<DeleteCartItemResponse, DeleteCartItemError, Options<DeleteCartItemData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteCartItem({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * 웰로멤버 가족 프로필 삭제
 *
 * 웰로멤버 삭제요청을 처리합니다
 */
export const deleteWelloMemberFamilyMutation = (options?: Partial<Options<DeleteWelloMemberFamilyData>>): UseMutationOptions<DeleteWelloMemberFamilyResponse, DeleteWelloMemberFamilyError, Options<DeleteWelloMemberFamilyData>> => {
  const mutationOptions: UseMutationOptions<DeleteWelloMemberFamilyResponse, DeleteWelloMemberFamilyError, Options<DeleteWelloMemberFamilyData>> = {
    mutationFn: async fnOptions => {
      const {
        data
      } = await deleteWelloMemberFamily({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};